import { hasInjectionContext as Vr, inject as K, effectScope as Cr, ref as B, markRaw as Ue, toRaw as Tt, watch as tn, unref as j, getCurrentInstance as No, reactive as _o, isRef as kt, isReactive as ss, toRef as En, nextTick as Os, computed as Ae, getCurrentScope as Do, onScopeDispose as xo, toRefs as Es, openBlock as S, createElementBlock as E, normalizeClass as He, createElementVNode as D, renderSlot as W, provide as We, Fragment as be, renderList as lt, toDisplayString as me, createCommentVNode as Se, mergeModels as Fe, useModel as It, withDirectives as Te, vModelDynamic as Io, resolveDirective as Vo, normalizeProps as ue, guardReactiveProps as ge, createTextVNode as ut, createBlock as we, resolveDynamicComponent as jt, mergeProps as Nt, toHandlers as Co, vShow as Ts, createVNode as U, Transition as Ao, withCtx as Ee, withModifiers as Ln, vModelSelect as Pn, vModelText as Ar, onMounted as Fr } from "vue";
var Mr = !1;
function $t(t, e, n) {
  return Array.isArray(t) ? (t.length = Math.max(t.length, e), t.splice(e, 1, n), n) : (t[e] = n, n);
}
function Tn(t, e) {
  if (Array.isArray(t)) {
    t.splice(e, 1);
    return;
  }
  delete t[e];
}
function Fo() {
  return Rr().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function Rr() {
  return typeof navigator < "u" && typeof window < "u" ? window : typeof globalThis < "u" ? globalThis : {};
}
const Mo = typeof Proxy == "function", Ro = "devtools-plugin:setup", $o = "plugin:settings:set";
let Ge, Un;
function Lo() {
  var t;
  return Ge !== void 0 || (typeof window < "u" && window.performance ? (Ge = !0, Un = window.performance) : typeof globalThis < "u" && (!((t = globalThis.perf_hooks) === null || t === void 0) && t.performance) ? (Ge = !0, Un = globalThis.perf_hooks.performance) : Ge = !1), Ge;
}
function Po() {
  return Lo() ? Un.now() : Date.now();
}
class Uo {
  constructor(e, n) {
    this.target = null, this.targetQueue = [], this.onQueue = [], this.plugin = e, this.hook = n;
    const s = {};
    if (e.settings)
      for (const o in e.settings) {
        const a = e.settings[o];
        s[o] = a.defaultValue;
      }
    const r = `__vue-devtools-plugin-settings__${e.id}`;
    let i = Object.assign({}, s);
    try {
      const o = localStorage.getItem(r), a = JSON.parse(o);
      Object.assign(i, a);
    } catch {
    }
    this.fallbacks = {
      getSettings() {
        return i;
      },
      setSettings(o) {
        try {
          localStorage.setItem(r, JSON.stringify(o));
        } catch {
        }
        i = o;
      },
      now() {
        return Po();
      }
    }, n && n.on($o, (o, a) => {
      o === this.plugin.id && this.fallbacks.setSettings(a);
    }), this.proxiedOn = new Proxy({}, {
      get: (o, a) => this.target ? this.target.on[a] : (...l) => {
        this.onQueue.push({
          method: a,
          args: l
        });
      }
    }), this.proxiedTarget = new Proxy({}, {
      get: (o, a) => this.target ? this.target[a] : a === "on" ? this.proxiedOn : Object.keys(this.fallbacks).includes(a) ? (...l) => (this.targetQueue.push({
        method: a,
        args: l,
        resolve: () => {
        }
      }), this.fallbacks[a](...l)) : (...l) => new Promise((u) => {
        this.targetQueue.push({
          method: a,
          args: l,
          resolve: u
        });
      })
    });
  }
  async setRealTarget(e) {
    this.target = e;
    for (const n of this.onQueue)
      this.target.on[n.method](...n.args);
    for (const n of this.targetQueue)
      n.resolve(await this.target[n.method](...n.args));
  }
}
function $r(t, e) {
  const n = t, s = Rr(), r = Fo(), i = Mo && n.enableEarlyProxy;
  if (r && (s.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !i))
    r.emit(Ro, t, e);
  else {
    const o = i ? new Uo(n, r) : null;
    (s.__VUE_DEVTOOLS_PLUGINS__ = s.__VUE_DEVTOOLS_PLUGINS__ || []).push({
      pluginDescriptor: n,
      setupFn: e,
      proxy: o
    }), o && e(o.proxiedTarget);
  }
}
/*!
 * pinia v2.2.4
 * (c) 2024 Eduardo San Martin Morote
 * @license MIT
 */
let st;
const _t = (t) => st = t, Wo = () => Vr() && K(rs) || st, rs = process.env.NODE_ENV !== "production" ? Symbol("pinia") : (
  /* istanbul ignore next */
  Symbol()
);
function Ze(t) {
  return t && typeof t == "object" && Object.prototype.toString.call(t) === "[object Object]" && typeof t.toJSON != "function";
}
var ve;
(function(t) {
  t.direct = "direct", t.patchObject = "patch object", t.patchFunction = "patch function";
})(ve || (ve = {}));
const qe = typeof window < "u", ks = typeof window == "object" && window.window === window ? window : typeof self == "object" && self.self === self ? self : typeof global == "object" && global.global === global ? global : typeof globalThis == "object" ? globalThis : { HTMLElement: null };
function qo(t, { autoBom: e = !1 } = {}) {
  return e && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(t.type) ? new Blob(["\uFEFF", t], { type: t.type }) : t;
}
function is(t, e, n) {
  const s = new XMLHttpRequest();
  s.open("GET", t), s.responseType = "blob", s.onload = function() {
    Ur(s.response, e, n);
  }, s.onerror = function() {
    console.error("could not download file");
  }, s.send();
}
function Lr(t) {
  const e = new XMLHttpRequest();
  e.open("HEAD", t, !1);
  try {
    e.send();
  } catch {
  }
  return e.status >= 200 && e.status <= 299;
}
function zt(t) {
  try {
    t.dispatchEvent(new MouseEvent("click"));
  } catch {
    const n = document.createEvent("MouseEvents");
    n.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), t.dispatchEvent(n);
  }
}
const Ht = typeof navigator == "object" ? navigator : { userAgent: "" }, Pr = /Macintosh/.test(Ht.userAgent) && /AppleWebKit/.test(Ht.userAgent) && !/Safari/.test(Ht.userAgent), Ur = qe ? (
  // Use download attribute first if possible (#193 Lumia mobile) unless this is a macOS WebView or mini program
  typeof HTMLAnchorElement < "u" && "download" in HTMLAnchorElement.prototype && !Pr ? Bo : (
    // Use msSaveOrOpenBlob as a second approach
    "msSaveOrOpenBlob" in Ht ? jo : (
      // Fallback to using FileReader and a popup
      zo
    )
  )
) : () => {
};
function Bo(t, e = "download", n) {
  const s = document.createElement("a");
  s.download = e, s.rel = "noopener", typeof t == "string" ? (s.href = t, s.origin !== location.origin ? Lr(s.href) ? is(t, e, n) : (s.target = "_blank", zt(s)) : zt(s)) : (s.href = URL.createObjectURL(t), setTimeout(function() {
    URL.revokeObjectURL(s.href);
  }, 4e4), setTimeout(function() {
    zt(s);
  }, 0));
}
function jo(t, e = "download", n) {
  if (typeof t == "string")
    if (Lr(t))
      is(t, e, n);
    else {
      const s = document.createElement("a");
      s.href = t, s.target = "_blank", setTimeout(function() {
        zt(s);
      });
    }
  else
    navigator.msSaveOrOpenBlob(qo(t, n), e);
}
function zo(t, e, n, s) {
  if (s = s || open("", "_blank"), s && (s.document.title = s.document.body.innerText = "downloading..."), typeof t == "string")
    return is(t, e, n);
  const r = t.type === "application/octet-stream", i = /constructor/i.test(String(ks.HTMLElement)) || "safari" in ks, o = /CriOS\/[\d]+/.test(navigator.userAgent);
  if ((o || r && i || Pr) && typeof FileReader < "u") {
    const a = new FileReader();
    a.onloadend = function() {
      let l = a.result;
      if (typeof l != "string")
        throw s = null, new Error("Wrong reader.result type");
      l = o ? l : l.replace(/^data:[^;]*;/, "data:attachment/file;"), s ? s.location.href = l : location.assign(l), s = null;
    }, a.readAsDataURL(t);
  } else {
    const a = URL.createObjectURL(t);
    s ? s.location.assign(a) : location.href = a, s = null, setTimeout(function() {
      URL.revokeObjectURL(a);
    }, 4e4);
  }
}
function z(t, e) {
  const n = "🍍 " + t;
  typeof __VUE_DEVTOOLS_TOAST__ == "function" ? __VUE_DEVTOOLS_TOAST__(n, e) : e === "error" ? console.error(n) : e === "warn" ? console.warn(n) : console.log(n);
}
function os(t) {
  return "_a" in t && "install" in t;
}
function Wr() {
  if (!("clipboard" in navigator))
    return z("Your browser doesn't support the Clipboard API", "error"), !0;
}
function qr(t) {
  return t instanceof Error && t.message.toLowerCase().includes("document is not focused") ? (z('You need to activate the "Emulate a focused page" setting in the "Rendering" panel of devtools.', "warn"), !0) : !1;
}
async function Ho(t) {
  if (!Wr())
    try {
      await navigator.clipboard.writeText(JSON.stringify(t.state.value)), z("Global state copied to clipboard.");
    } catch (e) {
      if (qr(e))
        return;
      z("Failed to serialize the state. Check the console for more details.", "error"), console.error(e);
    }
}
async function Zo(t) {
  if (!Wr())
    try {
      Br(t, JSON.parse(await navigator.clipboard.readText())), z("Global state pasted from clipboard.");
    } catch (e) {
      if (qr(e))
        return;
      z("Failed to deserialize the state from clipboard. Check the console for more details.", "error"), console.error(e);
    }
}
async function Jo(t) {
  try {
    Ur(new Blob([JSON.stringify(t.state.value)], {
      type: "text/plain;charset=utf-8"
    }), "pinia-state.json");
  } catch (e) {
    z("Failed to export the state as JSON. Check the console for more details.", "error"), console.error(e);
  }
}
let Oe;
function Yo() {
  Oe || (Oe = document.createElement("input"), Oe.type = "file", Oe.accept = ".json");
  function t() {
    return new Promise((e, n) => {
      Oe.onchange = async () => {
        const s = Oe.files;
        if (!s)
          return e(null);
        const r = s.item(0);
        return e(r ? { text: await r.text(), file: r } : null);
      }, Oe.oncancel = () => e(null), Oe.onerror = n, Oe.click();
    });
  }
  return t;
}
async function Go(t) {
  try {
    const n = await Yo()();
    if (!n)
      return;
    const { text: s, file: r } = n;
    Br(t, JSON.parse(s)), z(`Global state imported from "${r.name}".`);
  } catch (e) {
    z("Failed to import the state from JSON. Check the console for more details.", "error"), console.error(e);
  }
}
function Br(t, e) {
  for (const n in e) {
    const s = t.state.value[n];
    s ? Object.assign(s, e[n]) : t.state.value[n] = e[n];
  }
}
function fe(t) {
  return {
    _custom: {
      display: t
    }
  };
}
const jr = "🍍 Pinia (root)", Zt = "_root";
function Ko(t) {
  return os(t) ? {
    id: Zt,
    label: jr
  } : {
    id: t.$id,
    label: t.$id
  };
}
function Qo(t) {
  if (os(t)) {
    const n = Array.from(t._s.keys()), s = t._s;
    return {
      state: n.map((i) => ({
        editable: !0,
        key: i,
        value: t.state.value[i]
      })),
      getters: n.filter((i) => s.get(i)._getters).map((i) => {
        const o = s.get(i);
        return {
          editable: !1,
          key: i,
          value: o._getters.reduce((a, l) => (a[l] = o[l], a), {})
        };
      })
    };
  }
  const e = {
    state: Object.keys(t.$state).map((n) => ({
      editable: !0,
      key: n,
      value: t.$state[n]
    }))
  };
  return t._getters && t._getters.length && (e.getters = t._getters.map((n) => ({
    editable: !1,
    key: n,
    value: t[n]
  }))), t._customProperties.size && (e.customProperties = Array.from(t._customProperties).map((n) => ({
    editable: !0,
    key: n,
    value: t[n]
  }))), e;
}
function Xo(t) {
  return t ? Array.isArray(t) ? t.reduce((e, n) => (e.keys.push(n.key), e.operations.push(n.type), e.oldValue[n.key] = n.oldValue, e.newValue[n.key] = n.newValue, e), {
    oldValue: {},
    keys: [],
    operations: [],
    newValue: {}
  }) : {
    operation: fe(t.type),
    key: fe(t.key),
    oldValue: t.oldValue,
    newValue: t.newValue
  } : {};
}
function ea(t) {
  switch (t) {
    case ve.direct:
      return "mutation";
    case ve.patchFunction:
      return "$patch";
    case ve.patchObject:
      return "$patch";
    default:
      return "unknown";
  }
}
let rt = !0;
const Jt = [], Pe = "pinia:mutations", Z = "pinia", { assign: ta } = Object, nn = (t) => "🍍 " + t;
function na(t, e) {
  $r({
    id: "dev.esm.pinia",
    label: "Pinia 🍍",
    logo: "https://pinia.vuejs.org/logo.svg",
    packageName: "pinia",
    homepage: "https://pinia.vuejs.org",
    componentStateTypes: Jt,
    app: t
  }, (n) => {
    typeof n.now != "function" && z("You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html."), n.addTimelineLayer({
      id: Pe,
      label: "Pinia 🍍",
      color: 15064968
    }), n.addInspector({
      id: Z,
      label: "Pinia 🍍",
      icon: "storage",
      treeFilterPlaceholder: "Search stores",
      actions: [
        {
          icon: "content_copy",
          action: () => {
            Ho(e);
          },
          tooltip: "Serialize and copy the state"
        },
        {
          icon: "content_paste",
          action: async () => {
            await Zo(e), n.sendInspectorTree(Z), n.sendInspectorState(Z);
          },
          tooltip: "Replace the state with the content of your clipboard"
        },
        {
          icon: "save",
          action: () => {
            Jo(e);
          },
          tooltip: "Save the state as a JSON file"
        },
        {
          icon: "folder_open",
          action: async () => {
            await Go(e), n.sendInspectorTree(Z), n.sendInspectorState(Z);
          },
          tooltip: "Import the state from a JSON file"
        }
      ],
      nodeActions: [
        {
          icon: "restore",
          tooltip: 'Reset the state (with "$reset")',
          action: (s) => {
            const r = e._s.get(s);
            r ? typeof r.$reset != "function" ? z(`Cannot reset "${s}" store because it doesn't have a "$reset" method implemented.`, "warn") : (r.$reset(), z(`Store "${s}" reset.`)) : z(`Cannot reset "${s}" store because it wasn't found.`, "warn");
          }
        }
      ]
    }), n.on.inspectComponent((s, r) => {
      const i = s.componentInstance && s.componentInstance.proxy;
      if (i && i._pStores) {
        const o = s.componentInstance.proxy._pStores;
        Object.values(o).forEach((a) => {
          s.instanceData.state.push({
            type: nn(a.$id),
            key: "state",
            editable: !0,
            value: a._isOptionsAPI ? {
              _custom: {
                value: Tt(a.$state),
                actions: [
                  {
                    icon: "restore",
                    tooltip: "Reset the state of this store",
                    action: () => a.$reset()
                  }
                ]
              }
            } : (
              // NOTE: workaround to unwrap transferred refs
              Object.keys(a.$state).reduce((l, u) => (l[u] = a.$state[u], l), {})
            )
          }), a._getters && a._getters.length && s.instanceData.state.push({
            type: nn(a.$id),
            key: "getters",
            editable: !1,
            value: a._getters.reduce((l, u) => {
              try {
                l[u] = a[u];
              } catch (c) {
                l[u] = c;
              }
              return l;
            }, {})
          });
        });
      }
    }), n.on.getInspectorTree((s) => {
      if (s.app === t && s.inspectorId === Z) {
        let r = [e];
        r = r.concat(Array.from(e._s.values())), s.rootNodes = (s.filter ? r.filter((i) => "$id" in i ? i.$id.toLowerCase().includes(s.filter.toLowerCase()) : jr.toLowerCase().includes(s.filter.toLowerCase())) : r).map(Ko);
      }
    }), globalThis.$pinia = e, n.on.getInspectorState((s) => {
      if (s.app === t && s.inspectorId === Z) {
        const r = s.nodeId === Zt ? e : e._s.get(s.nodeId);
        if (!r)
          return;
        r && (s.nodeId !== Zt && (globalThis.$store = Tt(r)), s.state = Qo(r));
      }
    }), n.on.editInspectorState((s, r) => {
      if (s.app === t && s.inspectorId === Z) {
        const i = s.nodeId === Zt ? e : e._s.get(s.nodeId);
        if (!i)
          return z(`store "${s.nodeId}" not found`, "error");
        const { path: o } = s;
        os(i) ? o.unshift("state") : (o.length !== 1 || !i._customProperties.has(o[0]) || o[0] in i.$state) && o.unshift("$state"), rt = !1, s.set(i, o, s.state.value), rt = !0;
      }
    }), n.on.editComponentState((s) => {
      if (s.type.startsWith("🍍")) {
        const r = s.type.replace(/^🍍\s*/, ""), i = e._s.get(r);
        if (!i)
          return z(`store "${r}" not found`, "error");
        const { path: o } = s;
        if (o[0] !== "state")
          return z(`Invalid path for store "${r}":
${o}
Only state can be modified.`);
        o[0] = "$state", rt = !1, s.set(i, o, s.state.value), rt = !0;
      }
    });
  });
}
function sa(t, e) {
  Jt.includes(nn(e.$id)) || Jt.push(nn(e.$id)), $r({
    id: "dev.esm.pinia",
    label: "Pinia 🍍",
    logo: "https://pinia.vuejs.org/logo.svg",
    packageName: "pinia",
    homepage: "https://pinia.vuejs.org",
    componentStateTypes: Jt,
    app: t,
    settings: {
      logStoreChanges: {
        label: "Notify about new/deleted stores",
        type: "boolean",
        defaultValue: !0
      }
      // useEmojis: {
      //   label: 'Use emojis in messages ⚡️',
      //   type: 'boolean',
      //   defaultValue: true,
      // },
    }
  }, (n) => {
    const s = typeof n.now == "function" ? n.now.bind(n) : Date.now;
    e.$onAction(({ after: o, onError: a, name: l, args: u }) => {
      const c = zr++;
      n.addTimelineEvent({
        layerId: Pe,
        event: {
          time: s(),
          title: "🛫 " + l,
          subtitle: "start",
          data: {
            store: fe(e.$id),
            action: fe(l),
            args: u
          },
          groupId: c
        }
      }), o((d) => {
        Ve = void 0, n.addTimelineEvent({
          layerId: Pe,
          event: {
            time: s(),
            title: "🛬 " + l,
            subtitle: "end",
            data: {
              store: fe(e.$id),
              action: fe(l),
              args: u,
              result: d
            },
            groupId: c
          }
        });
      }), a((d) => {
        Ve = void 0, n.addTimelineEvent({
          layerId: Pe,
          event: {
            time: s(),
            logType: "error",
            title: "💥 " + l,
            subtitle: "end",
            data: {
              store: fe(e.$id),
              action: fe(l),
              args: u,
              error: d
            },
            groupId: c
          }
        });
      });
    }, !0), e._customProperties.forEach((o) => {
      tn(() => j(e[o]), (a, l) => {
        n.notifyComponentUpdate(), n.sendInspectorState(Z), rt && n.addTimelineEvent({
          layerId: Pe,
          event: {
            time: s(),
            title: "Change",
            subtitle: o,
            data: {
              newValue: a,
              oldValue: l
            },
            groupId: Ve
          }
        });
      }, { deep: !0 });
    }), e.$subscribe(({ events: o, type: a }, l) => {
      if (n.notifyComponentUpdate(), n.sendInspectorState(Z), !rt)
        return;
      const u = {
        time: s(),
        title: ea(a),
        data: ta({ store: fe(e.$id) }, Xo(o)),
        groupId: Ve
      };
      a === ve.patchFunction ? u.subtitle = "⤵️" : a === ve.patchObject ? u.subtitle = "🧩" : o && !Array.isArray(o) && (u.subtitle = o.type), o && (u.data["rawEvent(s)"] = {
        _custom: {
          display: "DebuggerEvent",
          type: "object",
          tooltip: "raw DebuggerEvent[]",
          value: o
        }
      }), n.addTimelineEvent({
        layerId: Pe,
        event: u
      });
    }, { detached: !0, flush: "sync" });
    const r = e._hotUpdate;
    e._hotUpdate = Ue((o) => {
      r(o), n.addTimelineEvent({
        layerId: Pe,
        event: {
          time: s(),
          title: "🔥 " + e.$id,
          subtitle: "HMR update",
          data: {
            store: fe(e.$id),
            info: fe("HMR update")
          }
        }
      }), n.notifyComponentUpdate(), n.sendInspectorTree(Z), n.sendInspectorState(Z);
    });
    const { $dispose: i } = e;
    e.$dispose = () => {
      i(), n.notifyComponentUpdate(), n.sendInspectorTree(Z), n.sendInspectorState(Z), n.getSettings().logStoreChanges && z(`Disposed "${e.$id}" store 🗑`);
    }, n.notifyComponentUpdate(), n.sendInspectorTree(Z), n.sendInspectorState(Z), n.getSettings().logStoreChanges && z(`"${e.$id}" store installed 🆕`);
  });
}
let zr = 0, Ve;
function Ns(t, e, n) {
  const s = e.reduce((r, i) => (r[i] = Tt(t)[i], r), {});
  for (const r in s)
    t[r] = function() {
      const i = zr, o = n ? new Proxy(t, {
        get(...l) {
          return Ve = i, Reflect.get(...l);
        },
        set(...l) {
          return Ve = i, Reflect.set(...l);
        }
      }) : t;
      Ve = i;
      const a = s[r].apply(o, arguments);
      return Ve = void 0, a;
    };
}
function ra({ app: t, store: e, options: n }) {
  if (!e.$id.startsWith("__hot:")) {
    if (e._isOptionsAPI = !!n.state, !e._p._testing) {
      Ns(e, Object.keys(n.actions), e._isOptionsAPI);
      const s = e._hotUpdate;
      Tt(e)._hotUpdate = function(r) {
        s.apply(this, arguments), Ns(e, Object.keys(r._hmrPayload.actions), !!e._isOptionsAPI);
      };
    }
    sa(
      t,
      // FIXME: is there a way to allow the assignment from Store<Id, S, G, A> to StoreGeneric?
      e
    );
  }
}
function ia() {
  const t = Cr(!0), e = t.run(() => B({}));
  let n = [], s = [];
  const r = Ue({
    install(i) {
      _t(r), r._a = i, i.provide(rs, r), i.config.globalProperties.$pinia = r, process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && qe && na(i, r), s.forEach((o) => n.push(o)), s = [];
    },
    use(i) {
      return !this._a && !Mr ? s.push(i) : n.push(i), this;
    },
    _p: n,
    // it's actually undefined here
    // @ts-expect-error
    _a: null,
    _e: t,
    _s: /* @__PURE__ */ new Map(),
    state: e
  });
  return process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && typeof Proxy < "u" && r.use(ra), r;
}
function Hr(t, e) {
  for (const n in e) {
    const s = e[n];
    if (!(n in t))
      continue;
    const r = t[n];
    Ze(r) && Ze(s) && !kt(s) && !ss(s) ? t[n] = Hr(r, s) : t[n] = s;
  }
  return t;
}
const Zr = () => {
};
function _s(t, e, n, s = Zr) {
  t.push(e);
  const r = () => {
    const i = t.indexOf(e);
    i > -1 && (t.splice(i, 1), s());
  };
  return !n && Do() && xo(r), r;
}
function Ke(t, ...e) {
  t.slice().forEach((n) => {
    n(...e);
  });
}
const oa = (t) => t(), Ds = Symbol(), kn = Symbol();
function Wn(t, e) {
  t instanceof Map && e instanceof Map ? e.forEach((n, s) => t.set(s, n)) : t instanceof Set && e instanceof Set && e.forEach(t.add, t);
  for (const n in e) {
    if (!e.hasOwnProperty(n))
      continue;
    const s = e[n], r = t[n];
    Ze(r) && Ze(s) && t.hasOwnProperty(n) && !kt(s) && !ss(s) ? t[n] = Wn(r, s) : t[n] = s;
  }
  return t;
}
const aa = process.env.NODE_ENV !== "production" ? Symbol("pinia:skipHydration") : (
  /* istanbul ignore next */
  Symbol()
);
function la(t) {
  return !Ze(t) || !t.hasOwnProperty(aa);
}
const { assign: oe } = Object;
function xs(t) {
  return !!(kt(t) && t.effect);
}
function Is(t, e, n, s) {
  const { state: r, actions: i, getters: o } = e, a = n.state.value[t];
  let l;
  function u() {
    !a && (process.env.NODE_ENV === "production" || !s) && (n.state.value[t] = r ? r() : {});
    const c = process.env.NODE_ENV !== "production" && s ? (
      // use ref() to unwrap refs inside state TODO: check if this is still necessary
      Es(B(r ? r() : {}).value)
    ) : Es(n.state.value[t]);
    return oe(c, i, Object.keys(o || {}).reduce((d, m) => (process.env.NODE_ENV !== "production" && m in c && console.warn(`[🍍]: A getter cannot have the same name as another state property. Rename one of them. Found with "${m}" in store "${t}".`), d[m] = Ue(Ae(() => {
      _t(n);
      const h = n._s.get(t);
      return o[m].call(h, h);
    })), d), {}));
  }
  return l = qn(t, u, e, n, s, !0), l;
}
function qn(t, e, n = {}, s, r, i) {
  let o;
  const a = oe({ actions: {} }, n);
  if (process.env.NODE_ENV !== "production" && !s._e.active)
    throw new Error("Pinia destroyed");
  const l = { deep: !0 };
  process.env.NODE_ENV !== "production" && !Mr && (l.onTrigger = (w) => {
    u ? h = w : u == !1 && !O._hotUpdating && (Array.isArray(h) ? h.push(w) : console.error("🍍 debuggerEvents should be an array. This is most likely an internal Pinia bug."));
  });
  let u, c, d = [], m = [], h;
  const p = s.state.value[t];
  !i && !p && (process.env.NODE_ENV === "production" || !r) && (s.state.value[t] = {});
  const v = B({});
  let g;
  function I(w) {
    let b;
    u = c = !1, process.env.NODE_ENV !== "production" && (h = []), typeof w == "function" ? (w(s.state.value[t]), b = {
      type: ve.patchFunction,
      storeId: t,
      events: h
    }) : (Wn(s.state.value[t], w), b = {
      type: ve.patchObject,
      payload: w,
      storeId: t,
      events: h
    });
    const M = g = Symbol();
    Os().then(() => {
      g === M && (u = !0);
    }), c = !0, Ke(d, b, s.state.value[t]);
  }
  const T = i ? function() {
    const { state: b } = n, M = b ? b() : {};
    this.$patch((se) => {
      oe(se, M);
    });
  } : (
    /* istanbul ignore next */
    process.env.NODE_ENV !== "production" ? () => {
      throw new Error(`🍍: Store "${t}" is built using the setup syntax and does not implement $reset().`);
    } : Zr
  );
  function x() {
    o.stop(), d = [], m = [], s._s.delete(t);
  }
  const $ = (w, b = "") => {
    if (Ds in w)
      return w[kn] = b, w;
    const M = function() {
      _t(s);
      const se = Array.from(arguments), gt = [], On = [];
      function To(re) {
        gt.push(re);
      }
      function ko(re) {
        On.push(re);
      }
      Ke(m, {
        args: se,
        name: M[kn],
        store: O,
        after: To,
        onError: ko
      });
      let bt;
      try {
        bt = w.apply(this && this.$id === t ? this : O, se);
      } catch (re) {
        throw Ke(On, re), re;
      }
      return bt instanceof Promise ? bt.then((re) => (Ke(gt, re), re)).catch((re) => (Ke(On, re), Promise.reject(re))) : (Ke(gt, bt), bt);
    };
    return M[Ds] = !0, M[kn] = b, M;
  }, F = /* @__PURE__ */ Ue({
    actions: {},
    getters: {},
    state: [],
    hotState: v
  }), ee = {
    _p: s,
    // _s: scope,
    $id: t,
    $onAction: _s.bind(null, m),
    $patch: I,
    $reset: T,
    $subscribe(w, b = {}) {
      const M = _s(d, w, b.detached, () => se()), se = o.run(() => tn(() => s.state.value[t], (gt) => {
        (b.flush === "sync" ? c : u) && w({
          storeId: t,
          type: ve.direct,
          events: h
        }, gt);
      }, oe({}, l, b)));
      return M;
    },
    $dispose: x
  }, O = _o(process.env.NODE_ENV !== "production" || process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && qe ? oe(
    {
      _hmrPayload: F,
      _customProperties: Ue(/* @__PURE__ */ new Set())
      // devtools custom properties
    },
    ee
    // must be added later
    // setupStore
  ) : ee);
  s._s.set(t, O);
  const H = (s._a && s._a.runWithContext || oa)(() => s._e.run(() => (o = Cr()).run(() => e({ action: $ }))));
  for (const w in H) {
    const b = H[w];
    if (kt(b) && !xs(b) || ss(b))
      process.env.NODE_ENV !== "production" && r ? $t(v.value, w, En(H, w)) : i || (p && la(b) && (kt(b) ? b.value = p[w] : Wn(b, p[w])), s.state.value[t][w] = b), process.env.NODE_ENV !== "production" && F.state.push(w);
    else if (typeof b == "function") {
      const M = process.env.NODE_ENV !== "production" && r ? b : $(b, w);
      H[w] = M, process.env.NODE_ENV !== "production" && (F.actions[w] = b), a.actions[w] = b;
    } else process.env.NODE_ENV !== "production" && xs(b) && (F.getters[w] = i ? (
      // @ts-expect-error
      n.getters[w]
    ) : b, qe && (H._getters || // @ts-expect-error: same
    (H._getters = Ue([]))).push(w));
  }
  if (oe(O, H), oe(Tt(O), H), Object.defineProperty(O, "$state", {
    get: () => process.env.NODE_ENV !== "production" && r ? v.value : s.state.value[t],
    set: (w) => {
      if (process.env.NODE_ENV !== "production" && r)
        throw new Error("cannot set hotState");
      I((b) => {
        oe(b, w);
      });
    }
  }), process.env.NODE_ENV !== "production" && (O._hotUpdate = Ue((w) => {
    O._hotUpdating = !0, w._hmrPayload.state.forEach((b) => {
      if (b in O.$state) {
        const M = w.$state[b], se = O.$state[b];
        typeof M == "object" && Ze(M) && Ze(se) ? Hr(M, se) : w.$state[b] = se;
      }
      $t(O, b, En(w.$state, b));
    }), Object.keys(O.$state).forEach((b) => {
      b in w.$state || Tn(O, b);
    }), u = !1, c = !1, s.state.value[t] = En(w._hmrPayload, "hotState"), c = !0, Os().then(() => {
      u = !0;
    });
    for (const b in w._hmrPayload.actions) {
      const M = w[b];
      $t(O, b, $(M, b));
    }
    for (const b in w._hmrPayload.getters) {
      const M = w._hmrPayload.getters[b], se = i ? (
        // special handling of options api
        Ae(() => (_t(s), M.call(O, O)))
      ) : M;
      $t(O, b, se);
    }
    Object.keys(O._hmrPayload.getters).forEach((b) => {
      b in w._hmrPayload.getters || Tn(O, b);
    }), Object.keys(O._hmrPayload.actions).forEach((b) => {
      b in w._hmrPayload.actions || Tn(O, b);
    }), O._hmrPayload = w._hmrPayload, O._getters = w._getters, O._hotUpdating = !1;
  })), process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && qe) {
    const w = {
      writable: !0,
      configurable: !0,
      // avoid warning on devtools trying to display this property
      enumerable: !1
    };
    ["_p", "_hmrPayload", "_getters", "_customProperties"].forEach((b) => {
      Object.defineProperty(O, b, oe({ value: O[b] }, w));
    });
  }
  return s._p.forEach((w) => {
    if (process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && qe) {
      const b = o.run(() => w({
        store: O,
        app: s._a,
        pinia: s,
        options: a
      }));
      Object.keys(b || {}).forEach((M) => O._customProperties.add(M)), oe(O, b);
    } else
      oe(O, o.run(() => w({
        store: O,
        app: s._a,
        pinia: s,
        options: a
      })));
  }), process.env.NODE_ENV !== "production" && O.$state && typeof O.$state == "object" && typeof O.$state.constructor == "function" && !O.$state.constructor.toString().includes("[native code]") && console.warn(`[🍍]: The "state" must be a plain object. It cannot be
	state: () => new MyClass()
Found in store "${O.$id}".`), p && i && n.hydrate && n.hydrate(O.$state, p), u = !0, c = !0, O;
}
// @__NO_SIDE_EFFECTS__
function ua(t, e, n) {
  let s, r;
  const i = typeof e == "function";
  s = t, r = i ? n : e;
  function o(a, l) {
    const u = Vr();
    if (a = // in test mode, ignore the argument provided as we can always retrieve a
    // pinia instance with getActivePinia()
    (process.env.NODE_ENV === "test" && st && st._testing ? null : a) || (u ? K(rs, null) : null), a && _t(a), process.env.NODE_ENV !== "production" && !st)
      throw new Error(`[🍍]: "getActivePinia()" was called but there was no active Pinia. Are you trying to use a store before calling "app.use(pinia)"?
See https://pinia.vuejs.org/core-concepts/outside-component-usage.html for help.
This will fail in production.`);
    a = st, a._s.has(s) || (i ? qn(s, e, r, a) : Is(s, r, a), process.env.NODE_ENV !== "production" && (o._pinia = a));
    const c = a._s.get(s);
    if (process.env.NODE_ENV !== "production" && l) {
      const d = "__hot:" + s, m = i ? qn(d, e, r, a, !0) : Is(d, oe({}, r), a, !0);
      l._hotUpdate(m), delete a.state.value[d], a._s.delete(d);
    }
    if (process.env.NODE_ENV !== "production" && qe) {
      const d = No();
      if (d && d.proxy && // avoid adding stores that are just built for hot module replacement
      !l) {
        const m = d.proxy, h = "_pStores" in m ? m._pStores : m._pStores = {};
        h[s] = c;
      }
    }
    return c;
  }
  return o.$id = s, o;
}
function ca(t) {
  return typeof t == "object" && t !== null;
}
function Vs(t, e) {
  return t = ca(t) ? t : /* @__PURE__ */ Object.create(null), new Proxy(t, {
    get(n, s, r) {
      return s === "key" ? Reflect.get(n, s, r) : Reflect.get(n, s, r) || Reflect.get(e, s, r);
    }
  });
}
function da(t, e) {
  return e.reduce((n, s) => n == null ? void 0 : n[s], t);
}
function fa(t, e, n) {
  return e.slice(0, -1).reduce((s, r) => /^(__proto__)$/.test(r) ? {} : s[r] = s[r] || {}, t)[e[e.length - 1]] = n, t;
}
function ha(t, e) {
  return e.reduce((n, s) => {
    const r = s.split(".");
    return fa(n, r, da(t, r));
  }, {});
}
function ma(t, e) {
  return (n) => {
    var s;
    try {
      const {
        storage: r = localStorage,
        beforeRestore: i = void 0,
        afterRestore: o = void 0,
        serializer: a = {
          serialize: JSON.stringify,
          deserialize: JSON.parse
        },
        key: l = e.$id,
        paths: u = null,
        debug: c = !1
      } = n;
      return {
        storage: r,
        beforeRestore: i,
        afterRestore: o,
        serializer: a,
        key: ((s = t.key) != null ? s : (d) => d)(typeof l == "string" ? l : l(e.$id)),
        paths: u,
        debug: c
      };
    } catch (r) {
      return n.debug && console.error("[pinia-plugin-persistedstate]", r), null;
    }
  };
}
function Cs(t, { storage: e, serializer: n, key: s, debug: r }) {
  try {
    const i = e == null ? void 0 : e.getItem(s);
    i && t.$patch(n == null ? void 0 : n.deserialize(i));
  } catch (i) {
    r && console.error("[pinia-plugin-persistedstate]", i);
  }
}
function As(t, { storage: e, serializer: n, key: s, paths: r, debug: i }) {
  try {
    const o = Array.isArray(r) ? ha(t, r) : t;
    e.setItem(s, n.serialize(o));
  } catch (o) {
    i && console.error("[pinia-plugin-persistedstate]", o);
  }
}
function pa(t = {}) {
  return (e) => {
    const { auto: n = !1 } = t, {
      options: { persist: s = n },
      store: r,
      pinia: i
    } = e;
    if (!s)
      return;
    if (!(r.$id in i.state.value)) {
      const a = i._s.get(r.$id.replace("__hot:", ""));
      a && Promise.resolve().then(() => a.$persist());
      return;
    }
    const o = (Array.isArray(s) ? s.map((a) => Vs(a, t)) : [Vs(s, t)]).map(ma(t, r)).filter(Boolean);
    r.$persist = () => {
      o.forEach((a) => {
        As(r.$state, a);
      });
    }, r.$hydrate = ({ runHooks: a = !0 } = {}) => {
      o.forEach((l) => {
        const { beforeRestore: u, afterRestore: c } = l;
        a && (u == null || u(e)), Cs(r, l), a && (c == null || c(e));
      });
    }, o.forEach((a) => {
      const { beforeRestore: l, afterRestore: u } = a;
      l == null || l(e), Cs(r, a), u == null || u(e), r.$subscribe(
        (c, d) => {
          As(d, a);
        },
        {
          detached: !0
        }
      );
    });
  };
}
var ya = pa();
const ga = (t = "") => t.endsWith("/") ? t.substr(0, t.length - 1) : t, ba = { class: "pappas-eclub-view-feedback-body" }, sn = {
  __name: "ViewFeedback",
  props: {
    type: { type: String, default: "info" }
  },
  setup(t) {
    return (e, n) => (S(), E("div", {
      class: He(["pappas-eclub-view-feedback", "pappas-eclub-view-feedback-" + t.type])
    }, [
      D("div", ba, [
        W(e.$slots, "default")
      ])
    ], 2));
  }
}, as = /* @__PURE__ */ ua(
  "form",
  () => {
    const t = B(new URLSearchParams(window.location.search).get("member")), e = B([]);
    return { feedback: e, addError: (o) => e.value.push({ type: "error", message: o }), addSuccess: (o) => e.value.push({ type: "success", message: o }), clearFeedback: () => e.value = [], memberId: t, updateMember: (o) => t.value = o };
  },
  {
    persist: {
      paths: ["memberId"]
    }
  }
);
function Jr(t, e) {
  return function() {
    return t.apply(e, arguments);
  };
}
const { toString: wa } = Object.prototype, { getPrototypeOf: ls } = Object, dn = /* @__PURE__ */ ((t) => (e) => {
  const n = wa.call(e);
  return t[n] || (t[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), ye = (t) => (t = t.toLowerCase(), (e) => dn(e) === t), fn = (t) => (e) => typeof e === t, { isArray: dt } = Array, Dt = fn("undefined");
function Sa(t) {
  return t !== null && !Dt(t) && t.constructor !== null && !Dt(t.constructor) && te(t.constructor.isBuffer) && t.constructor.isBuffer(t);
}
const Yr = ye("ArrayBuffer");
function va(t) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(t) : e = t && t.buffer && Yr(t.buffer), e;
}
const Oa = fn("string"), te = fn("function"), Gr = fn("number"), hn = (t) => t !== null && typeof t == "object", Ea = (t) => t === !0 || t === !1, Yt = (t) => {
  if (dn(t) !== "object")
    return !1;
  const e = ls(t);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Symbol.toStringTag in t) && !(Symbol.iterator in t);
}, Ta = ye("Date"), ka = ye("File"), Na = ye("Blob"), _a = ye("FileList"), Da = (t) => hn(t) && te(t.pipe), xa = (t) => {
  let e;
  return t && (typeof FormData == "function" && t instanceof FormData || te(t.append) && ((e = dn(t)) === "formdata" || // detect form-data instance
  e === "object" && te(t.toString) && t.toString() === "[object FormData]"));
}, Ia = ye("URLSearchParams"), [Va, Ca, Aa, Fa] = ["ReadableStream", "Request", "Response", "Headers"].map(ye), Ma = (t) => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Vt(t, e, { allOwnKeys: n = !1 } = {}) {
  if (t === null || typeof t > "u")
    return;
  let s, r;
  if (typeof t != "object" && (t = [t]), dt(t))
    for (s = 0, r = t.length; s < r; s++)
      e.call(null, t[s], s, t);
  else {
    const i = n ? Object.getOwnPropertyNames(t) : Object.keys(t), o = i.length;
    let a;
    for (s = 0; s < o; s++)
      a = i[s], e.call(null, t[a], a, t);
  }
}
function Kr(t, e) {
  e = e.toLowerCase();
  const n = Object.keys(t);
  let s = n.length, r;
  for (; s-- > 0; )
    if (r = n[s], e === r.toLowerCase())
      return r;
  return null;
}
const Be = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Qr = (t) => !Dt(t) && t !== Be;
function Bn() {
  const { caseless: t } = Qr(this) && this || {}, e = {}, n = (s, r) => {
    const i = t && Kr(e, r) || r;
    Yt(e[i]) && Yt(s) ? e[i] = Bn(e[i], s) : Yt(s) ? e[i] = Bn({}, s) : dt(s) ? e[i] = s.slice() : e[i] = s;
  };
  for (let s = 0, r = arguments.length; s < r; s++)
    arguments[s] && Vt(arguments[s], n);
  return e;
}
const Ra = (t, e, n, { allOwnKeys: s } = {}) => (Vt(e, (r, i) => {
  n && te(r) ? t[i] = Jr(r, n) : t[i] = r;
}, { allOwnKeys: s }), t), $a = (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t), La = (t, e, n, s) => {
  t.prototype = Object.create(e.prototype, s), t.prototype.constructor = t, Object.defineProperty(t, "super", {
    value: e.prototype
  }), n && Object.assign(t.prototype, n);
}, Pa = (t, e, n, s) => {
  let r, i, o;
  const a = {};
  if (e = e || {}, t == null) return e;
  do {
    for (r = Object.getOwnPropertyNames(t), i = r.length; i-- > 0; )
      o = r[i], (!s || s(o, t, e)) && !a[o] && (e[o] = t[o], a[o] = !0);
    t = n !== !1 && ls(t);
  } while (t && (!n || n(t, e)) && t !== Object.prototype);
  return e;
}, Ua = (t, e, n) => {
  t = String(t), (n === void 0 || n > t.length) && (n = t.length), n -= e.length;
  const s = t.indexOf(e, n);
  return s !== -1 && s === n;
}, Wa = (t) => {
  if (!t) return null;
  if (dt(t)) return t;
  let e = t.length;
  if (!Gr(e)) return null;
  const n = new Array(e);
  for (; e-- > 0; )
    n[e] = t[e];
  return n;
}, qa = /* @__PURE__ */ ((t) => (e) => t && e instanceof t)(typeof Uint8Array < "u" && ls(Uint8Array)), Ba = (t, e) => {
  const s = (t && t[Symbol.iterator]).call(t);
  let r;
  for (; (r = s.next()) && !r.done; ) {
    const i = r.value;
    e.call(t, i[0], i[1]);
  }
}, ja = (t, e) => {
  let n;
  const s = [];
  for (; (n = t.exec(e)) !== null; )
    s.push(n);
  return s;
}, za = ye("HTMLFormElement"), Ha = (t) => t.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, s, r) {
    return s.toUpperCase() + r;
  }
), Fs = (({ hasOwnProperty: t }) => (e, n) => t.call(e, n))(Object.prototype), Za = ye("RegExp"), Xr = (t, e) => {
  const n = Object.getOwnPropertyDescriptors(t), s = {};
  Vt(n, (r, i) => {
    let o;
    (o = e(r, i, t)) !== !1 && (s[i] = o || r);
  }), Object.defineProperties(t, s);
}, Ja = (t) => {
  Xr(t, (e, n) => {
    if (te(t) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const s = t[n];
    if (te(s)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, Ya = (t, e) => {
  const n = {}, s = (r) => {
    r.forEach((i) => {
      n[i] = !0;
    });
  };
  return dt(t) ? s(t) : s(String(t).split(e)), n;
}, Ga = () => {
}, Ka = (t, e) => t != null && Number.isFinite(t = +t) ? t : e, Nn = "abcdefghijklmnopqrstuvwxyz", Ms = "0123456789", ei = {
  DIGIT: Ms,
  ALPHA: Nn,
  ALPHA_DIGIT: Nn + Nn.toUpperCase() + Ms
}, Qa = (t = 16, e = ei.ALPHA_DIGIT) => {
  let n = "";
  const { length: s } = e;
  for (; t--; )
    n += e[Math.random() * s | 0];
  return n;
};
function Xa(t) {
  return !!(t && te(t.append) && t[Symbol.toStringTag] === "FormData" && t[Symbol.iterator]);
}
const el = (t) => {
  const e = new Array(10), n = (s, r) => {
    if (hn(s)) {
      if (e.indexOf(s) >= 0)
        return;
      if (!("toJSON" in s)) {
        e[r] = s;
        const i = dt(s) ? [] : {};
        return Vt(s, (o, a) => {
          const l = n(o, r + 1);
          !Dt(l) && (i[a] = l);
        }), e[r] = void 0, i;
      }
    }
    return s;
  };
  return n(t, 0);
}, tl = ye("AsyncFunction"), nl = (t) => t && (hn(t) || te(t)) && te(t.then) && te(t.catch), ti = ((t, e) => t ? setImmediate : e ? ((n, s) => (Be.addEventListener("message", ({ source: r, data: i }) => {
  r === Be && i === n && s.length && s.shift()();
}, !1), (r) => {
  s.push(r), Be.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  te(Be.postMessage)
), sl = typeof queueMicrotask < "u" ? queueMicrotask.bind(Be) : typeof process < "u" && process.nextTick || ti, f = {
  isArray: dt,
  isArrayBuffer: Yr,
  isBuffer: Sa,
  isFormData: xa,
  isArrayBufferView: va,
  isString: Oa,
  isNumber: Gr,
  isBoolean: Ea,
  isObject: hn,
  isPlainObject: Yt,
  isReadableStream: Va,
  isRequest: Ca,
  isResponse: Aa,
  isHeaders: Fa,
  isUndefined: Dt,
  isDate: Ta,
  isFile: ka,
  isBlob: Na,
  isRegExp: Za,
  isFunction: te,
  isStream: Da,
  isURLSearchParams: Ia,
  isTypedArray: qa,
  isFileList: _a,
  forEach: Vt,
  merge: Bn,
  extend: Ra,
  trim: Ma,
  stripBOM: $a,
  inherits: La,
  toFlatObject: Pa,
  kindOf: dn,
  kindOfTest: ye,
  endsWith: Ua,
  toArray: Wa,
  forEachEntry: Ba,
  matchAll: ja,
  isHTMLForm: za,
  hasOwnProperty: Fs,
  hasOwnProp: Fs,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Xr,
  freezeMethods: Ja,
  toObjectSet: Ya,
  toCamelCase: Ha,
  noop: Ga,
  toFiniteNumber: Ka,
  findKey: Kr,
  global: Be,
  isContextDefined: Qr,
  ALPHABET: ei,
  generateString: Qa,
  isSpecCompliantForm: Xa,
  toJSONObject: el,
  isAsyncFn: tl,
  isThenable: nl,
  setImmediate: ti,
  asap: sl
};
function _(t, e, n, s, r) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = "AxiosError", e && (this.code = e), n && (this.config = n), s && (this.request = s), r && (this.response = r, this.status = r.status ? r.status : null);
}
f.inherits(_, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: f.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const ni = _.prototype, si = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((t) => {
  si[t] = { value: t };
});
Object.defineProperties(_, si);
Object.defineProperty(ni, "isAxiosError", { value: !0 });
_.from = (t, e, n, s, r, i) => {
  const o = Object.create(ni);
  return f.toFlatObject(t, o, function(l) {
    return l !== Error.prototype;
  }, (a) => a !== "isAxiosError"), _.call(o, t.message, e, n, s, r), o.cause = t, o.name = t.name, i && Object.assign(o, i), o;
};
const rl = null;
function jn(t) {
  return f.isPlainObject(t) || f.isArray(t);
}
function ri(t) {
  return f.endsWith(t, "[]") ? t.slice(0, -2) : t;
}
function Rs(t, e, n) {
  return t ? t.concat(e).map(function(r, i) {
    return r = ri(r), !n && i ? "[" + r + "]" : r;
  }).join(n ? "." : "") : e;
}
function il(t) {
  return f.isArray(t) && !t.some(jn);
}
const ol = f.toFlatObject(f, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function mn(t, e, n) {
  if (!f.isObject(t))
    throw new TypeError("target must be an object");
  e = e || new FormData(), n = f.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(v, g) {
    return !f.isUndefined(g[v]);
  });
  const s = n.metaTokens, r = n.visitor || c, i = n.dots, o = n.indexes, l = (n.Blob || typeof Blob < "u" && Blob) && f.isSpecCompliantForm(e);
  if (!f.isFunction(r))
    throw new TypeError("visitor must be a function");
  function u(p) {
    if (p === null) return "";
    if (f.isDate(p))
      return p.toISOString();
    if (!l && f.isBlob(p))
      throw new _("Blob is not supported. Use a Buffer instead.");
    return f.isArrayBuffer(p) || f.isTypedArray(p) ? l && typeof Blob == "function" ? new Blob([p]) : Buffer.from(p) : p;
  }
  function c(p, v, g) {
    let I = p;
    if (p && !g && typeof p == "object") {
      if (f.endsWith(v, "{}"))
        v = s ? v : v.slice(0, -2), p = JSON.stringify(p);
      else if (f.isArray(p) && il(p) || (f.isFileList(p) || f.endsWith(v, "[]")) && (I = f.toArray(p)))
        return v = ri(v), I.forEach(function(x, $) {
          !(f.isUndefined(x) || x === null) && e.append(
            // eslint-disable-next-line no-nested-ternary
            o === !0 ? Rs([v], $, i) : o === null ? v : v + "[]",
            u(x)
          );
        }), !1;
    }
    return jn(p) ? !0 : (e.append(Rs(g, v, i), u(p)), !1);
  }
  const d = [], m = Object.assign(ol, {
    defaultVisitor: c,
    convertValue: u,
    isVisitable: jn
  });
  function h(p, v) {
    if (!f.isUndefined(p)) {
      if (d.indexOf(p) !== -1)
        throw Error("Circular reference detected in " + v.join("."));
      d.push(p), f.forEach(p, function(I, T) {
        (!(f.isUndefined(I) || I === null) && r.call(
          e,
          I,
          f.isString(T) ? T.trim() : T,
          v,
          m
        )) === !0 && h(I, v ? v.concat(T) : [T]);
      }), d.pop();
    }
  }
  if (!f.isObject(t))
    throw new TypeError("data must be an object");
  return h(t), e;
}
function $s(t) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function(s) {
    return e[s];
  });
}
function us(t, e) {
  this._pairs = [], t && mn(t, this, e);
}
const ii = us.prototype;
ii.append = function(e, n) {
  this._pairs.push([e, n]);
};
ii.toString = function(e) {
  const n = e ? function(s) {
    return e.call(this, s, $s);
  } : $s;
  return this._pairs.map(function(r) {
    return n(r[0]) + "=" + n(r[1]);
  }, "").join("&");
};
function al(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function oi(t, e, n) {
  if (!e)
    return t;
  const s = n && n.encode || al, r = n && n.serialize;
  let i;
  if (r ? i = r(e, n) : i = f.isURLSearchParams(e) ? e.toString() : new us(e, n).toString(s), i) {
    const o = t.indexOf("#");
    o !== -1 && (t = t.slice(0, o)), t += (t.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return t;
}
class Ls {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(e, n, s) {
    return this.handlers.push({
      fulfilled: e,
      rejected: n,
      synchronous: s ? s.synchronous : !1,
      runWhen: s ? s.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(e) {
    f.forEach(this.handlers, function(s) {
      s !== null && e(s);
    });
  }
}
const ai = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, ll = typeof URLSearchParams < "u" ? URLSearchParams : us, ul = typeof FormData < "u" ? FormData : null, cl = typeof Blob < "u" ? Blob : null, dl = {
  isBrowser: !0,
  classes: {
    URLSearchParams: ll,
    FormData: ul,
    Blob: cl
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, cs = typeof window < "u" && typeof document < "u", zn = typeof navigator == "object" && navigator || void 0, fl = cs && (!zn || ["ReactNative", "NativeScript", "NS"].indexOf(zn.product) < 0), hl = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", ml = cs && window.location.href || "http://localhost", pl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: cs,
  hasStandardBrowserEnv: fl,
  hasStandardBrowserWebWorkerEnv: hl,
  navigator: zn,
  origin: ml
}, Symbol.toStringTag, { value: "Module" })), Q = {
  ...pl,
  ...dl
};
function yl(t, e) {
  return mn(t, new Q.classes.URLSearchParams(), Object.assign({
    visitor: function(n, s, r, i) {
      return Q.isNode && f.isBuffer(n) ? (this.append(s, n.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, e));
}
function gl(t) {
  return f.matchAll(/\w+|\[(\w*)]/g, t).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function bl(t) {
  const e = {}, n = Object.keys(t);
  let s;
  const r = n.length;
  let i;
  for (s = 0; s < r; s++)
    i = n[s], e[i] = t[i];
  return e;
}
function li(t) {
  function e(n, s, r, i) {
    let o = n[i++];
    if (o === "__proto__") return !0;
    const a = Number.isFinite(+o), l = i >= n.length;
    return o = !o && f.isArray(r) ? r.length : o, l ? (f.hasOwnProp(r, o) ? r[o] = [r[o], s] : r[o] = s, !a) : ((!r[o] || !f.isObject(r[o])) && (r[o] = []), e(n, s, r[o], i) && f.isArray(r[o]) && (r[o] = bl(r[o])), !a);
  }
  if (f.isFormData(t) && f.isFunction(t.entries)) {
    const n = {};
    return f.forEachEntry(t, (s, r) => {
      e(gl(s), r, n, 0);
    }), n;
  }
  return null;
}
function wl(t, e, n) {
  if (f.isString(t))
    try {
      return (e || JSON.parse)(t), f.trim(t);
    } catch (s) {
      if (s.name !== "SyntaxError")
        throw s;
    }
  return (0, JSON.stringify)(t);
}
const Ct = {
  transitional: ai,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, n) {
    const s = n.getContentType() || "", r = s.indexOf("application/json") > -1, i = f.isObject(e);
    if (i && f.isHTMLForm(e) && (e = new FormData(e)), f.isFormData(e))
      return r ? JSON.stringify(li(e)) : e;
    if (f.isArrayBuffer(e) || f.isBuffer(e) || f.isStream(e) || f.isFile(e) || f.isBlob(e) || f.isReadableStream(e))
      return e;
    if (f.isArrayBufferView(e))
      return e.buffer;
    if (f.isURLSearchParams(e))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let a;
    if (i) {
      if (s.indexOf("application/x-www-form-urlencoded") > -1)
        return yl(e, this.formSerializer).toString();
      if ((a = f.isFileList(e)) || s.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return mn(
          a ? { "files[]": e } : e,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return i || r ? (n.setContentType("application/json", !1), wl(e)) : e;
  }],
  transformResponse: [function(e) {
    const n = this.transitional || Ct.transitional, s = n && n.forcedJSONParsing, r = this.responseType === "json";
    if (f.isResponse(e) || f.isReadableStream(e))
      return e;
    if (e && f.isString(e) && (s && !this.responseType || r)) {
      const o = !(n && n.silentJSONParsing) && r;
      try {
        return JSON.parse(e);
      } catch (a) {
        if (o)
          throw a.name === "SyntaxError" ? _.from(a, _.ERR_BAD_RESPONSE, this, null, this.response) : a;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Q.classes.FormData,
    Blob: Q.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
f.forEach(["delete", "get", "head", "post", "put", "patch"], (t) => {
  Ct.headers[t] = {};
});
const Sl = f.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), vl = (t) => {
  const e = {};
  let n, s, r;
  return t && t.split(`
`).forEach(function(o) {
    r = o.indexOf(":"), n = o.substring(0, r).trim().toLowerCase(), s = o.substring(r + 1).trim(), !(!n || e[n] && Sl[n]) && (n === "set-cookie" ? e[n] ? e[n].push(s) : e[n] = [s] : e[n] = e[n] ? e[n] + ", " + s : s);
  }), e;
}, Ps = Symbol("internals");
function wt(t) {
  return t && String(t).trim().toLowerCase();
}
function Gt(t) {
  return t === !1 || t == null ? t : f.isArray(t) ? t.map(Gt) : String(t);
}
function Ol(t) {
  const e = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let s;
  for (; s = n.exec(t); )
    e[s[1]] = s[2];
  return e;
}
const El = (t) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(t.trim());
function _n(t, e, n, s, r) {
  if (f.isFunction(s))
    return s.call(this, e, n);
  if (r && (e = n), !!f.isString(e)) {
    if (f.isString(s))
      return e.indexOf(s) !== -1;
    if (f.isRegExp(s))
      return s.test(e);
  }
}
function Tl(t) {
  return t.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, n, s) => n.toUpperCase() + s);
}
function kl(t, e) {
  const n = f.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((s) => {
    Object.defineProperty(t, s + n, {
      value: function(r, i, o) {
        return this[s].call(this, e, r, i, o);
      },
      configurable: !0
    });
  });
}
class X {
  constructor(e) {
    e && this.set(e);
  }
  set(e, n, s) {
    const r = this;
    function i(a, l, u) {
      const c = wt(l);
      if (!c)
        throw new Error("header name must be a non-empty string");
      const d = f.findKey(r, c);
      (!d || r[d] === void 0 || u === !0 || u === void 0 && r[d] !== !1) && (r[d || l] = Gt(a));
    }
    const o = (a, l) => f.forEach(a, (u, c) => i(u, c, l));
    if (f.isPlainObject(e) || e instanceof this.constructor)
      o(e, n);
    else if (f.isString(e) && (e = e.trim()) && !El(e))
      o(vl(e), n);
    else if (f.isHeaders(e))
      for (const [a, l] of e.entries())
        i(l, a, s);
    else
      e != null && i(n, e, s);
    return this;
  }
  get(e, n) {
    if (e = wt(e), e) {
      const s = f.findKey(this, e);
      if (s) {
        const r = this[s];
        if (!n)
          return r;
        if (n === !0)
          return Ol(r);
        if (f.isFunction(n))
          return n.call(this, r, s);
        if (f.isRegExp(n))
          return n.exec(r);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, n) {
    if (e = wt(e), e) {
      const s = f.findKey(this, e);
      return !!(s && this[s] !== void 0 && (!n || _n(this, this[s], s, n)));
    }
    return !1;
  }
  delete(e, n) {
    const s = this;
    let r = !1;
    function i(o) {
      if (o = wt(o), o) {
        const a = f.findKey(s, o);
        a && (!n || _n(s, s[a], a, n)) && (delete s[a], r = !0);
      }
    }
    return f.isArray(e) ? e.forEach(i) : i(e), r;
  }
  clear(e) {
    const n = Object.keys(this);
    let s = n.length, r = !1;
    for (; s--; ) {
      const i = n[s];
      (!e || _n(this, this[i], i, e, !0)) && (delete this[i], r = !0);
    }
    return r;
  }
  normalize(e) {
    const n = this, s = {};
    return f.forEach(this, (r, i) => {
      const o = f.findKey(s, i);
      if (o) {
        n[o] = Gt(r), delete n[i];
        return;
      }
      const a = e ? Tl(i) : String(i).trim();
      a !== i && delete n[i], n[a] = Gt(r), s[a] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const n = /* @__PURE__ */ Object.create(null);
    return f.forEach(this, (s, r) => {
      s != null && s !== !1 && (n[r] = e && f.isArray(s) ? s.join(", ") : s);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, n]) => e + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...n) {
    const s = new this(e);
    return n.forEach((r) => s.set(r)), s;
  }
  static accessor(e) {
    const s = (this[Ps] = this[Ps] = {
      accessors: {}
    }).accessors, r = this.prototype;
    function i(o) {
      const a = wt(o);
      s[a] || (kl(r, o), s[a] = !0);
    }
    return f.isArray(e) ? e.forEach(i) : i(e), this;
  }
}
X.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
f.reduceDescriptors(X.prototype, ({ value: t }, e) => {
  let n = e[0].toUpperCase() + e.slice(1);
  return {
    get: () => t,
    set(s) {
      this[n] = s;
    }
  };
});
f.freezeMethods(X);
function Dn(t, e) {
  const n = this || Ct, s = e || n, r = X.from(s.headers);
  let i = s.data;
  return f.forEach(t, function(a) {
    i = a.call(n, i, r.normalize(), e ? e.status : void 0);
  }), r.normalize(), i;
}
function ui(t) {
  return !!(t && t.__CANCEL__);
}
function ft(t, e, n) {
  _.call(this, t ?? "canceled", _.ERR_CANCELED, e, n), this.name = "CanceledError";
}
f.inherits(ft, _, {
  __CANCEL__: !0
});
function ci(t, e, n) {
  const s = n.config.validateStatus;
  !n.status || !s || s(n.status) ? t(n) : e(new _(
    "Request failed with status code " + n.status,
    [_.ERR_BAD_REQUEST, _.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function Nl(t) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(t);
  return e && e[1] || "";
}
function _l(t, e) {
  t = t || 10;
  const n = new Array(t), s = new Array(t);
  let r = 0, i = 0, o;
  return e = e !== void 0 ? e : 1e3, function(l) {
    const u = Date.now(), c = s[i];
    o || (o = u), n[r] = l, s[r] = u;
    let d = i, m = 0;
    for (; d !== r; )
      m += n[d++], d = d % t;
    if (r = (r + 1) % t, r === i && (i = (i + 1) % t), u - o < e)
      return;
    const h = c && u - c;
    return h ? Math.round(m * 1e3 / h) : void 0;
  };
}
function Dl(t, e) {
  let n = 0, s = 1e3 / e, r, i;
  const o = (u, c = Date.now()) => {
    n = c, r = null, i && (clearTimeout(i), i = null), t.apply(null, u);
  };
  return [(...u) => {
    const c = Date.now(), d = c - n;
    d >= s ? o(u, c) : (r = u, i || (i = setTimeout(() => {
      i = null, o(r);
    }, s - d)));
  }, () => r && o(r)];
}
const rn = (t, e, n = 3) => {
  let s = 0;
  const r = _l(50, 250);
  return Dl((i) => {
    const o = i.loaded, a = i.lengthComputable ? i.total : void 0, l = o - s, u = r(l), c = o <= a;
    s = o;
    const d = {
      loaded: o,
      total: a,
      progress: a ? o / a : void 0,
      bytes: l,
      rate: u || void 0,
      estimated: u && a && c ? (a - o) / u : void 0,
      event: i,
      lengthComputable: a != null,
      [e ? "download" : "upload"]: !0
    };
    t(d);
  }, n);
}, Us = (t, e) => {
  const n = t != null;
  return [(s) => e[0]({
    lengthComputable: n,
    total: t,
    loaded: s
  }), e[1]];
}, Ws = (t) => (...e) => f.asap(() => t(...e)), xl = Q.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const e = Q.navigator && /(msie|trident)/i.test(Q.navigator.userAgent), n = document.createElement("a");
    let s;
    function r(i) {
      let o = i;
      return e && (n.setAttribute("href", o), o = n.href), n.setAttribute("href", o), {
        href: n.href,
        protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
        host: n.host,
        search: n.search ? n.search.replace(/^\?/, "") : "",
        hash: n.hash ? n.hash.replace(/^#/, "") : "",
        hostname: n.hostname,
        port: n.port,
        pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
      };
    }
    return s = r(window.location.href), function(o) {
      const a = f.isString(o) ? r(o) : o;
      return a.protocol === s.protocol && a.host === s.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
), Il = Q.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(t, e, n, s, r, i) {
      const o = [t + "=" + encodeURIComponent(e)];
      f.isNumber(n) && o.push("expires=" + new Date(n).toGMTString()), f.isString(s) && o.push("path=" + s), f.isString(r) && o.push("domain=" + r), i === !0 && o.push("secure"), document.cookie = o.join("; ");
    },
    read(t) {
      const e = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));
      return e ? decodeURIComponent(e[3]) : null;
    },
    remove(t) {
      this.write(t, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function Vl(t) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
}
function Cl(t, e) {
  return e ? t.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : t;
}
function di(t, e) {
  return t && !Vl(e) ? Cl(t, e) : e;
}
const qs = (t) => t instanceof X ? { ...t } : t;
function Je(t, e) {
  e = e || {};
  const n = {};
  function s(u, c, d) {
    return f.isPlainObject(u) && f.isPlainObject(c) ? f.merge.call({ caseless: d }, u, c) : f.isPlainObject(c) ? f.merge({}, c) : f.isArray(c) ? c.slice() : c;
  }
  function r(u, c, d) {
    if (f.isUndefined(c)) {
      if (!f.isUndefined(u))
        return s(void 0, u, d);
    } else return s(u, c, d);
  }
  function i(u, c) {
    if (!f.isUndefined(c))
      return s(void 0, c);
  }
  function o(u, c) {
    if (f.isUndefined(c)) {
      if (!f.isUndefined(u))
        return s(void 0, u);
    } else return s(void 0, c);
  }
  function a(u, c, d) {
    if (d in e)
      return s(u, c);
    if (d in t)
      return s(void 0, u);
  }
  const l = {
    url: i,
    method: i,
    data: i,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    withXSRFToken: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: a,
    headers: (u, c) => r(qs(u), qs(c), !0)
  };
  return f.forEach(Object.keys(Object.assign({}, t, e)), function(c) {
    const d = l[c] || r, m = d(t[c], e[c], c);
    f.isUndefined(m) && d !== a || (n[c] = m);
  }), n;
}
const fi = (t) => {
  const e = Je({}, t);
  let { data: n, withXSRFToken: s, xsrfHeaderName: r, xsrfCookieName: i, headers: o, auth: a } = e;
  e.headers = o = X.from(o), e.url = oi(di(e.baseURL, e.url), t.params, t.paramsSerializer), a && o.set(
    "Authorization",
    "Basic " + btoa((a.username || "") + ":" + (a.password ? unescape(encodeURIComponent(a.password)) : ""))
  );
  let l;
  if (f.isFormData(n)) {
    if (Q.hasStandardBrowserEnv || Q.hasStandardBrowserWebWorkerEnv)
      o.setContentType(void 0);
    else if ((l = o.getContentType()) !== !1) {
      const [u, ...c] = l ? l.split(";").map((d) => d.trim()).filter(Boolean) : [];
      o.setContentType([u || "multipart/form-data", ...c].join("; "));
    }
  }
  if (Q.hasStandardBrowserEnv && (s && f.isFunction(s) && (s = s(e)), s || s !== !1 && xl(e.url))) {
    const u = r && i && Il.read(i);
    u && o.set(r, u);
  }
  return e;
}, Al = typeof XMLHttpRequest < "u", Fl = Al && function(t) {
  return new Promise(function(n, s) {
    const r = fi(t);
    let i = r.data;
    const o = X.from(r.headers).normalize();
    let { responseType: a, onUploadProgress: l, onDownloadProgress: u } = r, c, d, m, h, p;
    function v() {
      h && h(), p && p(), r.cancelToken && r.cancelToken.unsubscribe(c), r.signal && r.signal.removeEventListener("abort", c);
    }
    let g = new XMLHttpRequest();
    g.open(r.method.toUpperCase(), r.url, !0), g.timeout = r.timeout;
    function I() {
      if (!g)
        return;
      const x = X.from(
        "getAllResponseHeaders" in g && g.getAllResponseHeaders()
      ), F = {
        data: !a || a === "text" || a === "json" ? g.responseText : g.response,
        status: g.status,
        statusText: g.statusText,
        headers: x,
        config: t,
        request: g
      };
      ci(function(O) {
        n(O), v();
      }, function(O) {
        s(O), v();
      }, F), g = null;
    }
    "onloadend" in g ? g.onloadend = I : g.onreadystatechange = function() {
      !g || g.readyState !== 4 || g.status === 0 && !(g.responseURL && g.responseURL.indexOf("file:") === 0) || setTimeout(I);
    }, g.onabort = function() {
      g && (s(new _("Request aborted", _.ECONNABORTED, t, g)), g = null);
    }, g.onerror = function() {
      s(new _("Network Error", _.ERR_NETWORK, t, g)), g = null;
    }, g.ontimeout = function() {
      let $ = r.timeout ? "timeout of " + r.timeout + "ms exceeded" : "timeout exceeded";
      const F = r.transitional || ai;
      r.timeoutErrorMessage && ($ = r.timeoutErrorMessage), s(new _(
        $,
        F.clarifyTimeoutError ? _.ETIMEDOUT : _.ECONNABORTED,
        t,
        g
      )), g = null;
    }, i === void 0 && o.setContentType(null), "setRequestHeader" in g && f.forEach(o.toJSON(), function($, F) {
      g.setRequestHeader(F, $);
    }), f.isUndefined(r.withCredentials) || (g.withCredentials = !!r.withCredentials), a && a !== "json" && (g.responseType = r.responseType), u && ([m, p] = rn(u, !0), g.addEventListener("progress", m)), l && g.upload && ([d, h] = rn(l), g.upload.addEventListener("progress", d), g.upload.addEventListener("loadend", h)), (r.cancelToken || r.signal) && (c = (x) => {
      g && (s(!x || x.type ? new ft(null, t, g) : x), g.abort(), g = null);
    }, r.cancelToken && r.cancelToken.subscribe(c), r.signal && (r.signal.aborted ? c() : r.signal.addEventListener("abort", c)));
    const T = Nl(r.url);
    if (T && Q.protocols.indexOf(T) === -1) {
      s(new _("Unsupported protocol " + T + ":", _.ERR_BAD_REQUEST, t));
      return;
    }
    g.send(i || null);
  });
}, Ml = (t, e) => {
  const { length: n } = t = t ? t.filter(Boolean) : [];
  if (e || n) {
    let s = new AbortController(), r;
    const i = function(u) {
      if (!r) {
        r = !0, a();
        const c = u instanceof Error ? u : this.reason;
        s.abort(c instanceof _ ? c : new ft(c instanceof Error ? c.message : c));
      }
    };
    let o = e && setTimeout(() => {
      o = null, i(new _(`timeout ${e} of ms exceeded`, _.ETIMEDOUT));
    }, e);
    const a = () => {
      t && (o && clearTimeout(o), o = null, t.forEach((u) => {
        u.unsubscribe ? u.unsubscribe(i) : u.removeEventListener("abort", i);
      }), t = null);
    };
    t.forEach((u) => u.addEventListener("abort", i));
    const { signal: l } = s;
    return l.unsubscribe = () => f.asap(a), l;
  }
}, Rl = function* (t, e) {
  let n = t.byteLength;
  if (n < e) {
    yield t;
    return;
  }
  let s = 0, r;
  for (; s < n; )
    r = s + e, yield t.slice(s, r), s = r;
}, $l = async function* (t, e) {
  for await (const n of Ll(t))
    yield* Rl(n, e);
}, Ll = async function* (t) {
  if (t[Symbol.asyncIterator]) {
    yield* t;
    return;
  }
  const e = t.getReader();
  try {
    for (; ; ) {
      const { done: n, value: s } = await e.read();
      if (n)
        break;
      yield s;
    }
  } finally {
    await e.cancel();
  }
}, Bs = (t, e, n, s) => {
  const r = $l(t, e);
  let i = 0, o, a = (l) => {
    o || (o = !0, s && s(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: u, value: c } = await r.next();
        if (u) {
          a(), l.close();
          return;
        }
        let d = c.byteLength;
        if (n) {
          let m = i += d;
          n(m);
        }
        l.enqueue(new Uint8Array(c));
      } catch (u) {
        throw a(u), u;
      }
    },
    cancel(l) {
      return a(l), r.return();
    }
  }, {
    highWaterMark: 2
  });
}, pn = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", hi = pn && typeof ReadableStream == "function", Pl = pn && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((t) => (e) => t.encode(e))(new TextEncoder()) : async (t) => new Uint8Array(await new Response(t).arrayBuffer())), mi = (t, ...e) => {
  try {
    return !!t(...e);
  } catch {
    return !1;
  }
}, Ul = hi && mi(() => {
  let t = !1;
  const e = new Request(Q.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return t = !0, "half";
    }
  }).headers.has("Content-Type");
  return t && !e;
}), js = 64 * 1024, Hn = hi && mi(() => f.isReadableStream(new Response("").body)), on = {
  stream: Hn && ((t) => t.body)
};
pn && ((t) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((e) => {
    !on[e] && (on[e] = f.isFunction(t[e]) ? (n) => n[e]() : (n, s) => {
      throw new _(`Response type '${e}' is not supported`, _.ERR_NOT_SUPPORT, s);
    });
  });
})(new Response());
const Wl = async (t) => {
  if (t == null)
    return 0;
  if (f.isBlob(t))
    return t.size;
  if (f.isSpecCompliantForm(t))
    return (await new Request(Q.origin, {
      method: "POST",
      body: t
    }).arrayBuffer()).byteLength;
  if (f.isArrayBufferView(t) || f.isArrayBuffer(t))
    return t.byteLength;
  if (f.isURLSearchParams(t) && (t = t + ""), f.isString(t))
    return (await Pl(t)).byteLength;
}, ql = async (t, e) => {
  const n = f.toFiniteNumber(t.getContentLength());
  return n ?? Wl(e);
}, Bl = pn && (async (t) => {
  let {
    url: e,
    method: n,
    data: s,
    signal: r,
    cancelToken: i,
    timeout: o,
    onDownloadProgress: a,
    onUploadProgress: l,
    responseType: u,
    headers: c,
    withCredentials: d = "same-origin",
    fetchOptions: m
  } = fi(t);
  u = u ? (u + "").toLowerCase() : "text";
  let h = Ml([r, i && i.toAbortSignal()], o), p;
  const v = h && h.unsubscribe && (() => {
    h.unsubscribe();
  });
  let g;
  try {
    if (l && Ul && n !== "get" && n !== "head" && (g = await ql(c, s)) !== 0) {
      let F = new Request(e, {
        method: "POST",
        body: s,
        duplex: "half"
      }), ee;
      if (f.isFormData(s) && (ee = F.headers.get("content-type")) && c.setContentType(ee), F.body) {
        const [O, Me] = Us(
          g,
          rn(Ws(l))
        );
        s = Bs(F.body, js, O, Me);
      }
    }
    f.isString(d) || (d = d ? "include" : "omit");
    const I = "credentials" in Request.prototype;
    p = new Request(e, {
      ...m,
      signal: h,
      method: n.toUpperCase(),
      headers: c.normalize().toJSON(),
      body: s,
      duplex: "half",
      credentials: I ? d : void 0
    });
    let T = await fetch(p);
    const x = Hn && (u === "stream" || u === "response");
    if (Hn && (a || x && v)) {
      const F = {};
      ["status", "statusText", "headers"].forEach((H) => {
        F[H] = T[H];
      });
      const ee = f.toFiniteNumber(T.headers.get("content-length")), [O, Me] = a && Us(
        ee,
        rn(Ws(a), !0)
      ) || [];
      T = new Response(
        Bs(T.body, js, O, () => {
          Me && Me(), v && v();
        }),
        F
      );
    }
    u = u || "text";
    let $ = await on[f.findKey(on, u) || "text"](T, t);
    return !x && v && v(), await new Promise((F, ee) => {
      ci(F, ee, {
        data: $,
        headers: X.from(T.headers),
        status: T.status,
        statusText: T.statusText,
        config: t,
        request: p
      });
    });
  } catch (I) {
    throw v && v(), I && I.name === "TypeError" && /fetch/i.test(I.message) ? Object.assign(
      new _("Network Error", _.ERR_NETWORK, t, p),
      {
        cause: I.cause || I
      }
    ) : _.from(I, I && I.code, t, p);
  }
}), Zn = {
  http: rl,
  xhr: Fl,
  fetch: Bl
};
f.forEach(Zn, (t, e) => {
  if (t) {
    try {
      Object.defineProperty(t, "name", { value: e });
    } catch {
    }
    Object.defineProperty(t, "adapterName", { value: e });
  }
});
const zs = (t) => `- ${t}`, jl = (t) => f.isFunction(t) || t === null || t === !1, pi = {
  getAdapter: (t) => {
    t = f.isArray(t) ? t : [t];
    const { length: e } = t;
    let n, s;
    const r = {};
    for (let i = 0; i < e; i++) {
      n = t[i];
      let o;
      if (s = n, !jl(n) && (s = Zn[(o = String(n)).toLowerCase()], s === void 0))
        throw new _(`Unknown adapter '${o}'`);
      if (s)
        break;
      r[o || "#" + i] = s;
    }
    if (!s) {
      const i = Object.entries(r).map(
        ([a, l]) => `adapter ${a} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let o = e ? i.length > 1 ? `since :
` + i.map(zs).join(`
`) : " " + zs(i[0]) : "as no adapter specified";
      throw new _(
        "There is no suitable adapter to dispatch the request " + o,
        "ERR_NOT_SUPPORT"
      );
    }
    return s;
  },
  adapters: Zn
};
function xn(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted)
    throw new ft(null, t);
}
function Hs(t) {
  return xn(t), t.headers = X.from(t.headers), t.data = Dn.call(
    t,
    t.transformRequest
  ), ["post", "put", "patch"].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), pi.getAdapter(t.adapter || Ct.adapter)(t).then(function(s) {
    return xn(t), s.data = Dn.call(
      t,
      t.transformResponse,
      s
    ), s.headers = X.from(s.headers), s;
  }, function(s) {
    return ui(s) || (xn(t), s && s.response && (s.response.data = Dn.call(
      t,
      t.transformResponse,
      s.response
    ), s.response.headers = X.from(s.response.headers))), Promise.reject(s);
  });
}
const yi = "1.7.7", ds = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((t, e) => {
  ds[t] = function(s) {
    return typeof s === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
const Zs = {};
ds.transitional = function(e, n, s) {
  function r(i, o) {
    return "[Axios v" + yi + "] Transitional option '" + i + "'" + o + (s ? ". " + s : "");
  }
  return (i, o, a) => {
    if (e === !1)
      throw new _(
        r(o, " has been removed" + (n ? " in " + n : "")),
        _.ERR_DEPRECATED
      );
    return n && !Zs[o] && (Zs[o] = !0, console.warn(
      r(
        o,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), e ? e(i, o, a) : !0;
  };
};
function zl(t, e, n) {
  if (typeof t != "object")
    throw new _("options must be an object", _.ERR_BAD_OPTION_VALUE);
  const s = Object.keys(t);
  let r = s.length;
  for (; r-- > 0; ) {
    const i = s[r], o = e[i];
    if (o) {
      const a = t[i], l = a === void 0 || o(a, i, t);
      if (l !== !0)
        throw new _("option " + i + " must be " + l, _.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new _("Unknown option " + i, _.ERR_BAD_OPTION);
  }
}
const Jn = {
  assertOptions: zl,
  validators: ds
}, Ne = Jn.validators;
class ze {
  constructor(e) {
    this.defaults = e, this.interceptors = {
      request: new Ls(),
      response: new Ls()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, n) {
    try {
      return await this._request(e, n);
    } catch (s) {
      if (s instanceof Error) {
        let r;
        Error.captureStackTrace ? Error.captureStackTrace(r = {}) : r = new Error();
        const i = r.stack ? r.stack.replace(/^.+\n/, "") : "";
        try {
          s.stack ? i && !String(s.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (s.stack += `
` + i) : s.stack = i;
        } catch {
        }
      }
      throw s;
    }
  }
  _request(e, n) {
    typeof e == "string" ? (n = n || {}, n.url = e) : n = e || {}, n = Je(this.defaults, n);
    const { transitional: s, paramsSerializer: r, headers: i } = n;
    s !== void 0 && Jn.assertOptions(s, {
      silentJSONParsing: Ne.transitional(Ne.boolean),
      forcedJSONParsing: Ne.transitional(Ne.boolean),
      clarifyTimeoutError: Ne.transitional(Ne.boolean)
    }, !1), r != null && (f.isFunction(r) ? n.paramsSerializer = {
      serialize: r
    } : Jn.assertOptions(r, {
      encode: Ne.function,
      serialize: Ne.function
    }, !0)), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let o = i && f.merge(
      i.common,
      i[n.method]
    );
    i && f.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (p) => {
        delete i[p];
      }
    ), n.headers = X.concat(o, i);
    const a = [];
    let l = !0;
    this.interceptors.request.forEach(function(v) {
      typeof v.runWhen == "function" && v.runWhen(n) === !1 || (l = l && v.synchronous, a.unshift(v.fulfilled, v.rejected));
    });
    const u = [];
    this.interceptors.response.forEach(function(v) {
      u.push(v.fulfilled, v.rejected);
    });
    let c, d = 0, m;
    if (!l) {
      const p = [Hs.bind(this), void 0];
      for (p.unshift.apply(p, a), p.push.apply(p, u), m = p.length, c = Promise.resolve(n); d < m; )
        c = c.then(p[d++], p[d++]);
      return c;
    }
    m = a.length;
    let h = n;
    for (d = 0; d < m; ) {
      const p = a[d++], v = a[d++];
      try {
        h = p(h);
      } catch (g) {
        v.call(this, g);
        break;
      }
    }
    try {
      c = Hs.call(this, h);
    } catch (p) {
      return Promise.reject(p);
    }
    for (d = 0, m = u.length; d < m; )
      c = c.then(u[d++], u[d++]);
    return c;
  }
  getUri(e) {
    e = Je(this.defaults, e);
    const n = di(e.baseURL, e.url);
    return oi(n, e.params, e.paramsSerializer);
  }
}
f.forEach(["delete", "get", "head", "options"], function(e) {
  ze.prototype[e] = function(n, s) {
    return this.request(Je(s || {}, {
      method: e,
      url: n,
      data: (s || {}).data
    }));
  };
});
f.forEach(["post", "put", "patch"], function(e) {
  function n(s) {
    return function(i, o, a) {
      return this.request(Je(a || {}, {
        method: e,
        headers: s ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: o
      }));
    };
  }
  ze.prototype[e] = n(), ze.prototype[e + "Form"] = n(!0);
});
class fs {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(i) {
      n = i;
    });
    const s = this;
    this.promise.then((r) => {
      if (!s._listeners) return;
      let i = s._listeners.length;
      for (; i-- > 0; )
        s._listeners[i](r);
      s._listeners = null;
    }), this.promise.then = (r) => {
      let i;
      const o = new Promise((a) => {
        s.subscribe(a), i = a;
      }).then(r);
      return o.cancel = function() {
        s.unsubscribe(i);
      }, o;
    }, e(function(i, o, a) {
      s.reason || (s.reason = new ft(i, o, a), n(s.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(e);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const e = new AbortController(), n = (s) => {
      e.abort(s);
    };
    return this.subscribe(n), e.signal.unsubscribe = () => this.unsubscribe(n), e.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let e;
    return {
      token: new fs(function(r) {
        e = r;
      }),
      cancel: e
    };
  }
}
function Hl(t) {
  return function(n) {
    return t.apply(null, n);
  };
}
function Zl(t) {
  return f.isObject(t) && t.isAxiosError === !0;
}
const Yn = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Yn).forEach(([t, e]) => {
  Yn[e] = t;
});
function gi(t) {
  const e = new ze(t), n = Jr(ze.prototype.request, e);
  return f.extend(n, ze.prototype, e, { allOwnKeys: !0 }), f.extend(n, e, null, { allOwnKeys: !0 }), n.create = function(r) {
    return gi(Je(t, r));
  }, n;
}
const R = gi(Ct);
R.Axios = ze;
R.CanceledError = ft;
R.CancelToken = fs;
R.isCancel = ui;
R.VERSION = yi;
R.toFormData = mn;
R.AxiosError = _;
R.Cancel = R.CanceledError;
R.all = function(e) {
  return Promise.all(e);
};
R.spread = Hl;
R.isAxiosError = Zl;
R.mergeConfig = Je;
R.AxiosHeaders = X;
R.formToJSON = (t) => li(f.isHTMLForm(t) ? new FormData(t) : t);
R.getAdapter = pi.getAdapter;
R.HttpStatusCode = Yn;
R.default = R;
const bi = (t, e) => {
  const n = t.__vccOpts || t;
  for (const [s, r] of e)
    n[s] = r;
  return n;
}, Jl = {}, Yl = {
  class: "pappas-eclub-spinner",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function Gl(t, e) {
  return S(), E("svg", Yl, e[0] || (e[0] = [
    D("circle", {
      cx: "12",
      cy: "12",
      r: "10",
      stroke: "currentColor",
      "stroke-width": "4"
    }, null, -1),
    D("path", {
      fill: "currentColor",
      d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    }, null, -1)
  ]));
}
const yn = /* @__PURE__ */ bi(Jl, [["render", Gl]]);
function wi() {
  const t = B({});
  function e(s) {
    Object.keys(s).forEach((i) => n(i, s[i][0]));
  }
  function n(s, r) {
    t.value[s] = r;
  }
  return { fieldErrors: t, addFieldErrors: e, addFieldError: n };
}
function Si() {
  const t = K("apiBase"), e = B(!0), n = B([]);
  We("locations", n);
  function s() {
    R.get(t + "/locations").then(({ data: r }) => n.value = r).catch((r) => console.error(r)).then(() => e.value = !1);
  }
  return s(), { locationsLoading: e, locations: n };
}
const Kl = {
  key: 0,
  class: "pappas-eclub-feedback-items"
}, Ql = { class: "pappas-eclub-feedback-item-message" }, Xl = {
  __name: "FormFeedback",
  setup(t) {
    const e = as();
    return (n, s) => (S(), E("div", null, [
      j(e).feedback.length ? (S(), E("div", Kl, [
        (S(!0), E(be, null, lt(j(e).feedback, (r) => (S(), E("div", null, [
          D("div", {
            class: He(["pappas-eclub-feedback-item", "pappas-eclub-feedback-item-" + r.type])
          }, [
            D("div", Ql, me(r.message), 1)
          ], 2)
        ]))), 256))
      ])) : Se("", !0)
    ]));
  }
}, eu = new RegExp("([\\p{Ll}\\d])(\\p{Lu})", "gu"), tu = new RegExp("(\\p{Lu})([\\p{Lu}][\\p{Ll}])", "gu"), nu = new RegExp("(\\d)\\p{Ll}|(\\p{L})\\d", "u"), su = /[^\p{L}\d]+/giu, Js = "$1\0$2", Ys = "";
function vi(t) {
  let e = t.trim();
  e = e.replace(eu, Js).replace(tu, Js), e = e.replace(su, "\0");
  let n = 0, s = e.length;
  for (; e.charAt(n) === "\0"; )
    n++;
  if (n === s)
    return [];
  for (; e.charAt(s - 1) === "\0"; )
    s--;
  return e.slice(n, s).split(/\0/g);
}
function ru(t) {
  const e = vi(t);
  for (let n = 0; n < e.length; n++) {
    const s = e[n], r = nu.exec(s);
    if (r) {
      const i = r.index + (r[1] ?? r[2]).length;
      e.splice(n, 1, s.slice(0, i), s.slice(i));
    }
  }
  return e;
}
function iu(t, e) {
  const [n, s, r] = uu(t, e), i = ou(e == null ? void 0 : e.locale), o = au(e == null ? void 0 : e.locale);
  return n + s.map(lu(i, o)).join(" ") + r;
}
function ou(t) {
  return (e) => e.toLocaleLowerCase(t);
}
function au(t) {
  return (e) => e.toLocaleUpperCase(t);
}
function lu(t, e) {
  return (n) => `${e(n[0])}${t(n.slice(1))}`;
}
function uu(t, e = {}) {
  const n = e.split ?? (e.separateNumbers ? ru : vi), s = e.prefixCharacters ?? Ys, r = e.suffixCharacters ?? Ys;
  let i = 0, o = t.length;
  for (; i < t.length; ) {
    const a = t.charAt(i);
    if (!s.includes(a))
      break;
    i++;
  }
  for (; o > i; ) {
    const a = o - 1, l = t.charAt(a);
    if (!r.includes(l))
      break;
    o = a;
  }
  return [
    t.slice(0, i),
    n(t.slice(i, o)),
    t.slice(o)
  ];
}
const cu = ["type", "name", "required", "disabled", "inputmode"], du = {
  __name: "TextInput",
  props: /* @__PURE__ */ Fe({
    type: { type: String, default: "text" },
    name: { type: String, required: !0 },
    required: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    placeholder: { type: String, default: null },
    inputmode: { type: String, default: "text" }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = It(t, "modelValue");
    return (n, s) => Te((S(), E("input", {
      type: t.type,
      name: t.name,
      "onUpdate:modelValue": s[0] || (s[0] = (r) => e.value = r),
      required: t.required,
      disabled: t.disabled,
      inputmode: t.inputmode
    }, null, 8, cu)), [
      [Io, e.value]
    ]);
  }
};
class Ye extends Error {
}
class fu extends Ye {
  constructor(e) {
    super(`Invalid DateTime: ${e.toMessage()}`);
  }
}
class hu extends Ye {
  constructor(e) {
    super(`Invalid Interval: ${e.toMessage()}`);
  }
}
class mu extends Ye {
  constructor(e) {
    super(`Invalid Duration: ${e.toMessage()}`);
  }
}
class it extends Ye {
}
class Oi extends Ye {
  constructor(e) {
    super(`Invalid unit ${e}`);
  }
}
class J extends Ye {
}
class _e extends Ye {
  constructor() {
    super("Zone is an abstract class");
  }
}
const y = "numeric", pe = "short", ne = "long", an = {
  year: y,
  month: y,
  day: y
}, Ei = {
  year: y,
  month: pe,
  day: y
}, pu = {
  year: y,
  month: pe,
  day: y,
  weekday: pe
}, Ti = {
  year: y,
  month: ne,
  day: y
}, ki = {
  year: y,
  month: ne,
  day: y,
  weekday: ne
}, Ni = {
  hour: y,
  minute: y
}, _i = {
  hour: y,
  minute: y,
  second: y
}, Di = {
  hour: y,
  minute: y,
  second: y,
  timeZoneName: pe
}, xi = {
  hour: y,
  minute: y,
  second: y,
  timeZoneName: ne
}, Ii = {
  hour: y,
  minute: y,
  hourCycle: "h23"
}, Vi = {
  hour: y,
  minute: y,
  second: y,
  hourCycle: "h23"
}, Ci = {
  hour: y,
  minute: y,
  second: y,
  hourCycle: "h23",
  timeZoneName: pe
}, Ai = {
  hour: y,
  minute: y,
  second: y,
  hourCycle: "h23",
  timeZoneName: ne
}, Fi = {
  year: y,
  month: y,
  day: y,
  hour: y,
  minute: y
}, Mi = {
  year: y,
  month: y,
  day: y,
  hour: y,
  minute: y,
  second: y
}, Ri = {
  year: y,
  month: pe,
  day: y,
  hour: y,
  minute: y
}, $i = {
  year: y,
  month: pe,
  day: y,
  hour: y,
  minute: y,
  second: y
}, yu = {
  year: y,
  month: pe,
  day: y,
  weekday: pe,
  hour: y,
  minute: y
}, Li = {
  year: y,
  month: ne,
  day: y,
  hour: y,
  minute: y,
  timeZoneName: pe
}, Pi = {
  year: y,
  month: ne,
  day: y,
  hour: y,
  minute: y,
  second: y,
  timeZoneName: pe
}, Ui = {
  year: y,
  month: ne,
  day: y,
  weekday: ne,
  hour: y,
  minute: y,
  timeZoneName: ne
}, Wi = {
  year: y,
  month: ne,
  day: y,
  weekday: ne,
  hour: y,
  minute: y,
  second: y,
  timeZoneName: ne
};
class At {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new _e();
  }
  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new _e();
  }
  /**
   * The IANA name of this zone.
   * Defaults to `name` if not overwritten by a subclass.
   * @abstract
   * @type {string}
   */
  get ianaName() {
    return this.name;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new _e();
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(e, n) {
    throw new _e();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(e, n) {
    throw new _e();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(e) {
    throw new _e();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(e) {
    throw new _e();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new _e();
  }
}
let In = null;
class gn extends At {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    return In === null && (In = new gn()), In;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName(e, { format: n, locale: s }) {
    return Gi(e, n, s);
  }
  /** @override **/
  formatOffset(e, n) {
    return Et(this.offset(e), n);
  }
  /** @override **/
  offset(e) {
    return -new Date(e).getTimezoneOffset();
  }
  /** @override **/
  equals(e) {
    return e.type === "system";
  }
  /** @override **/
  get isValid() {
    return !0;
  }
}
let Kt = {};
function gu(t) {
  return Kt[t] || (Kt[t] = new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: t,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    era: "short"
  })), Kt[t];
}
const bu = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function wu(t, e) {
  const n = t.format(e).replace(/\u200E/g, ""), s = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(n), [, r, i, o, a, l, u, c] = s;
  return [o, r, i, a, l, u, c];
}
function Su(t, e) {
  const n = t.formatToParts(e), s = [];
  for (let r = 0; r < n.length; r++) {
    const { type: i, value: o } = n[r], a = bu[i];
    i === "era" ? s[a] = o : N(a) || (s[a] = parseInt(o, 10));
  }
  return s;
}
let Lt = {};
class ke extends At {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(e) {
    return Lt[e] || (Lt[e] = new ke(e)), Lt[e];
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    Lt = {}, Kt = {};
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
   * @return {boolean}
   */
  static isValidSpecifier(e) {
    return this.isValidZone(e);
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(e) {
    if (!e)
      return !1;
    try {
      return new Intl.DateTimeFormat("en-US", { timeZone: e }).format(), !0;
    } catch {
      return !1;
    }
  }
  constructor(e) {
    super(), this.zoneName = e, this.valid = ke.isValidZone(e);
  }
  /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "iana";
  }
  /**
   * The name of this zone (i.e. the IANA zone name).
   * @override
   * @type {string}
   */
  get name() {
    return this.zoneName;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns false for all IANA zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return !1;
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(e, { format: n, locale: s }) {
    return Gi(e, n, s, this.name);
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(e, n) {
    return Et(this.offset(e), n);
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @override
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(e) {
    const n = new Date(e);
    if (isNaN(n)) return NaN;
    const s = gu(this.name);
    let [r, i, o, a, l, u, c] = s.formatToParts ? Su(s, n) : wu(s, n);
    a === "BC" && (r = -Math.abs(r) + 1);
    const m = wn({
      year: r,
      month: i,
      day: o,
      hour: l === 24 ? 0 : l,
      minute: u,
      second: c,
      millisecond: 0
    });
    let h = +n;
    const p = h % 1e3;
    return h -= p >= 0 ? p : 1e3 + p, (m - h) / (60 * 1e3);
  }
  /**
   * Return whether this Zone is equal to another zone
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(e) {
    return e.type === "iana" && e.name === this.name;
  }
  /**
   * Return whether this Zone is valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return this.valid;
  }
}
let Gs = {};
function vu(t, e = {}) {
  const n = JSON.stringify([t, e]);
  let s = Gs[n];
  return s || (s = new Intl.ListFormat(t, e), Gs[n] = s), s;
}
let Gn = {};
function Kn(t, e = {}) {
  const n = JSON.stringify([t, e]);
  let s = Gn[n];
  return s || (s = new Intl.DateTimeFormat(t, e), Gn[n] = s), s;
}
let Qn = {};
function Ou(t, e = {}) {
  const n = JSON.stringify([t, e]);
  let s = Qn[n];
  return s || (s = new Intl.NumberFormat(t, e), Qn[n] = s), s;
}
let Xn = {};
function Eu(t, e = {}) {
  const { base: n, ...s } = e, r = JSON.stringify([t, s]);
  let i = Xn[r];
  return i || (i = new Intl.RelativeTimeFormat(t, e), Xn[r] = i), i;
}
let vt = null;
function Tu() {
  return vt || (vt = new Intl.DateTimeFormat().resolvedOptions().locale, vt);
}
let Ks = {};
function ku(t) {
  let e = Ks[t];
  if (!e) {
    const n = new Intl.Locale(t);
    e = "getWeekInfo" in n ? n.getWeekInfo() : n.weekInfo, Ks[t] = e;
  }
  return e;
}
function Nu(t) {
  const e = t.indexOf("-x-");
  e !== -1 && (t = t.substring(0, e));
  const n = t.indexOf("-u-");
  if (n === -1)
    return [t];
  {
    let s, r;
    try {
      s = Kn(t).resolvedOptions(), r = t;
    } catch {
      const l = t.substring(0, n);
      s = Kn(l).resolvedOptions(), r = l;
    }
    const { numberingSystem: i, calendar: o } = s;
    return [r, i, o];
  }
}
function _u(t, e, n) {
  return (n || e) && (t.includes("-u-") || (t += "-u"), n && (t += `-ca-${n}`), e && (t += `-nu-${e}`)), t;
}
function Du(t) {
  const e = [];
  for (let n = 1; n <= 12; n++) {
    const s = k.utc(2009, n, 1);
    e.push(t(s));
  }
  return e;
}
function xu(t) {
  const e = [];
  for (let n = 1; n <= 7; n++) {
    const s = k.utc(2016, 11, 13 + n);
    e.push(t(s));
  }
  return e;
}
function Pt(t, e, n, s) {
  const r = t.listingMode();
  return r === "error" ? null : r === "en" ? n(e) : s(e);
}
function Iu(t) {
  return t.numberingSystem && t.numberingSystem !== "latn" ? !1 : t.numberingSystem === "latn" || !t.locale || t.locale.startsWith("en") || new Intl.DateTimeFormat(t.intl).resolvedOptions().numberingSystem === "latn";
}
class Vu {
  constructor(e, n, s) {
    this.padTo = s.padTo || 0, this.floor = s.floor || !1;
    const { padTo: r, floor: i, ...o } = s;
    if (!n || Object.keys(o).length > 0) {
      const a = { useGrouping: !1, ...s };
      s.padTo > 0 && (a.minimumIntegerDigits = s.padTo), this.inf = Ou(e, a);
    }
  }
  format(e) {
    if (this.inf) {
      const n = this.floor ? Math.floor(e) : e;
      return this.inf.format(n);
    } else {
      const n = this.floor ? Math.floor(e) : gs(e, 3);
      return q(n, this.padTo);
    }
  }
}
class Cu {
  constructor(e, n, s) {
    this.opts = s, this.originalZone = void 0;
    let r;
    if (this.opts.timeZone)
      this.dt = e;
    else if (e.zone.type === "fixed") {
      const o = -1 * (e.offset / 60), a = o >= 0 ? `Etc/GMT+${o}` : `Etc/GMT${o}`;
      e.offset !== 0 && ke.create(a).valid ? (r = a, this.dt = e) : (r = "UTC", this.dt = e.offset === 0 ? e : e.setZone("UTC").plus({ minutes: e.offset }), this.originalZone = e.zone);
    } else e.zone.type === "system" ? this.dt = e : e.zone.type === "iana" ? (this.dt = e, r = e.zone.name) : (r = "UTC", this.dt = e.setZone("UTC").plus({ minutes: e.offset }), this.originalZone = e.zone);
    const i = { ...this.opts };
    i.timeZone = i.timeZone || r, this.dtf = Kn(n, i);
  }
  format() {
    return this.originalZone ? this.formatToParts().map(({ value: e }) => e).join("") : this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    const e = this.dtf.formatToParts(this.dt.toJSDate());
    return this.originalZone ? e.map((n) => {
      if (n.type === "timeZoneName") {
        const s = this.originalZone.offsetName(this.dt.ts, {
          locale: this.dt.locale,
          format: this.opts.timeZoneName
        });
        return {
          ...n,
          value: s
        };
      } else
        return n;
    }) : e;
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}
class Au {
  constructor(e, n, s) {
    this.opts = { style: "long", ...s }, !n && Ji() && (this.rtf = Eu(e, s));
  }
  format(e, n) {
    return this.rtf ? this.rtf.format(e, n) : nc(n, e, this.opts.numeric, this.opts.style !== "long");
  }
  formatToParts(e, n) {
    return this.rtf ? this.rtf.formatToParts(e, n) : [];
  }
}
const Fu = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [6, 7]
};
class A {
  static fromOpts(e) {
    return A.create(
      e.locale,
      e.numberingSystem,
      e.outputCalendar,
      e.weekSettings,
      e.defaultToEN
    );
  }
  static create(e, n, s, r, i = !1) {
    const o = e || P.defaultLocale, a = o || (i ? "en-US" : Tu()), l = n || P.defaultNumberingSystem, u = s || P.defaultOutputCalendar, c = es(r) || P.defaultWeekSettings;
    return new A(a, l, u, c, o);
  }
  static resetCache() {
    vt = null, Gn = {}, Qn = {}, Xn = {};
  }
  static fromObject({ locale: e, numberingSystem: n, outputCalendar: s, weekSettings: r } = {}) {
    return A.create(e, n, s, r);
  }
  constructor(e, n, s, r, i) {
    const [o, a, l] = Nu(e);
    this.locale = o, this.numberingSystem = n || a || null, this.outputCalendar = s || l || null, this.weekSettings = r, this.intl = _u(this.locale, this.numberingSystem, this.outputCalendar), this.weekdaysCache = { format: {}, standalone: {} }, this.monthsCache = { format: {}, standalone: {} }, this.meridiemCache = null, this.eraCache = {}, this.specifiedLocale = i, this.fastNumbersCached = null;
  }
  get fastNumbers() {
    return this.fastNumbersCached == null && (this.fastNumbersCached = Iu(this)), this.fastNumbersCached;
  }
  listingMode() {
    const e = this.isEnglish(), n = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return e && n ? "en" : "intl";
  }
  clone(e) {
    return !e || Object.getOwnPropertyNames(e).length === 0 ? this : A.create(
      e.locale || this.specifiedLocale,
      e.numberingSystem || this.numberingSystem,
      e.outputCalendar || this.outputCalendar,
      es(e.weekSettings) || this.weekSettings,
      e.defaultToEN || !1
    );
  }
  redefaultToEN(e = {}) {
    return this.clone({ ...e, defaultToEN: !0 });
  }
  redefaultToSystem(e = {}) {
    return this.clone({ ...e, defaultToEN: !1 });
  }
  months(e, n = !1) {
    return Pt(this, e, Xi, () => {
      const s = n ? { month: e, day: "numeric" } : { month: e }, r = n ? "format" : "standalone";
      return this.monthsCache[r][e] || (this.monthsCache[r][e] = Du((i) => this.extract(i, s, "month"))), this.monthsCache[r][e];
    });
  }
  weekdays(e, n = !1) {
    return Pt(this, e, no, () => {
      const s = n ? { weekday: e, year: "numeric", month: "long", day: "numeric" } : { weekday: e }, r = n ? "format" : "standalone";
      return this.weekdaysCache[r][e] || (this.weekdaysCache[r][e] = xu(
        (i) => this.extract(i, s, "weekday")
      )), this.weekdaysCache[r][e];
    });
  }
  meridiems() {
    return Pt(
      this,
      void 0,
      () => so,
      () => {
        if (!this.meridiemCache) {
          const e = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [k.utc(2016, 11, 13, 9), k.utc(2016, 11, 13, 19)].map(
            (n) => this.extract(n, e, "dayperiod")
          );
        }
        return this.meridiemCache;
      }
    );
  }
  eras(e) {
    return Pt(this, e, ro, () => {
      const n = { era: e };
      return this.eraCache[e] || (this.eraCache[e] = [k.utc(-40, 1, 1), k.utc(2017, 1, 1)].map(
        (s) => this.extract(s, n, "era")
      )), this.eraCache[e];
    });
  }
  extract(e, n, s) {
    const r = this.dtFormatter(e, n), i = r.formatToParts(), o = i.find((a) => a.type.toLowerCase() === s);
    return o ? o.value : null;
  }
  numberFormatter(e = {}) {
    return new Vu(this.intl, e.forceSimple || this.fastNumbers, e);
  }
  dtFormatter(e, n = {}) {
    return new Cu(e, this.intl, n);
  }
  relFormatter(e = {}) {
    return new Au(this.intl, this.isEnglish(), e);
  }
  listFormatter(e = {}) {
    return vu(this.intl, e);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
  }
  getWeekSettings() {
    return this.weekSettings ? this.weekSettings : Yi() ? ku(this.locale) : Fu;
  }
  getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  }
  getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  }
  getWeekendDays() {
    return this.getWeekSettings().weekend;
  }
  equals(e) {
    return this.locale === e.locale && this.numberingSystem === e.numberingSystem && this.outputCalendar === e.outputCalendar;
  }
  toString() {
    return `Locale(${this.locale}, ${this.numberingSystem}, ${this.outputCalendar})`;
  }
}
let Vn = null;
class G extends At {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    return Vn === null && (Vn = new G(0)), Vn;
  }
  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(e) {
    return e === 0 ? G.utcInstance : new G(e);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(e) {
    if (e) {
      const n = e.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (n)
        return new G(Sn(n[1], n[2]));
    }
    return null;
  }
  constructor(e) {
    super(), this.fixed = e;
  }
  /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "fixed";
  }
  /**
   * The name of this zone.
   * All fixed zones' names always start with "UTC" (plus optional offset)
   * @override
   * @type {string}
   */
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${Et(this.fixed, "narrow")}`;
  }
  /**
   * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
   *
   * @override
   * @type {string}
   */
  get ianaName() {
    return this.fixed === 0 ? "Etc/UTC" : `Etc/GMT${Et(-this.fixed, "narrow")}`;
  }
  /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */
  offsetName() {
    return this.name;
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(e, n) {
    return Et(this.fixed, n);
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns true for all fixed offset zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return !0;
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */
  offset() {
    return this.fixed;
  }
  /**
   * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(e) {
    return e.type === "fixed" && e.fixed === this.fixed;
  }
  /**
   * Return whether this Zone is valid:
   * All fixed offset zones are valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return !0;
  }
}
class Mu extends At {
  constructor(e) {
    super(), this.zoneName = e;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return !1;
  }
  /** @override **/
  get isValid() {
    return !1;
  }
}
function Ie(t, e) {
  if (N(t) || t === null)
    return e;
  if (t instanceof At)
    return t;
  if (Wu(t)) {
    const n = t.toLowerCase();
    return n === "default" ? e : n === "local" || n === "system" ? gn.instance : n === "utc" || n === "gmt" ? G.utcInstance : G.parseSpecifier(n) || ke.create(t);
  } else return Ce(t) ? G.instance(t) : typeof t == "object" && "offset" in t && typeof t.offset == "function" ? t : new Mu(t);
}
const hs = {
  arab: "[٠-٩]",
  arabext: "[۰-۹]",
  bali: "[᭐-᭙]",
  beng: "[০-৯]",
  deva: "[०-९]",
  fullwide: "[０-９]",
  gujr: "[૦-૯]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[០-៩]",
  knda: "[೦-೯]",
  laoo: "[໐-໙]",
  limb: "[᥆-᥏]",
  mlym: "[൦-൯]",
  mong: "[᠐-᠙]",
  mymr: "[၀-၉]",
  orya: "[୦-୯]",
  tamldec: "[௦-௯]",
  telu: "[౦-౯]",
  thai: "[๐-๙]",
  tibt: "[༠-༩]",
  latn: "\\d"
}, Qs = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
}, Ru = hs.hanidec.replace(/[\[|\]]/g, "").split("");
function $u(t) {
  let e = parseInt(t, 10);
  if (isNaN(e)) {
    e = "";
    for (let n = 0; n < t.length; n++) {
      const s = t.charCodeAt(n);
      if (t[n].search(hs.hanidec) !== -1)
        e += Ru.indexOf(t[n]);
      else
        for (const r in Qs) {
          const [i, o] = Qs[r];
          s >= i && s <= o && (e += s - i);
        }
    }
    return parseInt(e, 10);
  } else
    return e;
}
let nt = {};
function Lu() {
  nt = {};
}
function ce({ numberingSystem: t }, e = "") {
  const n = t || "latn";
  return nt[n] || (nt[n] = {}), nt[n][e] || (nt[n][e] = new RegExp(`${hs[n]}${e}`)), nt[n][e];
}
let Xs = () => Date.now(), er = "system", tr = null, nr = null, sr = null, rr = 60, ir, or = null;
class P {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return Xs;
  }
  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(e) {
    Xs = e;
  }
  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(e) {
    er = e;
  }
  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return Ie(er, gn.instance);
  }
  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return tr;
  }
  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(e) {
    tr = e;
  }
  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return nr;
  }
  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(e) {
    nr = e;
  }
  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return sr;
  }
  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(e) {
    sr = e;
  }
  /**
   * @typedef {Object} WeekSettings
   * @property {number} firstDay
   * @property {number} minimalDays
   * @property {number[]} weekend
   */
  /**
   * @return {WeekSettings|null}
   */
  static get defaultWeekSettings() {
    return or;
  }
  /**
   * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
   * how many days are required in the first week of a year.
   * Does not affect existing instances.
   *
   * @param {WeekSettings|null} weekSettings
   */
  static set defaultWeekSettings(e) {
    or = es(e);
  }
  /**
   * Get the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   */
  static get twoDigitCutoffYear() {
    return rr;
  }
  /**
   * Set the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // all 'yy' are interpreted as 20th century
   * @example Settings.twoDigitCutoffYear = 99 // all 'yy' are interpreted as 21st century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 2049; '50' -> 1950
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */
  static set twoDigitCutoffYear(e) {
    rr = e % 100;
  }
  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return ir;
  }
  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(e) {
    ir = e;
  }
  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    A.resetCache(), ke.resetCache(), k.resetCache(), Lu();
  }
}
class he {
  constructor(e, n) {
    this.reason = e, this.explanation = n;
  }
  toMessage() {
    return this.explanation ? `${this.reason}: ${this.explanation}` : this.reason;
  }
}
const qi = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], Bi = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function ae(t, e) {
  return new he(
    "unit out of range",
    `you specified ${e} (of type ${typeof e}) as a ${t}, which is invalid`
  );
}
function ms(t, e, n) {
  const s = new Date(Date.UTC(t, e - 1, n));
  t < 100 && t >= 0 && s.setUTCFullYear(s.getUTCFullYear() - 1900);
  const r = s.getUTCDay();
  return r === 0 ? 7 : r;
}
function ji(t, e, n) {
  return n + (Ft(t) ? Bi : qi)[e - 1];
}
function zi(t, e) {
  const n = Ft(t) ? Bi : qi, s = n.findIndex((i) => i < e), r = e - n[s];
  return { month: s + 1, day: r };
}
function ps(t, e) {
  return (t - e + 7) % 7 + 1;
}
function ln(t, e = 4, n = 1) {
  const { year: s, month: r, day: i } = t, o = ji(s, r, i), a = ps(ms(s, r, i), n);
  let l = Math.floor((o - a + 14 - e) / 7), u;
  return l < 1 ? (u = s - 1, l = xt(u, e, n)) : l > xt(s, e, n) ? (u = s + 1, l = 1) : u = s, { weekYear: u, weekNumber: l, weekday: a, ...vn(t) };
}
function ar(t, e = 4, n = 1) {
  const { weekYear: s, weekNumber: r, weekday: i } = t, o = ps(ms(s, 1, e), n), a = ot(s);
  let l = r * 7 + i - o - 7 + e, u;
  l < 1 ? (u = s - 1, l += ot(u)) : l > a ? (u = s + 1, l -= ot(s)) : u = s;
  const { month: c, day: d } = zi(u, l);
  return { year: u, month: c, day: d, ...vn(t) };
}
function Cn(t) {
  const { year: e, month: n, day: s } = t, r = ji(e, n, s);
  return { year: e, ordinal: r, ...vn(t) };
}
function lr(t) {
  const { year: e, ordinal: n } = t, { month: s, day: r } = zi(e, n);
  return { year: e, month: s, day: r, ...vn(t) };
}
function ur(t, e) {
  if (!N(t.localWeekday) || !N(t.localWeekNumber) || !N(t.localWeekYear)) {
    if (!N(t.weekday) || !N(t.weekNumber) || !N(t.weekYear))
      throw new it(
        "Cannot mix locale-based week fields with ISO-based week fields"
      );
    return N(t.localWeekday) || (t.weekday = t.localWeekday), N(t.localWeekNumber) || (t.weekNumber = t.localWeekNumber), N(t.localWeekYear) || (t.weekYear = t.localWeekYear), delete t.localWeekday, delete t.localWeekNumber, delete t.localWeekYear, {
      minDaysInFirstWeek: e.getMinDaysInFirstWeek(),
      startOfWeek: e.getStartOfWeek()
    };
  } else
    return { minDaysInFirstWeek: 4, startOfWeek: 1 };
}
function Pu(t, e = 4, n = 1) {
  const s = bn(t.weekYear), r = le(
    t.weekNumber,
    1,
    xt(t.weekYear, e, n)
  ), i = le(t.weekday, 1, 7);
  return s ? r ? i ? !1 : ae("weekday", t.weekday) : ae("week", t.weekNumber) : ae("weekYear", t.weekYear);
}
function Uu(t) {
  const e = bn(t.year), n = le(t.ordinal, 1, ot(t.year));
  return e ? n ? !1 : ae("ordinal", t.ordinal) : ae("year", t.year);
}
function Hi(t) {
  const e = bn(t.year), n = le(t.month, 1, 12), s = le(t.day, 1, un(t.year, t.month));
  return e ? n ? s ? !1 : ae("day", t.day) : ae("month", t.month) : ae("year", t.year);
}
function Zi(t) {
  const { hour: e, minute: n, second: s, millisecond: r } = t, i = le(e, 0, 23) || e === 24 && n === 0 && s === 0 && r === 0, o = le(n, 0, 59), a = le(s, 0, 59), l = le(r, 0, 999);
  return i ? o ? a ? l ? !1 : ae("millisecond", r) : ae("second", s) : ae("minute", n) : ae("hour", e);
}
function N(t) {
  return typeof t > "u";
}
function Ce(t) {
  return typeof t == "number";
}
function bn(t) {
  return typeof t == "number" && t % 1 === 0;
}
function Wu(t) {
  return typeof t == "string";
}
function qu(t) {
  return Object.prototype.toString.call(t) === "[object Date]";
}
function Ji() {
  try {
    return typeof Intl < "u" && !!Intl.RelativeTimeFormat;
  } catch {
    return !1;
  }
}
function Yi() {
  try {
    return typeof Intl < "u" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
  } catch {
    return !1;
  }
}
function Bu(t) {
  return Array.isArray(t) ? t : [t];
}
function cr(t, e, n) {
  if (t.length !== 0)
    return t.reduce((s, r) => {
      const i = [e(r), r];
      return s && n(s[0], i[0]) === s[0] ? s : i;
    }, null)[1];
}
function ju(t, e) {
  return e.reduce((n, s) => (n[s] = t[s], n), {});
}
function ct(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
function es(t) {
  if (t == null)
    return null;
  if (typeof t != "object")
    throw new J("Week settings must be an object");
  if (!le(t.firstDay, 1, 7) || !le(t.minimalDays, 1, 7) || !Array.isArray(t.weekend) || t.weekend.some((e) => !le(e, 1, 7)))
    throw new J("Invalid week settings");
  return {
    firstDay: t.firstDay,
    minimalDays: t.minimalDays,
    weekend: Array.from(t.weekend)
  };
}
function le(t, e, n) {
  return bn(t) && t >= e && t <= n;
}
function zu(t, e) {
  return t - e * Math.floor(t / e);
}
function q(t, e = 2) {
  const n = t < 0;
  let s;
  return n ? s = "-" + ("" + -t).padStart(e, "0") : s = ("" + t).padStart(e, "0"), s;
}
function xe(t) {
  if (!(N(t) || t === null || t === ""))
    return parseInt(t, 10);
}
function Re(t) {
  if (!(N(t) || t === null || t === ""))
    return parseFloat(t);
}
function ys(t) {
  if (!(N(t) || t === null || t === "")) {
    const e = parseFloat("0." + t) * 1e3;
    return Math.floor(e);
  }
}
function gs(t, e, n = !1) {
  const s = 10 ** e;
  return (n ? Math.trunc : Math.round)(t * s) / s;
}
function Ft(t) {
  return t % 4 === 0 && (t % 100 !== 0 || t % 400 === 0);
}
function ot(t) {
  return Ft(t) ? 366 : 365;
}
function un(t, e) {
  const n = zu(e - 1, 12) + 1, s = t + (e - n) / 12;
  return n === 2 ? Ft(s) ? 29 : 28 : [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][n - 1];
}
function wn(t) {
  let e = Date.UTC(
    t.year,
    t.month - 1,
    t.day,
    t.hour,
    t.minute,
    t.second,
    t.millisecond
  );
  return t.year < 100 && t.year >= 0 && (e = new Date(e), e.setUTCFullYear(t.year, t.month - 1, t.day)), +e;
}
function dr(t, e, n) {
  return -ps(ms(t, 1, e), n) + e - 1;
}
function xt(t, e = 4, n = 1) {
  const s = dr(t, e, n), r = dr(t + 1, e, n);
  return (ot(t) - s + r) / 7;
}
function ts(t) {
  return t > 99 ? t : t > P.twoDigitCutoffYear ? 1900 + t : 2e3 + t;
}
function Gi(t, e, n, s = null) {
  const r = new Date(t), i = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  s && (i.timeZone = s);
  const o = { timeZoneName: e, ...i }, a = new Intl.DateTimeFormat(n, o).formatToParts(r).find((l) => l.type.toLowerCase() === "timezonename");
  return a ? a.value : null;
}
function Sn(t, e) {
  let n = parseInt(t, 10);
  Number.isNaN(n) && (n = 0);
  const s = parseInt(e, 10) || 0, r = n < 0 || Object.is(n, -0) ? -s : s;
  return n * 60 + r;
}
function Ki(t) {
  const e = Number(t);
  if (typeof t == "boolean" || t === "" || Number.isNaN(e))
    throw new J(`Invalid unit value ${t}`);
  return e;
}
function cn(t, e) {
  const n = {};
  for (const s in t)
    if (ct(t, s)) {
      const r = t[s];
      if (r == null) continue;
      n[e(s)] = Ki(r);
    }
  return n;
}
function Et(t, e) {
  const n = Math.trunc(Math.abs(t / 60)), s = Math.trunc(Math.abs(t % 60)), r = t >= 0 ? "+" : "-";
  switch (e) {
    case "short":
      return `${r}${q(n, 2)}:${q(s, 2)}`;
    case "narrow":
      return `${r}${n}${s > 0 ? `:${s}` : ""}`;
    case "techie":
      return `${r}${q(n, 2)}${q(s, 2)}`;
    default:
      throw new RangeError(`Value format ${e} is out of range for property format`);
  }
}
function vn(t) {
  return ju(t, ["hour", "minute", "second", "millisecond"]);
}
const Hu = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], Qi = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
], Zu = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function Xi(t) {
  switch (t) {
    case "narrow":
      return [...Zu];
    case "short":
      return [...Qi];
    case "long":
      return [...Hu];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
const eo = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
], to = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], Ju = ["M", "T", "W", "T", "F", "S", "S"];
function no(t) {
  switch (t) {
    case "narrow":
      return [...Ju];
    case "short":
      return [...to];
    case "long":
      return [...eo];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
const so = ["AM", "PM"], Yu = ["Before Christ", "Anno Domini"], Gu = ["BC", "AD"], Ku = ["B", "A"];
function ro(t) {
  switch (t) {
    case "narrow":
      return [...Ku];
    case "short":
      return [...Gu];
    case "long":
      return [...Yu];
    default:
      return null;
  }
}
function Qu(t) {
  return so[t.hour < 12 ? 0 : 1];
}
function Xu(t, e) {
  return no(e)[t.weekday - 1];
}
function ec(t, e) {
  return Xi(e)[t.month - 1];
}
function tc(t, e) {
  return ro(e)[t.year < 0 ? 0 : 1];
}
function nc(t, e, n = "always", s = !1) {
  const r = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  }, i = ["hours", "minutes", "seconds"].indexOf(t) === -1;
  if (n === "auto" && i) {
    const d = t === "days";
    switch (e) {
      case 1:
        return d ? "tomorrow" : `next ${r[t][0]}`;
      case -1:
        return d ? "yesterday" : `last ${r[t][0]}`;
      case 0:
        return d ? "today" : `this ${r[t][0]}`;
    }
  }
  const o = Object.is(e, -0) || e < 0, a = Math.abs(e), l = a === 1, u = r[t], c = s ? l ? u[1] : u[2] || u[1] : l ? r[t][0] : t;
  return o ? `${a} ${c} ago` : `in ${a} ${c}`;
}
function fr(t, e) {
  let n = "";
  for (const s of t)
    s.literal ? n += s.val : n += e(s.val);
  return n;
}
const sc = {
  D: an,
  DD: Ei,
  DDD: Ti,
  DDDD: ki,
  t: Ni,
  tt: _i,
  ttt: Di,
  tttt: xi,
  T: Ii,
  TT: Vi,
  TTT: Ci,
  TTTT: Ai,
  f: Fi,
  ff: Ri,
  fff: Li,
  ffff: Ui,
  F: Mi,
  FF: $i,
  FFF: Pi,
  FFFF: Wi
};
class Y {
  static create(e, n = {}) {
    return new Y(e, n);
  }
  static parseFormat(e) {
    let n = null, s = "", r = !1;
    const i = [];
    for (let o = 0; o < e.length; o++) {
      const a = e.charAt(o);
      a === "'" ? (s.length > 0 && i.push({ literal: r || /^\s+$/.test(s), val: s }), n = null, s = "", r = !r) : r || a === n ? s += a : (s.length > 0 && i.push({ literal: /^\s+$/.test(s), val: s }), s = a, n = a);
    }
    return s.length > 0 && i.push({ literal: r || /^\s+$/.test(s), val: s }), i;
  }
  static macroTokenToFormatOpts(e) {
    return sc[e];
  }
  constructor(e, n) {
    this.opts = n, this.loc = e, this.systemLoc = null;
  }
  formatWithSystemDefault(e, n) {
    return this.systemLoc === null && (this.systemLoc = this.loc.redefaultToSystem()), this.systemLoc.dtFormatter(e, { ...this.opts, ...n }).format();
  }
  dtFormatter(e, n = {}) {
    return this.loc.dtFormatter(e, { ...this.opts, ...n });
  }
  formatDateTime(e, n) {
    return this.dtFormatter(e, n).format();
  }
  formatDateTimeParts(e, n) {
    return this.dtFormatter(e, n).formatToParts();
  }
  formatInterval(e, n) {
    return this.dtFormatter(e.start, n).dtf.formatRange(e.start.toJSDate(), e.end.toJSDate());
  }
  resolvedOptions(e, n) {
    return this.dtFormatter(e, n).resolvedOptions();
  }
  num(e, n = 0) {
    if (this.opts.forceSimple)
      return q(e, n);
    const s = { ...this.opts };
    return n > 0 && (s.padTo = n), this.loc.numberFormatter(s).format(e);
  }
  formatDateTimeFromString(e, n) {
    const s = this.loc.listingMode() === "en", r = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", i = (h, p) => this.loc.extract(e, h, p), o = (h) => e.isOffsetFixed && e.offset === 0 && h.allowZ ? "Z" : e.isValid ? e.zone.formatOffset(e.ts, h.format) : "", a = () => s ? Qu(e) : i({ hour: "numeric", hourCycle: "h12" }, "dayperiod"), l = (h, p) => s ? ec(e, h) : i(p ? { month: h } : { month: h, day: "numeric" }, "month"), u = (h, p) => s ? Xu(e, h) : i(
      p ? { weekday: h } : { weekday: h, month: "long", day: "numeric" },
      "weekday"
    ), c = (h) => {
      const p = Y.macroTokenToFormatOpts(h);
      return p ? this.formatWithSystemDefault(e, p) : h;
    }, d = (h) => s ? tc(e, h) : i({ era: h }, "era"), m = (h) => {
      switch (h) {
        case "S":
          return this.num(e.millisecond);
        case "u":
        case "SSS":
          return this.num(e.millisecond, 3);
        case "s":
          return this.num(e.second);
        case "ss":
          return this.num(e.second, 2);
        case "uu":
          return this.num(Math.floor(e.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(e.millisecond / 100));
        case "m":
          return this.num(e.minute);
        case "mm":
          return this.num(e.minute, 2);
        case "h":
          return this.num(e.hour % 12 === 0 ? 12 : e.hour % 12);
        case "hh":
          return this.num(e.hour % 12 === 0 ? 12 : e.hour % 12, 2);
        case "H":
          return this.num(e.hour);
        case "HH":
          return this.num(e.hour, 2);
        case "Z":
          return o({ format: "narrow", allowZ: this.opts.allowZ });
        case "ZZ":
          return o({ format: "short", allowZ: this.opts.allowZ });
        case "ZZZ":
          return o({ format: "techie", allowZ: this.opts.allowZ });
        case "ZZZZ":
          return e.zone.offsetName(e.ts, { format: "short", locale: this.loc.locale });
        case "ZZZZZ":
          return e.zone.offsetName(e.ts, { format: "long", locale: this.loc.locale });
        case "z":
          return e.zoneName;
        case "a":
          return a();
        case "d":
          return r ? i({ day: "numeric" }, "day") : this.num(e.day);
        case "dd":
          return r ? i({ day: "2-digit" }, "day") : this.num(e.day, 2);
        case "c":
          return this.num(e.weekday);
        case "ccc":
          return u("short", !0);
        case "cccc":
          return u("long", !0);
        case "ccccc":
          return u("narrow", !0);
        case "E":
          return this.num(e.weekday);
        case "EEE":
          return u("short", !1);
        case "EEEE":
          return u("long", !1);
        case "EEEEE":
          return u("narrow", !1);
        case "L":
          return r ? i({ month: "numeric", day: "numeric" }, "month") : this.num(e.month);
        case "LL":
          return r ? i({ month: "2-digit", day: "numeric" }, "month") : this.num(e.month, 2);
        case "LLL":
          return l("short", !0);
        case "LLLL":
          return l("long", !0);
        case "LLLLL":
          return l("narrow", !0);
        case "M":
          return r ? i({ month: "numeric" }, "month") : this.num(e.month);
        case "MM":
          return r ? i({ month: "2-digit" }, "month") : this.num(e.month, 2);
        case "MMM":
          return l("short", !1);
        case "MMMM":
          return l("long", !1);
        case "MMMMM":
          return l("narrow", !1);
        case "y":
          return r ? i({ year: "numeric" }, "year") : this.num(e.year);
        case "yy":
          return r ? i({ year: "2-digit" }, "year") : this.num(e.year.toString().slice(-2), 2);
        case "yyyy":
          return r ? i({ year: "numeric" }, "year") : this.num(e.year, 4);
        case "yyyyyy":
          return r ? i({ year: "numeric" }, "year") : this.num(e.year, 6);
        case "G":
          return d("short");
        case "GG":
          return d("long");
        case "GGGGG":
          return d("narrow");
        case "kk":
          return this.num(e.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(e.weekYear, 4);
        case "W":
          return this.num(e.weekNumber);
        case "WW":
          return this.num(e.weekNumber, 2);
        case "n":
          return this.num(e.localWeekNumber);
        case "nn":
          return this.num(e.localWeekNumber, 2);
        case "ii":
          return this.num(e.localWeekYear.toString().slice(-2), 2);
        case "iiii":
          return this.num(e.localWeekYear, 4);
        case "o":
          return this.num(e.ordinal);
        case "ooo":
          return this.num(e.ordinal, 3);
        case "q":
          return this.num(e.quarter);
        case "qq":
          return this.num(e.quarter, 2);
        case "X":
          return this.num(Math.floor(e.ts / 1e3));
        case "x":
          return this.num(e.ts);
        default:
          return c(h);
      }
    };
    return fr(Y.parseFormat(n), m);
  }
  formatDurationFromString(e, n) {
    const s = (l) => {
      switch (l[0]) {
        case "S":
          return "millisecond";
        case "s":
          return "second";
        case "m":
          return "minute";
        case "h":
          return "hour";
        case "d":
          return "day";
        case "w":
          return "week";
        case "M":
          return "month";
        case "y":
          return "year";
        default:
          return null;
      }
    }, r = (l) => (u) => {
      const c = s(u);
      return c ? this.num(l.get(c), u.length) : u;
    }, i = Y.parseFormat(n), o = i.reduce(
      (l, { literal: u, val: c }) => u ? l : l.concat(c),
      []
    ), a = e.shiftTo(...o.map(s).filter((l) => l));
    return fr(i, r(a));
  }
}
const io = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function ht(...t) {
  const e = t.reduce((n, s) => n + s.source, "");
  return RegExp(`^${e}$`);
}
function mt(...t) {
  return (e) => t.reduce(
    ([n, s, r], i) => {
      const [o, a, l] = i(e, r);
      return [{ ...n, ...o }, a || s, l];
    },
    [{}, null, 1]
  ).slice(0, 2);
}
function pt(t, ...e) {
  if (t == null)
    return [null, null];
  for (const [n, s] of e) {
    const r = n.exec(t);
    if (r)
      return s(r);
  }
  return [null, null];
}
function oo(...t) {
  return (e, n) => {
    const s = {};
    let r;
    for (r = 0; r < t.length; r++)
      s[t[r]] = xe(e[n + r]);
    return [s, null, n + r];
  };
}
const ao = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/, rc = `(?:${ao.source}?(?:\\[(${io.source})\\])?)?`, bs = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/, lo = RegExp(`${bs.source}${rc}`), ws = RegExp(`(?:T${lo.source})?`), ic = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/, oc = /(\d{4})-?W(\d\d)(?:-?(\d))?/, ac = /(\d{4})-?(\d{3})/, lc = oo("weekYear", "weekNumber", "weekDay"), uc = oo("year", "ordinal"), cc = /(\d{4})-(\d\d)-(\d\d)/, uo = RegExp(
  `${bs.source} ?(?:${ao.source}|(${io.source}))?`
), dc = RegExp(`(?: ${uo.source})?`);
function at(t, e, n) {
  const s = t[e];
  return N(s) ? n : xe(s);
}
function fc(t, e) {
  return [{
    year: at(t, e),
    month: at(t, e + 1, 1),
    day: at(t, e + 2, 1)
  }, null, e + 3];
}
function yt(t, e) {
  return [{
    hours: at(t, e, 0),
    minutes: at(t, e + 1, 0),
    seconds: at(t, e + 2, 0),
    milliseconds: ys(t[e + 3])
  }, null, e + 4];
}
function Mt(t, e) {
  const n = !t[e] && !t[e + 1], s = Sn(t[e + 1], t[e + 2]), r = n ? null : G.instance(s);
  return [{}, r, e + 3];
}
function Rt(t, e) {
  const n = t[e] ? ke.create(t[e]) : null;
  return [{}, n, e + 1];
}
const hc = RegExp(`^T?${bs.source}$`), mc = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function pc(t) {
  const [e, n, s, r, i, o, a, l, u] = t, c = e[0] === "-", d = l && l[0] === "-", m = (h, p = !1) => h !== void 0 && (p || h && c) ? -h : h;
  return [
    {
      years: m(Re(n)),
      months: m(Re(s)),
      weeks: m(Re(r)),
      days: m(Re(i)),
      hours: m(Re(o)),
      minutes: m(Re(a)),
      seconds: m(Re(l), l === "-0"),
      milliseconds: m(ys(u), d)
    }
  ];
}
const yc = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function Ss(t, e, n, s, r, i, o) {
  const a = {
    year: e.length === 2 ? ts(xe(e)) : xe(e),
    month: Qi.indexOf(n) + 1,
    day: xe(s),
    hour: xe(r),
    minute: xe(i)
  };
  return o && (a.second = xe(o)), t && (a.weekday = t.length > 3 ? eo.indexOf(t) + 1 : to.indexOf(t) + 1), a;
}
const gc = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function bc(t) {
  const [
    ,
    e,
    n,
    s,
    r,
    i,
    o,
    a,
    l,
    u,
    c,
    d
  ] = t, m = Ss(e, r, s, n, i, o, a);
  let h;
  return l ? h = yc[l] : u ? h = 0 : h = Sn(c, d), [m, new G(h)];
}
function wc(t) {
  return t.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
const Sc = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, vc = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, Oc = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function hr(t) {
  const [, e, n, s, r, i, o, a] = t;
  return [Ss(e, r, s, n, i, o, a), G.utcInstance];
}
function Ec(t) {
  const [, e, n, s, r, i, o, a] = t;
  return [Ss(e, a, n, s, r, i, o), G.utcInstance];
}
const Tc = ht(ic, ws), kc = ht(oc, ws), Nc = ht(ac, ws), _c = ht(lo), co = mt(
  fc,
  yt,
  Mt,
  Rt
), Dc = mt(
  lc,
  yt,
  Mt,
  Rt
), xc = mt(
  uc,
  yt,
  Mt,
  Rt
), Ic = mt(
  yt,
  Mt,
  Rt
);
function Vc(t) {
  return pt(
    t,
    [Tc, co],
    [kc, Dc],
    [Nc, xc],
    [_c, Ic]
  );
}
function Cc(t) {
  return pt(wc(t), [gc, bc]);
}
function Ac(t) {
  return pt(
    t,
    [Sc, hr],
    [vc, hr],
    [Oc, Ec]
  );
}
function Fc(t) {
  return pt(t, [mc, pc]);
}
const Mc = mt(yt);
function Rc(t) {
  return pt(t, [hc, Mc]);
}
const $c = ht(cc, dc), Lc = ht(uo), Pc = mt(
  yt,
  Mt,
  Rt
);
function Uc(t) {
  return pt(
    t,
    [$c, co],
    [Lc, Pc]
  );
}
const mr = "Invalid Duration", fo = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1e3 },
  minutes: { seconds: 60, milliseconds: 60 * 1e3 },
  seconds: { milliseconds: 1e3 }
}, Wc = {
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1e3
  },
  ...fo
}, ie = 146097 / 400, Qe = 146097 / 4800, qc = {
  years: {
    quarters: 4,
    months: 12,
    weeks: ie / 7,
    days: ie,
    hours: ie * 24,
    minutes: ie * 24 * 60,
    seconds: ie * 24 * 60 * 60,
    milliseconds: ie * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: ie / 28,
    days: ie / 4,
    hours: ie * 24 / 4,
    minutes: ie * 24 * 60 / 4,
    seconds: ie * 24 * 60 * 60 / 4,
    milliseconds: ie * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: Qe / 7,
    days: Qe,
    hours: Qe * 24,
    minutes: Qe * 24 * 60,
    seconds: Qe * 24 * 60 * 60,
    milliseconds: Qe * 24 * 60 * 60 * 1e3
  },
  ...fo
}, je = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
], Bc = je.slice(0).reverse();
function De(t, e, n = !1) {
  const s = {
    values: n ? e.values : { ...t.values, ...e.values || {} },
    loc: t.loc.clone(e.loc),
    conversionAccuracy: e.conversionAccuracy || t.conversionAccuracy,
    matrix: e.matrix || t.matrix
  };
  return new V(s);
}
function ho(t, e) {
  let n = e.milliseconds ?? 0;
  for (const s of Bc.slice(1))
    e[s] && (n += e[s] * t[s].milliseconds);
  return n;
}
function pr(t, e) {
  const n = ho(t, e) < 0 ? -1 : 1;
  je.reduceRight((s, r) => {
    if (N(e[r]))
      return s;
    if (s) {
      const i = e[s] * n, o = t[r][s], a = Math.floor(i / o);
      e[r] += a * n, e[s] -= a * o * n;
    }
    return r;
  }, null), je.reduce((s, r) => {
    if (N(e[r]))
      return s;
    if (s) {
      const i = e[s] % 1;
      e[s] -= i, e[r] += i * t[s][r];
    }
    return r;
  }, null);
}
function jc(t) {
  const e = {};
  for (const [n, s] of Object.entries(t))
    s !== 0 && (e[n] = s);
  return e;
}
class V {
  /**
   * @private
   */
  constructor(e) {
    const n = e.conversionAccuracy === "longterm" || !1;
    let s = n ? qc : Wc;
    e.matrix && (s = e.matrix), this.values = e.values, this.loc = e.loc || A.create(), this.conversionAccuracy = n ? "longterm" : "casual", this.invalid = e.invalid || null, this.matrix = s, this.isLuxonDuration = !0;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(e, n) {
    return V.fromObject({ milliseconds: e }, n);
  }
  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */
  static fromObject(e, n = {}) {
    if (e == null || typeof e != "object")
      throw new J(
        `Duration.fromObject: argument expected to be an object, got ${e === null ? "null" : typeof e}`
      );
    return new V({
      values: cn(e, V.normalizeUnit),
      loc: A.fromObject(n),
      conversionAccuracy: n.conversionAccuracy,
      matrix: n.matrix
    });
  }
  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(e) {
    if (Ce(e))
      return V.fromMillis(e);
    if (V.isDuration(e))
      return e;
    if (typeof e == "object")
      return V.fromObject(e);
    throw new J(
      `Unknown duration argument ${e} of type ${typeof e}`
    );
  }
  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(e, n) {
    const [s] = Fc(e);
    return s ? V.fromObject(s, n) : V.invalid("unparsable", `the input "${e}" can't be parsed as ISO 8601`);
  }
  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(e, n) {
    const [s] = Rc(e);
    return s ? V.fromObject(s, n) : V.invalid("unparsable", `the input "${e}" can't be parsed as ISO 8601`);
  }
  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(e, n = null) {
    if (!e)
      throw new J("need to specify a reason the Duration is invalid");
    const s = e instanceof he ? e : new he(e, n);
    if (P.throwOnInvalid)
      throw new mu(s);
    return new V({ invalid: s });
  }
  /**
   * @private
   */
  static normalizeUnit(e) {
    const n = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[e && e.toLowerCase()];
    if (!n) throw new Oi(e);
    return n;
  }
  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(e) {
    return e && e.isLuxonDuration || !1;
  }
  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */
  toFormat(e, n = {}) {
    const s = {
      ...n,
      floor: n.round !== !1 && n.floor !== !1
    };
    return this.isValid ? Y.create(this.loc, s).formatDurationFromString(this, e) : mr;
  }
  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */
  toHuman(e = {}) {
    if (!this.isValid) return mr;
    const n = je.map((s) => {
      const r = this.values[s];
      return N(r) ? null : this.loc.numberFormatter({ style: "unit", unitDisplay: "long", ...e, unit: s.slice(0, -1) }).format(r);
    }).filter((s) => s);
    return this.loc.listFormatter({ type: "conjunction", style: e.listStyle || "narrow", ...e }).format(n);
  }
  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    return this.isValid ? { ...this.values } : {};
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    if (!this.isValid) return null;
    let e = "P";
    return this.years !== 0 && (e += this.years + "Y"), (this.months !== 0 || this.quarters !== 0) && (e += this.months + this.quarters * 3 + "M"), this.weeks !== 0 && (e += this.weeks + "W"), this.days !== 0 && (e += this.days + "D"), (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) && (e += "T"), this.hours !== 0 && (e += this.hours + "H"), this.minutes !== 0 && (e += this.minutes + "M"), (this.seconds !== 0 || this.milliseconds !== 0) && (e += gs(this.seconds + this.milliseconds / 1e3, 3) + "S"), e === "P" && (e += "T0S"), e;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(e = {}) {
    if (!this.isValid) return null;
    const n = this.toMillis();
    return n < 0 || n >= 864e5 ? null : (e = {
      suppressMilliseconds: !1,
      suppressSeconds: !1,
      includePrefix: !1,
      format: "extended",
      ...e,
      includeOffset: !1
    }, k.fromMillis(n, { zone: "UTC" }).toISOTime(e));
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }
  /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `Duration { values: ${JSON.stringify(this.values)} }` : `Duration { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? ho(this.matrix, this.values) : NaN;
  }
  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(e) {
    if (!this.isValid) return this;
    const n = V.fromDurationLike(e), s = {};
    for (const r of je)
      (ct(n.values, r) || ct(this.values, r)) && (s[r] = n.get(r) + this.get(r));
    return De(this, { values: s }, !0);
  }
  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(e) {
    if (!this.isValid) return this;
    const n = V.fromDurationLike(e);
    return this.plus(n.negate());
  }
  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(e) {
    if (!this.isValid) return this;
    const n = {};
    for (const s of Object.keys(this.values))
      n[s] = Ki(e(this.values[s], s));
    return De(this, { values: n }, !0);
  }
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(e) {
    return this[V.normalizeUnit(e)];
  }
  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(e) {
    if (!this.isValid) return this;
    const n = { ...this.values, ...cn(e, V.normalizeUnit) };
    return De(this, { values: n });
  }
  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale: e, numberingSystem: n, conversionAccuracy: s, matrix: r } = {}) {
    const o = { loc: this.loc.clone({ locale: e, numberingSystem: n }), matrix: r, conversionAccuracy: s };
    return De(this, o);
  }
  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(e) {
    return this.isValid ? this.shiftTo(e).get(e) : NaN;
  }
  /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid) return this;
    const e = this.toObject();
    return pr(this.matrix, e), De(this, { values: e }, !0);
  }
  /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */
  rescale() {
    if (!this.isValid) return this;
    const e = jc(this.normalize().shiftToAll().toObject());
    return De(this, { values: e }, !0);
  }
  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...e) {
    if (!this.isValid) return this;
    if (e.length === 0)
      return this;
    e = e.map((o) => V.normalizeUnit(o));
    const n = {}, s = {}, r = this.toObject();
    let i;
    for (const o of je)
      if (e.indexOf(o) >= 0) {
        i = o;
        let a = 0;
        for (const u in s)
          a += this.matrix[u][o] * s[u], s[u] = 0;
        Ce(r[o]) && (a += r[o]);
        const l = Math.trunc(a);
        n[o] = l, s[o] = (a * 1e3 - l * 1e3) / 1e3;
      } else Ce(r[o]) && (s[o] = r[o]);
    for (const o in s)
      s[o] !== 0 && (n[i] += o === i ? s[o] : s[o] / this.matrix[i][o]);
    return pr(this.matrix, n), De(this, { values: n }, !0);
  }
  /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */
  shiftToAll() {
    return this.isValid ? this.shiftTo(
      "years",
      "months",
      "weeks",
      "days",
      "hours",
      "minutes",
      "seconds",
      "milliseconds"
    ) : this;
  }
  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid) return this;
    const e = {};
    for (const n of Object.keys(this.values))
      e[n] = this.values[n] === 0 ? 0 : -this.values[n];
    return De(this, { values: e }, !0);
  }
  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(e) {
    if (!this.isValid || !e.isValid || !this.loc.equals(e.loc))
      return !1;
    function n(s, r) {
      return s === void 0 || s === 0 ? r === void 0 || r === 0 : s === r;
    }
    for (const s of je)
      if (!n(this.values[s], e.values[s]))
        return !1;
    return !0;
  }
}
const Xe = "Invalid Interval";
function zc(t, e) {
  return !t || !t.isValid ? L.invalid("missing or invalid start") : !e || !e.isValid ? L.invalid("missing or invalid end") : e < t ? L.invalid(
    "end before start",
    `The end of an interval must be after its start, but you had start=${t.toISO()} and end=${e.toISO()}`
  ) : null;
}
class L {
  /**
   * @private
   */
  constructor(e) {
    this.s = e.start, this.e = e.end, this.invalid = e.invalid || null, this.isLuxonInterval = !0;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(e, n = null) {
    if (!e)
      throw new J("need to specify a reason the Interval is invalid");
    const s = e instanceof he ? e : new he(e, n);
    if (P.throwOnInvalid)
      throw new hu(s);
    return new L({ invalid: s });
  }
  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(e, n) {
    const s = St(e), r = St(n), i = zc(s, r);
    return i ?? new L({
      start: s,
      end: r
    });
  }
  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(e, n) {
    const s = V.fromDurationLike(n), r = St(e);
    return L.fromDateTimes(r, r.plus(s));
  }
  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(e, n) {
    const s = V.fromDurationLike(n), r = St(e);
    return L.fromDateTimes(r.minus(s), r);
  }
  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(e, n) {
    const [s, r] = (e || "").split("/", 2);
    if (s && r) {
      let i, o;
      try {
        i = k.fromISO(s, n), o = i.isValid;
      } catch {
        o = !1;
      }
      let a, l;
      try {
        a = k.fromISO(r, n), l = a.isValid;
      } catch {
        l = !1;
      }
      if (o && l)
        return L.fromDateTimes(i, a);
      if (o) {
        const u = V.fromISO(r, n);
        if (u.isValid)
          return L.after(i, u);
      } else if (l) {
        const u = V.fromISO(s, n);
        if (u.isValid)
          return L.before(a, u);
      }
    }
    return L.invalid("unparsable", `the input "${e}" can't be parsed as ISO 8601`);
  }
  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(e) {
    return e && e.isLuxonInterval || !1;
  }
  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
   * Returns the end of the Interval
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(e = "milliseconds") {
    return this.isValid ? this.toDuration(e).get(e) : NaN;
  }
  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */
  count(e = "milliseconds", n) {
    if (!this.isValid) return NaN;
    const s = this.start.startOf(e, n);
    let r;
    return n != null && n.useLocaleWeeks ? r = this.end.reconfigure({ locale: s.locale }) : r = this.end, r = r.startOf(e, n), Math.floor(r.diff(s, e).get(e)) + (r.valueOf() !== this.end.valueOf());
  }
  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(e) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, e) : !1;
  }
  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(e) {
    return this.isValid ? this.s > e : !1;
  }
  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(e) {
    return this.isValid ? this.e <= e : !1;
  }
  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(e) {
    return this.isValid ? this.s <= e && this.e > e : !1;
  }
  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start: e, end: n } = {}) {
    return this.isValid ? L.fromDateTimes(e || this.s, n || this.e) : this;
  }
  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...e) {
    if (!this.isValid) return [];
    const n = e.map(St).filter((o) => this.contains(o)).sort((o, a) => o.toMillis() - a.toMillis()), s = [];
    let { s: r } = this, i = 0;
    for (; r < this.e; ) {
      const o = n[i] || this.e, a = +o > +this.e ? this.e : o;
      s.push(L.fromDateTimes(r, a)), r = a, i += 1;
    }
    return s;
  }
  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(e) {
    const n = V.fromDurationLike(e);
    if (!this.isValid || !n.isValid || n.as("milliseconds") === 0)
      return [];
    let { s } = this, r = 1, i;
    const o = [];
    for (; s < this.e; ) {
      const a = this.start.plus(n.mapUnits((l) => l * r));
      i = +a > +this.e ? this.e : a, o.push(L.fromDateTimes(s, i)), s = i, r += 1;
    }
    return o;
  }
  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(e) {
    return this.isValid ? this.splitBy(this.length() / e).slice(0, e) : [];
  }
  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(e) {
    return this.e > e.s && this.s < e.e;
  }
  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(e) {
    return this.isValid ? +this.e == +e.s : !1;
  }
  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(e) {
    return this.isValid ? +e.e == +this.s : !1;
  }
  /**
   * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(e) {
    return this.isValid ? this.s <= e.s && this.e >= e.e : !1;
  }
  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(e) {
    return !this.isValid || !e.isValid ? !1 : this.s.equals(e.s) && this.e.equals(e.e);
  }
  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(e) {
    if (!this.isValid) return this;
    const n = this.s > e.s ? this.s : e.s, s = this.e < e.e ? this.e : e.e;
    return n >= s ? null : L.fromDateTimes(n, s);
  }
  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(e) {
    if (!this.isValid) return this;
    const n = this.s < e.s ? this.s : e.s, s = this.e > e.e ? this.e : e.e;
    return L.fromDateTimes(n, s);
  }
  /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(e) {
    const [n, s] = e.sort((r, i) => r.s - i.s).reduce(
      ([r, i], o) => i ? i.overlaps(o) || i.abutsStart(o) ? [r, i.union(o)] : [r.concat([i]), o] : [r, o],
      [[], null]
    );
    return s && n.push(s), n;
  }
  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(e) {
    let n = null, s = 0;
    const r = [], i = e.map((l) => [
      { time: l.s, type: "s" },
      { time: l.e, type: "e" }
    ]), o = Array.prototype.concat(...i), a = o.sort((l, u) => l.time - u.time);
    for (const l of a)
      s += l.type === "s" ? 1 : -1, s === 1 ? n = l.time : (n && +n != +l.time && r.push(L.fromDateTimes(n, l.time)), n = null);
    return L.merge(r);
  }
  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...e) {
    return L.xor([this].concat(e)).map((n) => this.intersection(n)).filter((n) => n && !n.isEmpty());
  }
  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    return this.isValid ? `[${this.s.toISO()} – ${this.e.toISO()})` : Xe;
  }
  /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }` : `Interval { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */
  toLocaleString(e = an, n = {}) {
    return this.isValid ? Y.create(this.s.loc.clone(n), e).formatInterval(this) : Xe;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(e) {
    return this.isValid ? `${this.s.toISO(e)}/${this.e.toISO(e)}` : Xe;
  }
  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    return this.isValid ? `${this.s.toISODate()}/${this.e.toISODate()}` : Xe;
  }
  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(e) {
    return this.isValid ? `${this.s.toISOTime(e)}/${this.e.toISOTime(e)}` : Xe;
  }
  /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */
  toFormat(e, { separator: n = " – " } = {}) {
    return this.isValid ? `${this.s.toFormat(e)}${n}${this.e.toFormat(e)}` : Xe;
  }
  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(e, n) {
    return this.isValid ? this.e.diff(this.s, e, n) : V.invalid(this.invalidReason);
  }
  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(e) {
    return L.fromDateTimes(e(this.s), e(this.e));
  }
}
class Ut {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(e = P.defaultZone) {
    const n = k.now().setZone(e).set({ month: 12 });
    return !e.isUniversal && n.offset !== n.set({ month: 6 }).offset;
  }
  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(e) {
    return ke.isValidZone(e);
  }
  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(e) {
    return Ie(e, P.defaultZone);
  }
  /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */
  static getStartOfWeek({ locale: e = null, locObj: n = null } = {}) {
    return (n || A.create(e)).getStartOfWeek();
  }
  /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */
  static getMinimumDaysInFirstWeek({ locale: e = null, locObj: n = null } = {}) {
    return (n || A.create(e)).getMinDaysInFirstWeek();
  }
  /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */
  static getWeekendWeekdays({ locale: e = null, locObj: n = null } = {}) {
    return (n || A.create(e)).getWeekendDays().slice();
  }
  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(e = "long", { locale: n = null, numberingSystem: s = null, locObj: r = null, outputCalendar: i = "gregory" } = {}) {
    return (r || A.create(n, s, i)).months(e);
  }
  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(e = "long", { locale: n = null, numberingSystem: s = null, locObj: r = null, outputCalendar: i = "gregory" } = {}) {
    return (r || A.create(n, s, i)).months(e, !0);
  }
  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(e = "long", { locale: n = null, numberingSystem: s = null, locObj: r = null } = {}) {
    return (r || A.create(n, s, null)).weekdays(e);
  }
  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(e = "long", { locale: n = null, numberingSystem: s = null, locObj: r = null } = {}) {
    return (r || A.create(n, s, null)).weekdays(e, !0);
  }
  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale: e = null } = {}) {
    return A.create(e).meridiems();
  }
  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(e = "short", { locale: n = null } = {}) {
    return A.create(n, null, "gregory").eras(e);
  }
  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */
  static features() {
    return { relative: Ji(), localeWeek: Yi() };
  }
}
function yr(t, e) {
  const n = (r) => r.toUTC(0, { keepLocalTime: !0 }).startOf("day").valueOf(), s = n(e) - n(t);
  return Math.floor(V.fromMillis(s).as("days"));
}
function Hc(t, e, n) {
  const s = [
    ["years", (l, u) => u.year - l.year],
    ["quarters", (l, u) => u.quarter - l.quarter + (u.year - l.year) * 4],
    ["months", (l, u) => u.month - l.month + (u.year - l.year) * 12],
    [
      "weeks",
      (l, u) => {
        const c = yr(l, u);
        return (c - c % 7) / 7;
      }
    ],
    ["days", yr]
  ], r = {}, i = t;
  let o, a;
  for (const [l, u] of s)
    n.indexOf(l) >= 0 && (o = l, r[l] = u(t, e), a = i.plus(r), a > e ? (r[l]--, t = i.plus(r), t > e && (a = t, r[l]--, t = i.plus(r))) : t = a);
  return [t, r, a, o];
}
function Zc(t, e, n, s) {
  let [r, i, o, a] = Hc(t, e, n);
  const l = e - r, u = n.filter(
    (d) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(d) >= 0
  );
  u.length === 0 && (o < e && (o = r.plus({ [a]: 1 })), o !== r && (i[a] = (i[a] || 0) + l / (o - r)));
  const c = V.fromObject(i, s);
  return u.length > 0 ? V.fromMillis(l, s).shiftTo(...u).plus(c) : c;
}
const Jc = "missing Intl.DateTimeFormat.formatToParts support";
function C(t, e = (n) => n) {
  return { regex: t, deser: ([n]) => e($u(n)) };
}
const Yc = " ", mo = `[ ${Yc}]`, po = new RegExp(mo, "g");
function Gc(t) {
  return t.replace(/\./g, "\\.?").replace(po, mo);
}
function gr(t) {
  return t.replace(/\./g, "").replace(po, " ").toLowerCase();
}
function de(t, e) {
  return t === null ? null : {
    regex: RegExp(t.map(Gc).join("|")),
    deser: ([n]) => t.findIndex((s) => gr(n) === gr(s)) + e
  };
}
function br(t, e) {
  return { regex: t, deser: ([, n, s]) => Sn(n, s), groups: e };
}
function Wt(t) {
  return { regex: t, deser: ([e]) => e };
}
function Kc(t) {
  return t.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function Qc(t, e) {
  const n = ce(e), s = ce(e, "{2}"), r = ce(e, "{3}"), i = ce(e, "{4}"), o = ce(e, "{6}"), a = ce(e, "{1,2}"), l = ce(e, "{1,3}"), u = ce(e, "{1,6}"), c = ce(e, "{1,9}"), d = ce(e, "{2,4}"), m = ce(e, "{4,6}"), h = (g) => ({ regex: RegExp(Kc(g.val)), deser: ([I]) => I, literal: !0 }), v = ((g) => {
    if (t.literal)
      return h(g);
    switch (g.val) {
      case "G":
        return de(e.eras("short"), 0);
      case "GG":
        return de(e.eras("long"), 0);
      case "y":
        return C(u);
      case "yy":
        return C(d, ts);
      case "yyyy":
        return C(i);
      case "yyyyy":
        return C(m);
      case "yyyyyy":
        return C(o);
      case "M":
        return C(a);
      case "MM":
        return C(s);
      case "MMM":
        return de(e.months("short", !0), 1);
      case "MMMM":
        return de(e.months("long", !0), 1);
      case "L":
        return C(a);
      case "LL":
        return C(s);
      case "LLL":
        return de(e.months("short", !1), 1);
      case "LLLL":
        return de(e.months("long", !1), 1);
      case "d":
        return C(a);
      case "dd":
        return C(s);
      case "o":
        return C(l);
      case "ooo":
        return C(r);
      case "HH":
        return C(s);
      case "H":
        return C(a);
      case "hh":
        return C(s);
      case "h":
        return C(a);
      case "mm":
        return C(s);
      case "m":
        return C(a);
      case "q":
        return C(a);
      case "qq":
        return C(s);
      case "s":
        return C(a);
      case "ss":
        return C(s);
      case "S":
        return C(l);
      case "SSS":
        return C(r);
      case "u":
        return Wt(c);
      case "uu":
        return Wt(a);
      case "uuu":
        return C(n);
      case "a":
        return de(e.meridiems(), 0);
      case "kkkk":
        return C(i);
      case "kk":
        return C(d, ts);
      case "W":
        return C(a);
      case "WW":
        return C(s);
      case "E":
      case "c":
        return C(n);
      case "EEE":
        return de(e.weekdays("short", !1), 1);
      case "EEEE":
        return de(e.weekdays("long", !1), 1);
      case "ccc":
        return de(e.weekdays("short", !0), 1);
      case "cccc":
        return de(e.weekdays("long", !0), 1);
      case "Z":
      case "ZZ":
        return br(new RegExp(`([+-]${a.source})(?::(${s.source}))?`), 2);
      case "ZZZ":
        return br(new RegExp(`([+-]${a.source})(${s.source})?`), 2);
      case "z":
        return Wt(/[a-z_+-/]{1,256}?/i);
      case " ":
        return Wt(/[^\S\n\r]/);
      default:
        return h(g);
    }
  })(t) || {
    invalidReason: Jc
  };
  return v.token = t, v;
}
const Xc = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh"
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function ed(t, e, n) {
  const { type: s, value: r } = t;
  if (s === "literal") {
    const l = /^\s+$/.test(r);
    return {
      literal: !l,
      val: l ? " " : r
    };
  }
  const i = e[s];
  let o = s;
  s === "hour" && (e.hour12 != null ? o = e.hour12 ? "hour12" : "hour24" : e.hourCycle != null ? e.hourCycle === "h11" || e.hourCycle === "h12" ? o = "hour12" : o = "hour24" : o = n.hour12 ? "hour12" : "hour24");
  let a = Xc[o];
  if (typeof a == "object" && (a = a[i]), a)
    return {
      literal: !1,
      val: a
    };
}
function td(t) {
  return [`^${t.map((n) => n.regex).reduce((n, s) => `${n}(${s.source})`, "")}$`, t];
}
function nd(t, e, n) {
  const s = t.match(e);
  if (s) {
    const r = {};
    let i = 1;
    for (const o in n)
      if (ct(n, o)) {
        const a = n[o], l = a.groups ? a.groups + 1 : 1;
        !a.literal && a.token && (r[a.token.val[0]] = a.deser(s.slice(i, i + l))), i += l;
      }
    return [s, r];
  } else
    return [s, {}];
}
function sd(t) {
  const e = (i) => {
    switch (i) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  let n = null, s;
  return N(t.z) || (n = ke.create(t.z)), N(t.Z) || (n || (n = new G(t.Z)), s = t.Z), N(t.q) || (t.M = (t.q - 1) * 3 + 1), N(t.h) || (t.h < 12 && t.a === 1 ? t.h += 12 : t.h === 12 && t.a === 0 && (t.h = 0)), t.G === 0 && t.y && (t.y = -t.y), N(t.u) || (t.S = ys(t.u)), [Object.keys(t).reduce((i, o) => {
    const a = e(o);
    return a && (i[a] = t[o]), i;
  }, {}), n, s];
}
let An = null;
function rd() {
  return An || (An = k.fromMillis(1555555555555)), An;
}
function id(t, e) {
  if (t.literal)
    return t;
  const n = Y.macroTokenToFormatOpts(t.val), s = wo(n, e);
  return s == null || s.includes(void 0) ? t : s;
}
function yo(t, e) {
  return Array.prototype.concat(...t.map((n) => id(n, e)));
}
class go {
  constructor(e, n) {
    if (this.locale = e, this.format = n, this.tokens = yo(Y.parseFormat(n), e), this.units = this.tokens.map((s) => Qc(s, e)), this.disqualifyingUnit = this.units.find((s) => s.invalidReason), !this.disqualifyingUnit) {
      const [s, r] = td(this.units);
      this.regex = RegExp(s, "i"), this.handlers = r;
    }
  }
  explainFromTokens(e) {
    if (this.isValid) {
      const [n, s] = nd(e, this.regex, this.handlers), [r, i, o] = s ? sd(s) : [null, null, void 0];
      if (ct(s, "a") && ct(s, "H"))
        throw new it(
          "Can't include meridiem when specifying 24-hour format"
        );
      return {
        input: e,
        tokens: this.tokens,
        regex: this.regex,
        rawMatches: n,
        matches: s,
        result: r,
        zone: i,
        specificOffset: o
      };
    } else
      return { input: e, tokens: this.tokens, invalidReason: this.invalidReason };
  }
  get isValid() {
    return !this.disqualifyingUnit;
  }
  get invalidReason() {
    return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
  }
}
function bo(t, e, n) {
  return new go(t, n).explainFromTokens(e);
}
function od(t, e, n) {
  const { result: s, zone: r, specificOffset: i, invalidReason: o } = bo(t, e, n);
  return [s, r, i, o];
}
function wo(t, e) {
  if (!t)
    return null;
  const s = Y.create(e, t).dtFormatter(rd()), r = s.formatToParts(), i = s.resolvedOptions();
  return r.map((o) => ed(o, t, i));
}
const Fn = "Invalid DateTime", wr = 864e13;
function Ot(t) {
  return new he("unsupported zone", `the zone "${t.name}" is not supported`);
}
function Mn(t) {
  return t.weekData === null && (t.weekData = ln(t.c)), t.weekData;
}
function Rn(t) {
  return t.localWeekData === null && (t.localWeekData = ln(
    t.c,
    t.loc.getMinDaysInFirstWeek(),
    t.loc.getStartOfWeek()
  )), t.localWeekData;
}
function $e(t, e) {
  const n = {
    ts: t.ts,
    zone: t.zone,
    c: t.c,
    o: t.o,
    loc: t.loc,
    invalid: t.invalid
  };
  return new k({ ...n, ...e, old: n });
}
function So(t, e, n) {
  let s = t - e * 60 * 1e3;
  const r = n.offset(s);
  if (e === r)
    return [s, e];
  s -= (r - e) * 60 * 1e3;
  const i = n.offset(s);
  return r === i ? [s, r] : [t - Math.min(r, i) * 60 * 1e3, Math.max(r, i)];
}
function qt(t, e) {
  t += e * 60 * 1e3;
  const n = new Date(t);
  return {
    year: n.getUTCFullYear(),
    month: n.getUTCMonth() + 1,
    day: n.getUTCDate(),
    hour: n.getUTCHours(),
    minute: n.getUTCMinutes(),
    second: n.getUTCSeconds(),
    millisecond: n.getUTCMilliseconds()
  };
}
function Qt(t, e, n) {
  return So(wn(t), e, n);
}
function Sr(t, e) {
  const n = t.o, s = t.c.year + Math.trunc(e.years), r = t.c.month + Math.trunc(e.months) + Math.trunc(e.quarters) * 3, i = {
    ...t.c,
    year: s,
    month: r,
    day: Math.min(t.c.day, un(s, r)) + Math.trunc(e.days) + Math.trunc(e.weeks) * 7
  }, o = V.fromObject({
    years: e.years - Math.trunc(e.years),
    quarters: e.quarters - Math.trunc(e.quarters),
    months: e.months - Math.trunc(e.months),
    weeks: e.weeks - Math.trunc(e.weeks),
    days: e.days - Math.trunc(e.days),
    hours: e.hours,
    minutes: e.minutes,
    seconds: e.seconds,
    milliseconds: e.milliseconds
  }).as("milliseconds"), a = wn(i);
  let [l, u] = So(a, n, t.zone);
  return o !== 0 && (l += o, u = t.zone.offset(l)), { ts: l, o: u };
}
function et(t, e, n, s, r, i) {
  const { setZone: o, zone: a } = n;
  if (t && Object.keys(t).length !== 0 || e) {
    const l = e || a, u = k.fromObject(t, {
      ...n,
      zone: l,
      specificOffset: i
    });
    return o ? u : u.setZone(a);
  } else
    return k.invalid(
      new he("unparsable", `the input "${r}" can't be parsed as ${s}`)
    );
}
function Bt(t, e, n = !0) {
  return t.isValid ? Y.create(A.create("en-US"), {
    allowZ: n,
    forceSimple: !0
  }).formatDateTimeFromString(t, e) : null;
}
function $n(t, e) {
  const n = t.c.year > 9999 || t.c.year < 0;
  let s = "";
  return n && t.c.year >= 0 && (s += "+"), s += q(t.c.year, n ? 6 : 4), e ? (s += "-", s += q(t.c.month), s += "-", s += q(t.c.day)) : (s += q(t.c.month), s += q(t.c.day)), s;
}
function vr(t, e, n, s, r, i) {
  let o = q(t.c.hour);
  return e ? (o += ":", o += q(t.c.minute), (t.c.millisecond !== 0 || t.c.second !== 0 || !n) && (o += ":")) : o += q(t.c.minute), (t.c.millisecond !== 0 || t.c.second !== 0 || !n) && (o += q(t.c.second), (t.c.millisecond !== 0 || !s) && (o += ".", o += q(t.c.millisecond, 3))), r && (t.isOffsetFixed && t.offset === 0 && !i ? o += "Z" : t.o < 0 ? (o += "-", o += q(Math.trunc(-t.o / 60)), o += ":", o += q(Math.trunc(-t.o % 60))) : (o += "+", o += q(Math.trunc(t.o / 60)), o += ":", o += q(Math.trunc(t.o % 60)))), i && (o += "[" + t.zone.ianaName + "]"), o;
}
const vo = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, ad = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, ld = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, Oo = ["year", "month", "day", "hour", "minute", "second", "millisecond"], ud = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
], cd = ["year", "ordinal", "hour", "minute", "second", "millisecond"];
function dd(t) {
  const e = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[t.toLowerCase()];
  if (!e) throw new Oi(t);
  return e;
}
function Or(t) {
  switch (t.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return dd(t);
  }
}
function fd(t) {
  return en[t] || (Xt === void 0 && (Xt = P.now()), en[t] = t.offset(Xt)), en[t];
}
function Er(t, e) {
  const n = Ie(e.zone, P.defaultZone);
  if (!n.isValid)
    return k.invalid(Ot(n));
  const s = A.fromObject(e);
  let r, i;
  if (N(t.year))
    r = P.now();
  else {
    for (const l of Oo)
      N(t[l]) && (t[l] = vo[l]);
    const o = Hi(t) || Zi(t);
    if (o)
      return k.invalid(o);
    const a = fd(n);
    [r, i] = Qt(t, a, n);
  }
  return new k({ ts: r, zone: n, loc: s, o: i });
}
function Tr(t, e, n) {
  const s = N(n.round) ? !0 : n.round, r = (o, a) => (o = gs(o, s || n.calendary ? 0 : 2, !0), e.loc.clone(n).relFormatter(n).format(o, a)), i = (o) => n.calendary ? e.hasSame(t, o) ? 0 : e.startOf(o).diff(t.startOf(o), o).get(o) : e.diff(t, o).get(o);
  if (n.unit)
    return r(i(n.unit), n.unit);
  for (const o of n.units) {
    const a = i(o);
    if (Math.abs(a) >= 1)
      return r(a, o);
  }
  return r(t > e ? -0 : 0, n.units[n.units.length - 1]);
}
function kr(t) {
  let e = {}, n;
  return t.length > 0 && typeof t[t.length - 1] == "object" ? (e = t[t.length - 1], n = Array.from(t).slice(0, t.length - 1)) : n = Array.from(t), [e, n];
}
let Xt, en = {};
class k {
  /**
   * @access private
   */
  constructor(e) {
    const n = e.zone || P.defaultZone;
    let s = e.invalid || (Number.isNaN(e.ts) ? new he("invalid input") : null) || (n.isValid ? null : Ot(n));
    this.ts = N(e.ts) ? P.now() : e.ts;
    let r = null, i = null;
    if (!s)
      if (e.old && e.old.ts === this.ts && e.old.zone.equals(n))
        [r, i] = [e.old.c, e.old.o];
      else {
        const a = Ce(e.o) && !e.old ? e.o : n.offset(this.ts);
        r = qt(this.ts, a), s = Number.isNaN(r.year) ? new he("invalid input") : null, r = s ? null : r, i = s ? null : a;
      }
    this._zone = n, this.loc = e.loc || A.create(), this.invalid = s, this.weekData = null, this.localWeekData = null, this.c = r, this.o = i, this.isLuxonDateTime = !0;
  }
  // CONSTRUCT
  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new k({});
  }
  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [e, n] = kr(arguments), [s, r, i, o, a, l, u] = n;
    return Er({ year: s, month: r, day: i, hour: o, minute: a, second: l, millisecond: u }, e);
  }
  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [e, n] = kr(arguments), [s, r, i, o, a, l, u] = n;
    return e.zone = G.utcInstance, Er({ year: s, month: r, day: i, hour: o, minute: a, second: l, millisecond: u }, e);
  }
  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(e, n = {}) {
    const s = qu(e) ? e.valueOf() : NaN;
    if (Number.isNaN(s))
      return k.invalid("invalid input");
    const r = Ie(n.zone, P.defaultZone);
    return r.isValid ? new k({
      ts: s,
      zone: r,
      loc: A.fromObject(n)
    }) : k.invalid(Ot(r));
  }
  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(e, n = {}) {
    if (Ce(e))
      return e < -wr || e > wr ? k.invalid("Timestamp out of range") : new k({
        ts: e,
        zone: Ie(n.zone, P.defaultZone),
        loc: A.fromObject(n)
      });
    throw new J(
      `fromMillis requires a numerical input, but received a ${typeof e} with value ${e}`
    );
  }
  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(e, n = {}) {
    if (Ce(e))
      return new k({
        ts: e * 1e3,
        zone: Ie(n.zone, P.defaultZone),
        loc: A.fromObject(n)
      });
    throw new J("fromSeconds requires a numerical input");
  }
  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */
  static fromObject(e, n = {}) {
    e = e || {};
    const s = Ie(n.zone, P.defaultZone);
    if (!s.isValid)
      return k.invalid(Ot(s));
    const r = A.fromObject(n), i = cn(e, Or), { minDaysInFirstWeek: o, startOfWeek: a } = ur(i, r), l = P.now(), u = N(n.specificOffset) ? s.offset(l) : n.specificOffset, c = !N(i.ordinal), d = !N(i.year), m = !N(i.month) || !N(i.day), h = d || m, p = i.weekYear || i.weekNumber;
    if ((h || c) && p)
      throw new it(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (m && c)
      throw new it("Can't mix ordinal dates with month/day");
    const v = p || i.weekday && !h;
    let g, I, T = qt(l, u);
    v ? (g = ud, I = ad, T = ln(T, o, a)) : c ? (g = cd, I = ld, T = Cn(T)) : (g = Oo, I = vo);
    let x = !1;
    for (const w of g) {
      const b = i[w];
      N(b) ? x ? i[w] = I[w] : i[w] = T[w] : x = !0;
    }
    const $ = v ? Pu(i, o, a) : c ? Uu(i) : Hi(i), F = $ || Zi(i);
    if (F)
      return k.invalid(F);
    const ee = v ? ar(i, o, a) : c ? lr(i) : i, [O, Me] = Qt(ee, u, s), H = new k({
      ts: O,
      zone: s,
      o: Me,
      loc: r
    });
    return i.weekday && h && e.weekday !== H.weekday ? k.invalid(
      "mismatched weekday",
      `you can't specify both a weekday of ${i.weekday} and a date of ${H.toISO()}`
    ) : H.isValid ? H : k.invalid(H.invalid);
  }
  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(e, n = {}) {
    const [s, r] = Vc(e);
    return et(s, r, n, "ISO 8601", e);
  }
  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(e, n = {}) {
    const [s, r] = Cc(e);
    return et(s, r, n, "RFC 2822", e);
  }
  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(e, n = {}) {
    const [s, r] = Ac(e);
    return et(s, r, n, "HTTP", n);
  }
  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(e, n, s = {}) {
    if (N(e) || N(n))
      throw new J("fromFormat requires an input string and a format");
    const { locale: r = null, numberingSystem: i = null } = s, o = A.fromOpts({
      locale: r,
      numberingSystem: i,
      defaultToEN: !0
    }), [a, l, u, c] = od(o, e, n);
    return c ? k.invalid(c) : et(a, l, s, `format ${n}`, e, u);
  }
  /**
   * @deprecated use fromFormat instead
   */
  static fromString(e, n, s = {}) {
    return k.fromFormat(e, n, s);
  }
  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(e, n = {}) {
    const [s, r] = Uc(e);
    return et(s, r, n, "SQL", e);
  }
  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(e, n = null) {
    if (!e)
      throw new J("need to specify a reason the DateTime is invalid");
    const s = e instanceof he ? e : new he(e, n);
    if (P.throwOnInvalid)
      throw new fu(s);
    return new k({ invalid: s });
  }
  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(e) {
    return e && e.isLuxonDateTime || !1;
  }
  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */
  static parseFormatForOpts(e, n = {}) {
    const s = wo(e, A.fromObject(n));
    return s ? s.map((r) => r ? r.val : null).join("") : null;
  }
  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */
  static expandFormat(e, n = {}) {
    return yo(Y.parseFormat(e), A.fromObject(n)).map((r) => r.val).join("");
  }
  static resetCache() {
    Xt = void 0, en = {};
  }
  // INFO
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(e) {
    return this[e];
  }
  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }
  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? Mn(this).weekYear : NaN;
  }
  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? Mn(this).weekNumber : NaN;
  }
  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? Mn(this).weekday : NaN;
  }
  /**
   * Returns true if this date is on a weekend according to the locale, false otherwise
   * @returns {boolean}
   */
  get isWeekend() {
    return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
  }
  /**
   * Get the day of the week according to the locale.
   * 1 is the first day of the week and 7 is the last day of the week.
   * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
   * @returns {number}
   */
  get localWeekday() {
    return this.isValid ? Rn(this).weekday : NaN;
  }
  /**
   * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
   * because the week can start on different days of the week (see localWeekday) and because a different number of days
   * is required for a week to count as the first week of a year.
   * @returns {number}
   */
  get localWeekNumber() {
    return this.isValid ? Rn(this).weekNumber : NaN;
  }
  /**
   * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
   * differently, see localWeekNumber.
   * @returns {number}
   */
  get localWeekYear() {
    return this.isValid ? Rn(this).weekYear : NaN;
  }
  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? Cn(this.c).ordinal : NaN;
  }
  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? Ut.months("short", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? Ut.months("long", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? Ut.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? Ut.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "short",
      locale: this.locale
    }) : null;
  }
  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "long",
      locale: this.locale
    }) : null;
  }
  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    return this.isOffsetFixed ? !1 : this.offset > this.set({ month: 1, day: 1 }).offset || this.offset > this.set({ month: 5 }).offset;
  }
  /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed)
      return [this];
    const e = 864e5, n = 6e4, s = wn(this.c), r = this.zone.offset(s - e), i = this.zone.offset(s + e), o = this.zone.offset(s - r * n), a = this.zone.offset(s - i * n);
    if (o === a)
      return [this];
    const l = s - o * n, u = s - a * n, c = qt(l, o), d = qt(u, a);
    return c.hour === d.hour && c.minute === d.minute && c.second === d.second && c.millisecond === d.millisecond ? [$e(this, { ts: l }), $e(this, { ts: u })] : [this];
  }
  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return Ft(this.year);
  }
  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return un(this.year, this.month);
  }
  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? ot(this.year) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? xt(this.weekYear) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's local week year
   * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
   * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
   * @type {number}
   */
  get weeksInLocalWeekYear() {
    return this.isValid ? xt(
      this.localWeekYear,
      this.loc.getMinDaysInFirstWeek(),
      this.loc.getStartOfWeek()
    ) : NaN;
  }
  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(e = {}) {
    const { locale: n, numberingSystem: s, calendar: r } = Y.create(
      this.loc.clone(e),
      e
    ).resolvedOptions(this);
    return { locale: n, numberingSystem: s, outputCalendar: r };
  }
  // TRANSFORM
  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(e = 0, n = {}) {
    return this.setZone(G.instance(e), n);
  }
  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(P.defaultZone);
  }
  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(e, { keepLocalTime: n = !1, keepCalendarTime: s = !1 } = {}) {
    if (e = Ie(e, P.defaultZone), e.equals(this.zone))
      return this;
    if (e.isValid) {
      let r = this.ts;
      if (n || s) {
        const i = e.offset(this.ts), o = this.toObject();
        [r] = Qt(o, i, e);
      }
      return $e(this, { ts: r, zone: e });
    } else
      return k.invalid(Ot(e));
  }
  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale: e, numberingSystem: n, outputCalendar: s } = {}) {
    const r = this.loc.clone({ locale: e, numberingSystem: n, outputCalendar: s });
    return $e(this, { loc: r });
  }
  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(e) {
    return this.reconfigure({ locale: e });
  }
  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(e) {
    if (!this.isValid) return this;
    const n = cn(e, Or), { minDaysInFirstWeek: s, startOfWeek: r } = ur(n, this.loc), i = !N(n.weekYear) || !N(n.weekNumber) || !N(n.weekday), o = !N(n.ordinal), a = !N(n.year), l = !N(n.month) || !N(n.day), u = a || l, c = n.weekYear || n.weekNumber;
    if ((u || o) && c)
      throw new it(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (l && o)
      throw new it("Can't mix ordinal dates with month/day");
    let d;
    i ? d = ar(
      { ...ln(this.c, s, r), ...n },
      s,
      r
    ) : N(n.ordinal) ? (d = { ...this.toObject(), ...n }, N(n.day) && (d.day = Math.min(un(d.year, d.month), d.day))) : d = lr({ ...Cn(this.c), ...n });
    const [m, h] = Qt(d, this.o, this.zone);
    return $e(this, { ts: m, o: h });
  }
  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(e) {
    if (!this.isValid) return this;
    const n = V.fromDurationLike(e);
    return $e(this, Sr(this, n));
  }
  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(e) {
    if (!this.isValid) return this;
    const n = V.fromDurationLike(e).negate();
    return $e(this, Sr(this, n));
  }
  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(e, { useLocaleWeeks: n = !1 } = {}) {
    if (!this.isValid) return this;
    const s = {}, r = V.normalizeUnit(e);
    switch (r) {
      case "years":
        s.month = 1;
      case "quarters":
      case "months":
        s.day = 1;
      case "weeks":
      case "days":
        s.hour = 0;
      case "hours":
        s.minute = 0;
      case "minutes":
        s.second = 0;
      case "seconds":
        s.millisecond = 0;
        break;
    }
    if (r === "weeks")
      if (n) {
        const i = this.loc.getStartOfWeek(), { weekday: o } = this;
        o < i && (s.weekNumber = this.weekNumber - 1), s.weekday = i;
      } else
        s.weekday = 1;
    if (r === "quarters") {
      const i = Math.ceil(this.month / 3);
      s.month = (i - 1) * 3 + 1;
    }
    return this.set(s);
  }
  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(e, n) {
    return this.isValid ? this.plus({ [e]: 1 }).startOf(e, n).minus(1) : this;
  }
  // OUTPUT
  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(e, n = {}) {
    return this.isValid ? Y.create(this.loc.redefaultToEN(n)).formatDateTimeFromString(this, e) : Fn;
  }
  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(e = an, n = {}) {
    return this.isValid ? Y.create(this.loc.clone(n), e).formatDateTime(this) : Fn;
  }
  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(e = {}) {
    return this.isValid ? Y.create(this.loc.clone(e), e).formatDateTimeParts(this) : [];
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */
  toISO({
    format: e = "extended",
    suppressSeconds: n = !1,
    suppressMilliseconds: s = !1,
    includeOffset: r = !0,
    extendedZone: i = !1
  } = {}) {
    if (!this.isValid)
      return null;
    const o = e === "extended";
    let a = $n(this, o);
    return a += "T", a += vr(this, o, n, s, r, i), a;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */
  toISODate({ format: e = "extended" } = {}) {
    return this.isValid ? $n(this, e === "extended") : null;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return Bt(this, "kkkk-'W'WW-c");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds: e = !1,
    suppressSeconds: n = !1,
    includeOffset: s = !0,
    includePrefix: r = !1,
    extendedZone: i = !1,
    format: o = "extended"
  } = {}) {
    return this.isValid ? (r ? "T" : "") + vr(
      this,
      o === "extended",
      n,
      e,
      s,
      i
    ) : null;
  }
  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return Bt(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", !1);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return Bt(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */
  toSQLDate() {
    return this.isValid ? $n(this, !0) : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset: e = !0, includeZone: n = !1, includeOffsetSpace: s = !0 } = {}) {
    let r = "HH:mm:ss.SSS";
    return (n || e) && (s && (r += " "), n ? r += "z" : e && (r += "ZZ")), Bt(this, r, !0);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(e = {}) {
    return this.isValid ? `${this.toSQLDate()} ${this.toSQLTime(e)}` : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : Fn;
  }
  /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }` : `DateTime { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }
  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(e = {}) {
    if (!this.isValid) return {};
    const n = { ...this.c };
    return e.includeConfig && (n.outputCalendar = this.outputCalendar, n.numberingSystem = this.loc.numberingSystem, n.locale = this.loc.locale), n;
  }
  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(e, n = "milliseconds", s = {}) {
    if (!this.isValid || !e.isValid)
      return V.invalid("created by diffing an invalid DateTime");
    const r = { locale: this.locale, numberingSystem: this.numberingSystem, ...s }, i = Bu(n).map(V.normalizeUnit), o = e.valueOf() > this.valueOf(), a = o ? this : e, l = o ? e : this, u = Zc(a, l, i, r);
    return o ? u.negate() : u;
  }
  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(e = "milliseconds", n = {}) {
    return this.diff(k.now(), e, n);
  }
  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */
  until(e) {
    return this.isValid ? L.fromDateTimes(this, e) : this;
  }
  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(e, n, s) {
    if (!this.isValid) return !1;
    const r = e.valueOf(), i = this.setZone(e.zone, { keepLocalTime: !0 });
    return i.startOf(n, s) <= r && r <= i.endOf(n, s);
  }
  /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(e) {
    return this.isValid && e.isValid && this.valueOf() === e.valueOf() && this.zone.equals(e.zone) && this.loc.equals(e.loc);
  }
  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(e = {}) {
    if (!this.isValid) return null;
    const n = e.base || k.fromObject({}, { zone: this.zone }), s = e.padding ? this < n ? -e.padding : e.padding : 0;
    let r = ["years", "months", "days", "hours", "minutes", "seconds"], i = e.unit;
    return Array.isArray(e.unit) && (r = e.unit, i = void 0), Tr(n, this.plus(s), {
      ...e,
      numeric: "always",
      units: r,
      unit: i
    });
  }
  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(e = {}) {
    return this.isValid ? Tr(e.base || k.fromObject({}, { zone: this.zone }), this, {
      ...e,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: !0
    }) : null;
  }
  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...e) {
    if (!e.every(k.isDateTime))
      throw new J("min requires all arguments be DateTimes");
    return cr(e, (n) => n.valueOf(), Math.min);
  }
  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...e) {
    if (!e.every(k.isDateTime))
      throw new J("max requires all arguments be DateTimes");
    return cr(e, (n) => n.valueOf(), Math.max);
  }
  // MISC
  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(e, n, s = {}) {
    const { locale: r = null, numberingSystem: i = null } = s, o = A.fromOpts({
      locale: r,
      numberingSystem: i,
      defaultToEN: !0
    });
    return bo(o, e, n);
  }
  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(e, n, s = {}) {
    return k.fromFormatExplain(e, n, s);
  }
  /**
   * Build a parser for `fmt` using the given locale. This parser can be passed
   * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
   * can be used to optimize cases where many dates need to be parsed in a
   * specific format.
   *
   * @param {String} fmt - the format the string is expected to be in (see
   * description)
   * @param {Object} options - options used to set locale and numberingSystem
   * for parser
   * @returns {TokenParser} - opaque object to be used
   */
  static buildFormatParser(e, n = {}) {
    const { locale: s = null, numberingSystem: r = null } = n, i = A.fromOpts({
      locale: s,
      numberingSystem: r,
      defaultToEN: !0
    });
    return new go(i, e);
  }
  /**
   * Create a DateTime from an input string and format parser.
   *
   * The format parser must have been created with the same locale as this call.
   *
   * @param {String} text - the string to parse
   * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
   * @param {Object} opts - options taken by fromFormat()
   * @returns {DateTime}
   */
  static fromFormatParser(e, n, s = {}) {
    if (N(e) || N(n))
      throw new J(
        "fromFormatParser requires an input string and a format parser"
      );
    const { locale: r = null, numberingSystem: i = null } = s, o = A.fromOpts({
      locale: r,
      numberingSystem: i,
      defaultToEN: !0
    });
    if (!o.equals(n.locale))
      throw new J(
        `fromFormatParser called with a locale of ${o}, but the format parser was created for ${n.locale}`
      );
    const { result: a, zone: l, specificOffset: u, invalidReason: c } = n.explainFromTokens(e);
    return c ? k.invalid(c) : et(
      a,
      l,
      s,
      `format ${n.format}`,
      e,
      u
    );
  }
  // FORMAT PRESETS
  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return an;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return Ei;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return pu;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return Ti;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return ki;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return Ni;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return _i;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return Di;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return xi;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return Ii;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return Vi;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return Ci;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return Ai;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return Fi;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return Mi;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return Ri;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return $i;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return yu;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return Li;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return Pi;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return Ui;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return Wi;
  }
}
function St(t) {
  if (k.isDateTime(t))
    return t;
  if (t && t.valueOf && Ce(t.valueOf()))
    return k.fromJSDate(t);
  if (t && typeof t == "object")
    return k.fromObject(t);
  throw new J(
    `Unknown datetime argument: ${t}, of type ${typeof t}`
  );
}
var hd = Object.defineProperty, md = Object.defineProperties, pd = Object.getOwnPropertyDescriptors, Nr = Object.getOwnPropertySymbols, yd = Object.prototype.hasOwnProperty, gd = Object.prototype.propertyIsEnumerable, _r = (t, e, n) => e in t ? hd(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, tt = (t, e) => {
  for (var n in e || (e = {}))
    yd.call(e, n) && _r(t, n, e[n]);
  if (Nr)
    for (var n of Nr(e))
      gd.call(e, n) && _r(t, n, e[n]);
  return t;
}, Dr = (t, e) => md(t, pd(e));
const bd = {
  props: {
    autoscroll: {
      type: Boolean,
      default: !0
    }
  },
  watch: {
    typeAheadPointer() {
      this.autoscroll && this.maybeAdjustScroll();
    },
    open(t) {
      this.autoscroll && t && this.$nextTick(() => this.maybeAdjustScroll());
    }
  },
  methods: {
    maybeAdjustScroll() {
      var t;
      const e = ((t = this.$refs.dropdownMenu) == null ? void 0 : t.children[this.typeAheadPointer]) || !1;
      if (e) {
        const n = this.getDropdownViewport(), { top: s, bottom: r, height: i } = e.getBoundingClientRect();
        if (s < n.top)
          return this.$refs.dropdownMenu.scrollTop = e.offsetTop;
        if (r > n.bottom)
          return this.$refs.dropdownMenu.scrollTop = e.offsetTop - (n.height - i);
      }
    },
    getDropdownViewport() {
      return this.$refs.dropdownMenu ? this.$refs.dropdownMenu.getBoundingClientRect() : {
        height: 0,
        top: 0,
        bottom: 0
      };
    }
  }
}, wd = {
  data() {
    return {
      typeAheadPointer: -1
    };
  },
  watch: {
    filteredOptions() {
      for (let t = 0; t < this.filteredOptions.length; t++)
        if (this.selectable(this.filteredOptions[t])) {
          this.typeAheadPointer = t;
          break;
        }
    },
    open(t) {
      t && this.typeAheadToLastSelected();
    },
    selectedValue() {
      this.open && this.typeAheadToLastSelected();
    }
  },
  methods: {
    typeAheadUp() {
      for (let t = this.typeAheadPointer - 1; t >= 0; t--)
        if (this.selectable(this.filteredOptions[t])) {
          this.typeAheadPointer = t;
          break;
        }
    },
    typeAheadDown() {
      for (let t = this.typeAheadPointer + 1; t < this.filteredOptions.length; t++)
        if (this.selectable(this.filteredOptions[t])) {
          this.typeAheadPointer = t;
          break;
        }
    },
    typeAheadSelect() {
      const t = this.filteredOptions[this.typeAheadPointer];
      t && this.selectable(t) && this.select(t);
    },
    typeAheadToLastSelected() {
      this.typeAheadPointer = this.selectedValue.length !== 0 ? this.filteredOptions.indexOf(this.selectedValue[this.selectedValue.length - 1]) : -1;
    }
  }
}, Sd = {
  props: {
    loading: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      mutableLoading: !1
    };
  },
  watch: {
    search() {
      this.$emit("search", this.search, this.toggleLoading);
    },
    loading(t) {
      this.mutableLoading = t;
    }
  },
  methods: {
    toggleLoading(t = null) {
      return t == null ? this.mutableLoading = !this.mutableLoading : this.mutableLoading = t;
    }
  }
}, vs = (t, e) => {
  const n = t.__vccOpts || t;
  for (const [s, r] of e)
    n[s] = r;
  return n;
}, vd = {}, Od = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "10"
}, Ed = /* @__PURE__ */ D("path", { d: "M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z" }, null, -1), Td = [
  Ed
];
function kd(t, e) {
  return S(), E("svg", Od, Td);
}
const Nd = /* @__PURE__ */ vs(vd, [["render", kd]]), _d = {}, Dd = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "10"
}, xd = /* @__PURE__ */ D("path", { d: "M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z" }, null, -1), Id = [
  xd
];
function Vd(t, e) {
  return S(), E("svg", Dd, Id);
}
const Cd = /* @__PURE__ */ vs(_d, [["render", Vd]]), xr = {
  Deselect: Nd,
  OpenIndicator: Cd
}, Ad = {
  mounted(t, { instance: e }) {
    if (e.appendToBody) {
      const {
        height: n,
        top: s,
        left: r,
        width: i
      } = e.$refs.toggle.getBoundingClientRect();
      let o = window.scrollX || window.pageXOffset, a = window.scrollY || window.pageYOffset;
      t.unbindPosition = e.calculatePosition(t, e, {
        width: i + "px",
        left: o + r + "px",
        top: a + s + n + "px"
      }), document.body.appendChild(t);
    }
  },
  unmounted(t, { instance: e }) {
    e.appendToBody && (t.unbindPosition && typeof t.unbindPosition == "function" && t.unbindPosition(), t.parentNode && t.parentNode.removeChild(t));
  }
};
function Fd(t) {
  const e = {};
  return Object.keys(t).sort().forEach((n) => {
    e[n] = t[n];
  }), JSON.stringify(e);
}
let Md = 0;
function Rd() {
  return ++Md;
}
const $d = {
  components: tt({}, xr),
  directives: { appendToBody: Ad },
  mixins: [bd, wd, Sd],
  compatConfig: {
    MODE: 3
  },
  emits: [
    "open",
    "close",
    "update:modelValue",
    "search",
    "search:compositionstart",
    "search:compositionend",
    "search:keydown",
    "search:blur",
    "search:focus",
    "search:input",
    "option:created",
    "option:selecting",
    "option:selected",
    "option:deselecting",
    "option:deselected"
  ],
  props: {
    modelValue: {},
    components: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    clearable: {
      type: Boolean,
      default: !0
    },
    deselectFromDropdown: {
      type: Boolean,
      default: !1
    },
    searchable: {
      type: Boolean,
      default: !0
    },
    multiple: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: ""
    },
    transition: {
      type: String,
      default: "vs__fade"
    },
    clearSearchOnSelect: {
      type: Boolean,
      default: !0
    },
    closeOnSelect: {
      type: Boolean,
      default: !0
    },
    label: {
      type: String,
      default: "label"
    },
    autocomplete: {
      type: String,
      default: "off"
    },
    reduce: {
      type: Function,
      default: (t) => t
    },
    selectable: {
      type: Function,
      default: (t) => !0
    },
    getOptionLabel: {
      type: Function,
      default(t) {
        return typeof t == "object" ? t.hasOwnProperty(this.label) ? t[this.label] : console.warn(`[vue-select warn]: Label key "option.${this.label}" does not exist in options object ${JSON.stringify(t)}.
https://vue-select.org/api/props.html#getoptionlabel`) : t;
      }
    },
    getOptionKey: {
      type: Function,
      default(t) {
        if (typeof t != "object")
          return t;
        try {
          return t.hasOwnProperty("id") ? t.id : Fd(t);
        } catch (e) {
          return console.warn(`[vue-select warn]: Could not stringify this option to generate unique key. Please provide'getOptionKey' prop to return a unique key for each option.
https://vue-select.org/api/props.html#getoptionkey`, t, e);
        }
      }
    },
    onTab: {
      type: Function,
      default: function() {
        this.selectOnTab && !this.isComposing && this.typeAheadSelect();
      }
    },
    taggable: {
      type: Boolean,
      default: !1
    },
    tabindex: {
      type: Number,
      default: null
    },
    pushTags: {
      type: Boolean,
      default: !1
    },
    filterable: {
      type: Boolean,
      default: !0
    },
    filterBy: {
      type: Function,
      default(t, e, n) {
        return (e || "").toLocaleLowerCase().indexOf(n.toLocaleLowerCase()) > -1;
      }
    },
    filter: {
      type: Function,
      default(t, e) {
        return t.filter((n) => {
          let s = this.getOptionLabel(n);
          return typeof s == "number" && (s = s.toString()), this.filterBy(n, s, e);
        });
      }
    },
    createOption: {
      type: Function,
      default(t) {
        return typeof this.optionList[0] == "object" ? { [this.label]: t } : t;
      }
    },
    resetOnOptionsChange: {
      default: !1,
      validator: (t) => ["function", "boolean"].includes(typeof t)
    },
    clearSearchOnBlur: {
      type: Function,
      default: function({ clearSearchOnSelect: t, multiple: e }) {
        return t && !e;
      }
    },
    noDrop: {
      type: Boolean,
      default: !1
    },
    inputId: {
      type: String
    },
    dir: {
      type: String,
      default: "auto"
    },
    selectOnTab: {
      type: Boolean,
      default: !1
    },
    selectOnKeyCodes: {
      type: Array,
      default: () => [13]
    },
    searchInputQuerySelector: {
      type: String,
      default: "[type=search]"
    },
    mapKeydown: {
      type: Function,
      default: (t, e) => t
    },
    appendToBody: {
      type: Boolean,
      default: !1
    },
    calculatePosition: {
      type: Function,
      default(t, e, { width: n, top: s, left: r }) {
        t.style.top = s, t.style.left = r, t.style.width = n;
      }
    },
    dropdownShouldOpen: {
      type: Function,
      default({ noDrop: t, open: e, mutableLoading: n }) {
        return t ? !1 : e && !n;
      }
    },
    uid: {
      type: [String, Number],
      default: () => Rd()
    }
  },
  data() {
    return {
      search: "",
      open: !1,
      isComposing: !1,
      pushedTags: [],
      _value: [],
      deselectButtons: []
    };
  },
  computed: {
    isReducingValues() {
      return this.$props.reduce !== this.$options.props.reduce.default;
    },
    isTrackingValues() {
      return typeof this.modelValue > "u" || this.isReducingValues;
    },
    selectedValue() {
      let t = this.modelValue;
      return this.isTrackingValues && (t = this.$data._value), t != null && t !== "" ? [].concat(t) : [];
    },
    optionList() {
      return this.options.concat(this.pushTags ? this.pushedTags : []);
    },
    searchEl() {
      return this.$slots.search ? this.$refs.selectedOptions.querySelector(this.searchInputQuerySelector) : this.$refs.search;
    },
    scope() {
      const t = {
        search: this.search,
        loading: this.loading,
        searching: this.searching,
        filteredOptions: this.filteredOptions
      };
      return {
        search: {
          attributes: tt({
            disabled: this.disabled,
            placeholder: this.searchPlaceholder,
            tabindex: this.tabindex,
            readonly: !this.searchable,
            id: this.inputId,
            "aria-autocomplete": "list",
            "aria-labelledby": `vs${this.uid}__combobox`,
            "aria-controls": `vs${this.uid}__listbox`,
            ref: "search",
            type: "search",
            autocomplete: this.autocomplete,
            value: this.search
          }, this.dropdownOpen && this.filteredOptions[this.typeAheadPointer] ? {
            "aria-activedescendant": `vs${this.uid}__option-${this.typeAheadPointer}`
          } : {}),
          events: {
            compositionstart: () => this.isComposing = !0,
            compositionend: () => this.isComposing = !1,
            keydown: this.onSearchKeyDown,
            blur: this.onSearchBlur,
            focus: this.onSearchFocus,
            input: (e) => this.search = e.target.value
          }
        },
        spinner: {
          loading: this.mutableLoading
        },
        noOptions: {
          search: this.search,
          loading: this.mutableLoading,
          searching: this.searching
        },
        openIndicator: {
          attributes: {
            ref: "openIndicator",
            role: "presentation",
            class: "vs__open-indicator"
          }
        },
        listHeader: t,
        listFooter: t,
        header: Dr(tt({}, t), { deselect: this.deselect }),
        footer: Dr(tt({}, t), { deselect: this.deselect })
      };
    },
    childComponents() {
      return tt(tt({}, xr), this.components);
    },
    stateClasses() {
      return {
        "vs--open": this.dropdownOpen,
        "vs--single": !this.multiple,
        "vs--multiple": this.multiple,
        "vs--searching": this.searching && !this.noDrop,
        "vs--searchable": this.searchable && !this.noDrop,
        "vs--unsearchable": !this.searchable,
        "vs--loading": this.mutableLoading,
        "vs--disabled": this.disabled
      };
    },
    searching() {
      return !!this.search;
    },
    dropdownOpen() {
      return this.dropdownShouldOpen(this);
    },
    searchPlaceholder() {
      return this.isValueEmpty && this.placeholder ? this.placeholder : void 0;
    },
    filteredOptions() {
      const t = [].concat(this.optionList);
      if (!this.filterable && !this.taggable)
        return t;
      const e = this.search.length ? this.filter(t, this.search, this) : t;
      if (this.taggable && this.search.length) {
        const n = this.createOption(this.search);
        this.optionExists(n) || e.unshift(n);
      }
      return e;
    },
    isValueEmpty() {
      return this.selectedValue.length === 0;
    },
    showClearButton() {
      return !this.multiple && this.clearable && !this.open && !this.isValueEmpty;
    }
  },
  watch: {
    options(t, e) {
      const n = () => typeof this.resetOnOptionsChange == "function" ? this.resetOnOptionsChange(t, e, this.selectedValue) : this.resetOnOptionsChange;
      !this.taggable && n() && this.clearSelection(), this.modelValue && this.isTrackingValues && this.setInternalValueFromOptions(this.modelValue);
    },
    modelValue: {
      immediate: !0,
      handler(t) {
        this.isTrackingValues && this.setInternalValueFromOptions(t);
      }
    },
    multiple() {
      this.clearSelection();
    },
    open(t) {
      this.$emit(t ? "open" : "close");
    }
  },
  created() {
    this.mutableLoading = this.loading;
  },
  methods: {
    setInternalValueFromOptions(t) {
      Array.isArray(t) ? this.$data._value = t.map((e) => this.findOptionFromReducedValue(e)) : this.$data._value = this.findOptionFromReducedValue(t);
    },
    select(t) {
      this.$emit("option:selecting", t), this.isOptionSelected(t) ? this.deselectFromDropdown && (this.clearable || this.multiple && this.selectedValue.length > 1) && this.deselect(t) : (this.taggable && !this.optionExists(t) && (this.$emit("option:created", t), this.pushTag(t)), this.multiple && (t = this.selectedValue.concat(t)), this.updateValue(t), this.$emit("option:selected", t)), this.onAfterSelect(t);
    },
    deselect(t) {
      this.$emit("option:deselecting", t), this.updateValue(this.selectedValue.filter((e) => !this.optionComparator(e, t))), this.$emit("option:deselected", t);
    },
    clearSelection() {
      this.updateValue(this.multiple ? [] : null);
    },
    onAfterSelect(t) {
      this.closeOnSelect && (this.open = !this.open, this.searchEl.blur()), this.clearSearchOnSelect && (this.search = "");
    },
    updateValue(t) {
      typeof this.modelValue > "u" && (this.$data._value = t), t !== null && (Array.isArray(t) ? t = t.map((e) => this.reduce(e)) : t = this.reduce(t)), this.$emit("update:modelValue", t);
    },
    toggleDropdown(t) {
      const e = t.target !== this.searchEl;
      e && t.preventDefault();
      const n = [
        ...this.deselectButtons || [],
        this.$refs.clearButton
      ];
      if (this.searchEl === void 0 || n.filter(Boolean).some((s) => s.contains(t.target) || s === t.target)) {
        t.preventDefault();
        return;
      }
      this.open && e ? this.searchEl.blur() : this.disabled || (this.open = !0, this.searchEl.focus());
    },
    isOptionSelected(t) {
      return this.selectedValue.some((e) => this.optionComparator(e, t));
    },
    isOptionDeselectable(t) {
      return this.isOptionSelected(t) && this.deselectFromDropdown;
    },
    optionComparator(t, e) {
      return this.getOptionKey(t) === this.getOptionKey(e);
    },
    findOptionFromReducedValue(t) {
      const e = (s) => JSON.stringify(this.reduce(s)) === JSON.stringify(t), n = [...this.options, ...this.pushedTags].filter(e);
      return n.length === 1 ? n[0] : n.find((s) => this.optionComparator(s, this.$data._value)) || t;
    },
    closeSearchOptions() {
      this.open = !1, this.$emit("search:blur");
    },
    maybeDeleteValue() {
      if (!this.searchEl.value.length && this.selectedValue && this.selectedValue.length && this.clearable) {
        let t = null;
        this.multiple && (t = [
          ...this.selectedValue.slice(0, this.selectedValue.length - 1)
        ]), this.updateValue(t);
      }
    },
    optionExists(t) {
      return this.optionList.some((e) => this.optionComparator(e, t));
    },
    normalizeOptionForSlot(t) {
      return typeof t == "object" ? t : { [this.label]: t };
    },
    pushTag(t) {
      this.pushedTags.push(t);
    },
    onEscape() {
      this.search.length ? this.search = "" : this.searchEl.blur();
    },
    onSearchBlur() {
      if (this.mousedown && !this.searching)
        this.mousedown = !1;
      else {
        const { clearSearchOnSelect: t, multiple: e } = this;
        this.clearSearchOnBlur({ clearSearchOnSelect: t, multiple: e }) && (this.search = ""), this.closeSearchOptions();
        return;
      }
      if (this.search.length === 0 && this.options.length === 0) {
        this.closeSearchOptions();
        return;
      }
    },
    onSearchFocus() {
      this.open = !0, this.$emit("search:focus");
    },
    onMousedown() {
      this.mousedown = !0;
    },
    onMouseUp() {
      this.mousedown = !1;
    },
    onSearchKeyDown(t) {
      const e = (r) => (r.preventDefault(), !this.isComposing && this.typeAheadSelect()), n = {
        8: (r) => this.maybeDeleteValue(),
        9: (r) => this.onTab(),
        27: (r) => this.onEscape(),
        38: (r) => (r.preventDefault(), this.typeAheadUp()),
        40: (r) => (r.preventDefault(), this.typeAheadDown())
      };
      this.selectOnKeyCodes.forEach((r) => n[r] = e);
      const s = this.mapKeydown(n, this);
      if (typeof s[t.keyCode] == "function")
        return s[t.keyCode](t);
    }
  }
}, Ld = ["dir"], Pd = ["id", "aria-expanded", "aria-owns"], Ud = {
  ref: "selectedOptions",
  class: "vs__selected-options"
}, Wd = ["disabled", "title", "aria-label", "onClick"], qd = {
  ref: "actions",
  class: "vs__actions"
}, Bd = ["disabled"], jd = { class: "vs__spinner" }, zd = ["id"], Hd = ["id", "aria-selected", "onMouseover", "onClick"], Zd = {
  key: 0,
  class: "vs__no-options"
}, Jd = /* @__PURE__ */ ut(" Sorry, no matching options. "), Yd = ["id"];
function Gd(t, e, n, s, r, i) {
  const o = Vo("append-to-body");
  return S(), E("div", {
    dir: n.dir,
    class: He(["v-select", i.stateClasses])
  }, [
    W(t.$slots, "header", ue(ge(i.scope.header))),
    D("div", {
      id: `vs${n.uid}__combobox`,
      ref: "toggle",
      class: "vs__dropdown-toggle",
      role: "combobox",
      "aria-expanded": i.dropdownOpen.toString(),
      "aria-owns": `vs${n.uid}__listbox`,
      "aria-label": "Search for option",
      onMousedown: e[1] || (e[1] = (a) => i.toggleDropdown(a))
    }, [
      D("div", Ud, [
        (S(!0), E(be, null, lt(i.selectedValue, (a, l) => W(t.$slots, "selected-option-container", {
          option: i.normalizeOptionForSlot(a),
          deselect: i.deselect,
          multiple: n.multiple,
          disabled: n.disabled
        }, () => [
          (S(), E("span", {
            key: n.getOptionKey(a),
            class: "vs__selected"
          }, [
            W(t.$slots, "selected-option", ue(ge(i.normalizeOptionForSlot(a))), () => [
              ut(me(n.getOptionLabel(a)), 1)
            ]),
            n.multiple ? (S(), E("button", {
              key: 0,
              ref_for: !0,
              ref: (u) => r.deselectButtons[l] = u,
              disabled: n.disabled,
              type: "button",
              class: "vs__deselect",
              title: `Deselect ${n.getOptionLabel(a)}`,
              "aria-label": `Deselect ${n.getOptionLabel(a)}`,
              onClick: (u) => i.deselect(a)
            }, [
              (S(), we(jt(i.childComponents.Deselect)))
            ], 8, Wd)) : Se("", !0)
          ]))
        ])), 256)),
        W(t.$slots, "search", ue(ge(i.scope.search)), () => [
          D("input", Nt({ class: "vs__search" }, i.scope.search.attributes, Co(i.scope.search.events)), null, 16)
        ])
      ], 512),
      D("div", qd, [
        Te(D("button", {
          ref: "clearButton",
          disabled: n.disabled,
          type: "button",
          class: "vs__clear",
          title: "Clear Selected",
          "aria-label": "Clear Selected",
          onClick: e[0] || (e[0] = (...a) => i.clearSelection && i.clearSelection(...a))
        }, [
          (S(), we(jt(i.childComponents.Deselect)))
        ], 8, Bd), [
          [Ts, i.showClearButton]
        ]),
        W(t.$slots, "open-indicator", ue(ge(i.scope.openIndicator)), () => [
          n.noDrop ? Se("", !0) : (S(), we(jt(i.childComponents.OpenIndicator), ue(Nt({ key: 0 }, i.scope.openIndicator.attributes)), null, 16))
        ]),
        W(t.$slots, "spinner", ue(ge(i.scope.spinner)), () => [
          Te(D("div", jd, "Loading...", 512), [
            [Ts, t.mutableLoading]
          ])
        ])
      ], 512)
    ], 40, Pd),
    U(Ao, { name: n.transition }, {
      default: Ee(() => [
        i.dropdownOpen ? Te((S(), E("ul", {
          id: `vs${n.uid}__listbox`,
          ref: "dropdownMenu",
          key: `vs${n.uid}__listbox`,
          class: "vs__dropdown-menu",
          role: "listbox",
          tabindex: "-1",
          onMousedown: e[2] || (e[2] = Ln((...a) => i.onMousedown && i.onMousedown(...a), ["prevent"])),
          onMouseup: e[3] || (e[3] = (...a) => i.onMouseUp && i.onMouseUp(...a))
        }, [
          W(t.$slots, "list-header", ue(ge(i.scope.listHeader))),
          (S(!0), E(be, null, lt(i.filteredOptions, (a, l) => (S(), E("li", {
            id: `vs${n.uid}__option-${l}`,
            key: n.getOptionKey(a),
            role: "option",
            class: He(["vs__dropdown-option", {
              "vs__dropdown-option--deselect": i.isOptionDeselectable(a) && l === t.typeAheadPointer,
              "vs__dropdown-option--selected": i.isOptionSelected(a),
              "vs__dropdown-option--highlight": l === t.typeAheadPointer,
              "vs__dropdown-option--disabled": !n.selectable(a)
            }]),
            "aria-selected": l === t.typeAheadPointer ? !0 : null,
            onMouseover: (u) => n.selectable(a) ? t.typeAheadPointer = l : null,
            onClick: Ln((u) => n.selectable(a) ? i.select(a) : null, ["prevent", "stop"])
          }, [
            W(t.$slots, "option", ue(ge(i.normalizeOptionForSlot(a))), () => [
              ut(me(n.getOptionLabel(a)), 1)
            ])
          ], 42, Hd))), 128)),
          i.filteredOptions.length === 0 ? (S(), E("li", Zd, [
            W(t.$slots, "no-options", ue(ge(i.scope.noOptions)), () => [
              Jd
            ])
          ])) : Se("", !0),
          W(t.$slots, "list-footer", ue(ge(i.scope.listFooter)))
        ], 40, zd)), [
          [o]
        ]) : (S(), E("ul", {
          key: 1,
          id: `vs${n.uid}__listbox`,
          role: "listbox",
          style: { display: "none", visibility: "hidden" }
        }, null, 8, Yd))
      ]),
      _: 3
    }, 8, ["name"]),
    W(t.$slots, "footer", ue(ge(i.scope.footer)))
  ], 10, Ld);
}
const ns = /* @__PURE__ */ vs($d, [["render", Gd]]), Kd = ["disabled"], Qd = ["value"], Xd = ["disabled"], ef = ["value"], tf = ["name"], nf = {
  __name: "BirthdateInput",
  props: /* @__PURE__ */ Fe({
    type: { type: String, default: "text" },
    name: { type: String, required: !0 },
    required: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = [
      { label: "January", value: "01", days: 31 },
      { label: "February", value: "02", days: 29 },
      { label: "March", value: "03", days: 31 },
      { label: "April", value: "04", days: 30 },
      { label: "May", value: "05", days: 31 },
      { label: "June", value: "06", days: 30 },
      { label: "July", value: "07", days: 31 },
      { label: "August", value: "08", days: 31 },
      { label: "September", value: "09", days: 30 },
      { label: "October", value: "10", days: 31 },
      { label: "November", value: "11", days: 30 },
      { label: "December", value: "12", days: 31 }
    ], n = e.map((d) => ({ label: d.label, value: d.value })), s = K("useEnhancedSelect"), r = K("eclubPluginOptions"), i = It(t, "modelValue"), o = Ae(() => {
      const d = k.fromISO(i.value);
      if (d.isValid)
        return d;
    }), a = B(o.value ? o.value.toFormat("MM") : ""), l = B(o.value ? o.value.toFormat("dd") : ""), u = Ae(() => {
      const d = e.find((h) => h.value == a.value), m = [];
      if (!d)
        return m;
      for (let h = 1; h <= d.days; h++)
        m.push({ label: h, value: h.toString().padStart(2, "0") });
      return m;
    });
    tn(a, c), tn(l, c);
    function c() {
      if (l.value && a.value) {
        const d = [k.now().toFormat("yyyy"), a.value, l.value + "T00:00:00Z"];
        i.value = d.join("-");
      } else
        i.value = null;
    }
    return (d, m) => (S(), E(be, null, [
      j(s) ? (S(), E(be, { key: 0 }, [
        D("div", null, [
          U(j(ns), Nt({
            options: j(n),
            modelValue: a.value,
            "onUpdate:modelValue": m[0] || (m[0] = (h) => a.value = h),
            clearable: !1,
            placeholder: "Month",
            reduce: (h) => h.value
          }, j(r).vSelectProps || {}, { disabled: t.disabled }), null, 16, ["options", "modelValue", "reduce", "disabled"])
        ]),
        D("div", null, [
          U(j(ns), Nt({
            options: u.value,
            modelValue: l.value,
            "onUpdate:modelValue": m[1] || (m[1] = (h) => l.value = h),
            clearable: !1,
            placeholder: "Day",
            reduce: (h) => h.value
          }, j(r).vSelectProps || {}, {
            disabled: !u.value.length || t.disabled
          }), null, 16, ["options", "modelValue", "reduce", "disabled"])
        ])
      ], 64)) : (S(), E(be, { key: 1 }, [
        Te(D("select", {
          name: "birthdate_month",
          "onUpdate:modelValue": m[2] || (m[2] = (h) => a.value = h),
          disabled: t.disabled,
          class: "pappas-eclub-birthdate-month"
        }, [
          m[5] || (m[5] = D("option", { value: "" }, "Month", -1)),
          (S(!0), E(be, null, lt(j(n), (h) => (S(), E("option", {
            value: h.value
          }, me(h.label), 9, Qd))), 256))
        ], 8, Kd), [
          [Pn, a.value]
        ]),
        Te(D("select", {
          name: "birthdate_day",
          "onUpdate:modelValue": m[3] || (m[3] = (h) => l.value = h),
          class: "pappas-eclub-birthdate-day",
          disabled: !u.value.length || t.disabled
        }, [
          m[6] || (m[6] = D("option", { value: "" }, "Day", -1)),
          (S(!0), E(be, null, lt(u.value, (h) => (S(), E("option", {
            value: h.value
          }, me(h.label), 9, ef))), 256))
        ], 8, Xd), [
          [Pn, l.value]
        ])
      ], 64)),
      Te(D("input", {
        type: "hidden",
        name: t.name,
        "onUpdate:modelValue": m[4] || (m[4] = (h) => i.value = h)
      }, null, 8, tf), [
        [Ar, i.value]
      ])
    ], 64));
  }
}, sf = { key: 0 }, rf = ["name", "required", "disabled"], of = {
  key: 0,
  value: ""
}, af = ["value"], lf = ["name"], Ir = {
  __name: "LocationInput",
  props: /* @__PURE__ */ Fe({
    name: { type: String, required: !0 },
    required: { type: Boolean, default: !1 },
    placeholder: { type: String, default: "Choose a location" },
    disabled: { type: Boolean, default: !1 }
  }, {
    modelValue: { type: String, default: "" },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Fe(["update:modelValue"], ["update:modelValue"]),
  setup(t, { emit: e }) {
    const n = e, s = K("useEnhancedSelect"), r = K("eclubPluginOptions"), i = It(t, "modelValue"), o = K("locations");
    return Fr(() => {
      !i.value && o.value.length == 1 && n("update:modelValue", o.value[0].code || o.value[0].name);
    }), (a, l) => (S(), E(be, null, [
      j(o).length > 1 ? (S(), E("div", sf, [
        j(s) ? (S(), we(j(ns), Nt({
          key: 0,
          options: j(o),
          modelValue: i.value,
          "onUpdate:modelValue": l[0] || (l[0] = (u) => i.value = u),
          clearable: !1,
          placeholder: "Favorite Location",
          label: "name",
          reduce: (u) => u.code || u.name
        }, j(r).vSelectProps || {}, { disabled: t.disabled }), null, 16, ["options", "modelValue", "reduce", "disabled"])) : Te((S(), E("select", {
          key: 1,
          name: t.name,
          required: t.required,
          "onUpdate:modelValue": l[1] || (l[1] = (u) => i.value = u),
          disabled: t.disabled
        }, [
          t.placeholder ? (S(), E("option", of, me(t.placeholder), 1)) : Se("", !0),
          (S(!0), E(be, null, lt(j(o), (u) => (S(), E("option", {
            value: u.code || u.name
          }, me(u.name), 9, af))), 256))
        ], 8, rf)), [
          [Pn, i.value]
        ])
      ])) : Se("", !0),
      Te(D("input", {
        type: "hidden",
        name: t.name,
        "onUpdate:modelValue": l[2] || (l[2] = (u) => i.value = u)
      }, null, 8, lf), [
        [Ar, i.value]
      ])
    ], 64));
  }
}, uf = ["id"], cf = { class: "pappas-eclub-field-label" }, df = {
  key: 0,
  class: "pappas-eclub-field-required"
}, ff = {
  key: 3,
  class: "pappas-eclub-field-error"
}, Le = {
  __name: "FormField",
  props: /* @__PURE__ */ Fe({
    name: { type: String, required: !0 },
    required: { type: Boolean, default: !1 },
    label: { type: String, default: null },
    type: { type: String, default: "text" },
    placeholder: { type: String, default: null },
    disabled: { type: Boolean, default: !1 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Fe(["update:modelValue"], ["update:modelValue"]),
  setup(t, { emit: e }) {
    const n = e, s = K("locations"), r = K("fieldErrors"), i = Ae(() => r.value[a.name]), o = It(t, "modelValue"), a = t, l = "pappas-eclub-input-" + a.name, u = Ae(() => a.label ? a.label : iu(a.name));
    return (c, d) => t.type == "location" && j(s).length <= 1 ? (S(), we(Ir, {
      key: 0,
      name: t.name,
      modelValue: o.value,
      "onUpdate:modelValue": d[0] || (d[0] = (m) => o.value = m),
      required: t.required,
      disabled: t.disabled
    }, null, 8, ["name", "modelValue", "required", "disabled"])) : (S(), E("div", {
      key: 1,
      class: He(["pappas-eclub-field", "pappas-eclub-field-" + t.type]),
      id: "pappas-eclub-field-" + t.name
    }, [
      D("div", cf, [
        D("label", { for: l }, [
          D("span", null, me(u.value), 1),
          t.required ? (S(), E("span", df, "*")) : Se("", !0)
        ])
      ]),
      D("div", {
        class: He(["pappas-eclub-field-input", { "pappas-eclub-field-input-error": i.value }])
      }, [
        t.type == "birthdate" ? (S(), we(nf, {
          key: 0,
          name: t.name,
          modelValue: o.value,
          "onUpdate:modelValue": d[1] || (d[1] = (m) => o.value = m),
          required: t.required,
          disabled: t.disabled
        }, null, 8, ["name", "modelValue", "required", "disabled"])) : t.type == "location" ? (S(), we(Ir, {
          key: 1,
          name: t.name,
          modelValue: o.value,
          "onUpdate:modelValue": d[2] || (d[2] = (m) => o.value = m),
          required: t.required,
          disabled: t.disabled
        }, null, 8, ["name", "modelValue", "required", "disabled"])) : (S(), we(du, {
          key: 2,
          type: t.type,
          name: t.name,
          modelValue: o.value,
          "onUpdate:modelValue": [
            d[3] || (d[3] = (m) => o.value = m),
            d[4] || (d[4] = (m) => n("update:modelValue", m))
          ],
          required: t.required,
          disabled: t.disabled,
          placeholder: t.placeholder
        }, null, 8, ["type", "name", "modelValue", "required", "disabled", "placeholder"])),
        i.value ? (S(), E("div", ff, me(i.value), 1)) : Se("", !0)
      ], 2)
    ], 10, uf));
  }
}, hf = { class: "pappas-eclub-form" }, mf = { class: "pappas-eclub-actions" }, pf = ["disabled"], Eo = {
  __name: "EclubForm",
  props: /* @__PURE__ */ Fe({
    submitting: { type: Boolean, default: !1 },
    buttonLabel: { type: String, default: "Submit" },
    handler: { type: Function, required: !0 },
    locations: { type: Array, default: () => [] }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Fe(["submit"], ["update:modelValue"]),
  setup(t, { emit: e }) {
    const n = It(t, "modelValue"), s = K("buttonClass");
    return (r, i) => (S(), E("div", hf, [
      U(Xl),
      D("form", {
        method: "",
        action: "",
        onSubmit: i[7] || (i[7] = Ln((...o) => t.handler && t.handler(...o), ["prevent"]))
      }, [
        U(Le, {
          name: "first_name",
          required: "",
          modelValue: n.value.first_name,
          "onUpdate:modelValue": i[0] || (i[0] = (o) => n.value.first_name = o),
          disabled: t.submitting
        }, null, 8, ["modelValue", "disabled"]),
        U(Le, {
          name: "last_name",
          required: "",
          modelValue: n.value.last_name,
          "onUpdate:modelValue": i[1] || (i[1] = (o) => n.value.last_name = o),
          disabled: t.submitting
        }, null, 8, ["modelValue", "disabled"]),
        U(Le, {
          type: "email",
          name: "email",
          label: "E-mail Address",
          required: "",
          modelValue: n.value.email,
          "onUpdate:modelValue": i[2] || (i[2] = (o) => n.value.email = o),
          disabled: t.submitting
        }, null, 8, ["modelValue", "disabled"]),
        U(Le, {
          type: "email",
          name: "email_confirm",
          required: "",
          label: "Confirm E-Mail",
          modelValue: n.value.email_confirm,
          "onUpdate:modelValue": i[3] || (i[3] = (o) => n.value.email_confirm = o),
          disabled: t.submitting
        }, null, 8, ["modelValue", "disabled"]),
        U(Le, {
          type: "birthdate",
          name: "birthdate",
          required: "",
          label: "Birth Date",
          modelValue: n.value.birthdate,
          "onUpdate:modelValue": i[4] || (i[4] = (o) => n.value.birthdate = o),
          disabled: t.submitting
        }, null, 8, ["modelValue", "disabled"]),
        U(Le, {
          name: "zip",
          label: "Zip Code",
          required: "",
          modelValue: n.value.zip,
          "onUpdate:modelValue": i[5] || (i[5] = (o) => n.value.zip = o),
          inputmode: "numeric",
          disabled: t.submitting
        }, null, 8, ["modelValue", "disabled"]),
        U(Le, {
          type: "location",
          name: "store_code",
          label: "Favorite Location",
          required: "",
          modelValue: n.value.store_code,
          "onUpdate:modelValue": i[6] || (i[6] = (o) => n.value.store_code = o),
          placeholder: "Select a Location",
          disabled: t.submitting
        }, null, 8, ["modelValue", "disabled"]),
        D("div", mf, [
          D("button", {
            type: "submit",
            class: He(["pappas-eclub-submit", j(s)]),
            disabled: t.submitting
          }, [
            U(yn),
            D("span", null, me(t.buttonLabel), 1)
          ], 10, pf)
        ])
      ], 32)
    ]));
  }
}, yf = { class: "pappas-eclub-join" }, gf = {
  key: 0,
  class: "pappas-eclub-header"
}, bf = {
  key: 1,
  class: "pappas-eclub-view-loading"
}, wf = { key: 2 }, Sf = { key: 3 }, vf = {
  __name: "JoinView",
  setup(t) {
    const e = as(), { locationsLoading: n } = Si(), { fieldErrors: s, addFieldErrors: r } = wi(), i = K("apiBase"), o = B({}), a = B(!1), l = B(!1), u = i;
    We("fieldErrors", s);
    function c() {
      a.value = !0, e.clearFeedback(), s.value = {}, R.post(u, o.value).then(({ data: d }) => {
        d.error ? e.addError(d.error) : l.value = !0;
      }).catch((d, m) => {
        var h;
        console.error(d, m), (h = d.response.data) != null && h.errors ? (r(d.response.data.errors), e.addError(d.response.data.message)) : d.response.status == 409 ? e.addError("This email address is already subscribed to the E-Club.") : e.addError(d.message);
      }).then(() => a.value = !1);
    }
    return (d, m) => (S(), E("div", yf, [
      l.value ? Se("", !0) : (S(), E("div", gf, [
        l.value ? Se("", !0) : W(d.$slots, "join", { key: 0 }, () => [
          m[1] || (m[1] = D("h3", null, "Join Our E-Club", -1))
        ])
      ])),
      j(n) ? (S(), E("div", bf, [
        U(yn)
      ])) : l.value ? (S(), E("div", wf, [
        U(sn, { type: "success" }, {
          default: Ee(() => [
            W(d.$slots, "thankyou", {}, () => [
              m[2] || (m[2] = D("h4", null, "Thank You!", -1)),
              m[3] || (m[3] = D("p", null, "Thank you for joining our E-Club", -1))
            ])
          ]),
          _: 3
        })
      ])) : (S(), E("div", Sf, [
        U(Eo, {
          submitting: a.value,
          modelValue: o.value,
          "onUpdate:modelValue": m[0] || (m[0] = (h) => o.value = h),
          handler: c
        }, null, 8, ["submitting", "modelValue"])
      ]))
    ]));
  }
}, Of = { class: "pappas-eclub-profile" }, Ef = { class: "pappas-eclub-header" }, Tf = {
  key: 0,
  class: "pappas-eclub-view-loading"
}, kf = { key: 1 }, Nf = { key: 2 }, _f = {
  __name: "ProfileView",
  props: {
    member: { type: [String, Number], default: "" }
  },
  setup(t) {
    const e = t, n = K("apiBase"), { locationsLoading: s } = Si(), { fieldErrors: r, addFieldErrors: i } = wi(), o = B(!0), a = B(!1), l = B(!1), u = B({}), c = B({}), d = as(), m = Ae(() => s.value || o.value);
    We("fieldErrors", r), Fr(() => h());
    function h() {
      o.value = !0, R.get(n + "/" + e.member).then(({ data: T }) => {
        u.value = T, c.value = v(T);
      }).catch((T) => {
        console.error(T), a.value = T.message;
      }).then(() => o.value = !1);
    }
    function p() {
      l.value = !0, d.clearFeedback(), r.value = {}, R.patch(n + "/" + u.value.MemberID, c.value).then(() => {
        d.addSuccess("Your profile has been updated successfully");
      }).catch((T) => {
        var x;
        console.error(T), (x = T.response.data) != null && x.errors ? (i(T.response.data.errors), d.addError(T.response.data.message)) : d.addError(T.message);
      }).then(() => l.value = !1);
    }
    function v(T) {
      return {
        first_name: g("FirstName"),
        last_name: g("LastName"),
        email: T.EmailAddress,
        email_confirm: T.EmailAddress,
        birthdate: I("Birthdate"),
        zip: g("Zip"),
        store_code: g("StoreCode")
      };
    }
    function g(T) {
      var $;
      return ($ = u.value.StringFields.find((F) => F.Name == T)) == null ? void 0 : $.Value;
    }
    function I(T) {
      var $;
      return ($ = u.value.DateFields.find((F) => F.Name == T)) == null ? void 0 : $.Value;
    }
    return (T, x) => (S(), E("div", Of, [
      D("div", Ef, [
        W(T.$slots, "update", {}, () => [
          x[1] || (x[1] = D("h3", null, "Update Your Profile", -1))
        ])
      ]),
      D("div", null, [
        m.value ? (S(), E("div", Tf, [
          U(yn)
        ])) : a.value ? (S(), E("div", kf, [
          U(sn, { type: "error" }, {
            default: Ee(() => x[2] || (x[2] = [
              D("p", null, "Unable to locate profile", -1)
            ])),
            _: 1
          })
        ])) : (S(), E("div", Nf, [
          U(Eo, {
            submitting: l.value,
            modelValue: c.value,
            "onUpdate:modelValue": x[0] || (x[0] = ($) => c.value = $),
            "button-label": "Update Profile",
            handler: p
          }, null, 8, ["submitting", "modelValue"])
        ]))
      ])
    ]));
  }
}, Df = { class: "pappas-eclub-unsubscribe" }, xf = {
  key: 0,
  class: "pappas-eclub-view-loading"
}, If = { key: 1 }, Vf = {
  key: 2,
  class: "pappas-eclub-unsubscribe-body"
}, Cf = {
  __name: "UnsubscribeView",
  props: {
    member: { type: [String, Number], default: "" }
  },
  setup(t) {
    const e = t, n = K("apiBase"), s = B(!0), r = B(!1);
    return R.delete(n + "/" + e.member).then(() => s.value = !1).catch((i) => r.value = "An unknown error has occured").then(() => s.value = !1), (i, o) => (S(), E("div", Df, [
      D("div", null, [
        s.value ? (S(), E("div", xf, [
          U(yn)
        ])) : r.value ? (S(), E("div", If, [
          U(sn, { type: "error" }, {
            default: Ee(() => [
              ut(me(r.value), 1)
            ]),
            _: 1
          })
        ])) : (S(), E("div", Vf, [
          W(i.$slots, "unsubscribed", {}, () => [
            U(sn, null, {
              default: Ee(() => o[0] || (o[0] = [
                D("p", null, "You have successfully unsubscribed from the E-Club.", -1)
              ])),
              _: 1
            })
          ])
        ]))
      ])
    ]));
  }
}, Af = {};
function Ff(t, e) {
  return S(), E("div", null, e[0] || (e[0] = [
    D("p", null, [
      ut(" The "),
      D("code", null, "concept"),
      ut(" property is required. ")
    ], -1)
  ]));
}
const Mf = /* @__PURE__ */ bi(Af, [["render", Ff], ["__scopeId", "data-v-45ed6146"]]), Rf = {
  __name: "PappasEclub",
  props: {
    concept: { type: String, required: !0 },
    apiBase: { type: String, default: "https://dashboard.pappas.com/api" },
    member: { type: [String, Number], default: null },
    unsub: { type: [String, Number], default: null },
    buttonClass: { type: [String, Array, Object], default: () => [] },
    useEnhancedSelect: { type: Boolean, default: !1 }
  },
  setup(t) {
    const e = {
      join: vf,
      profile: _f,
      unsubscribe: Cf
    }, n = t, s = Ae(() => n.unsub ? "unsubscribe" : n.member ? "profile" : "join");
    return We("buttonClass", n.buttonClass), We("concept", n.concept), We("apiBase", ga(n.apiBase) + "/concepts/" + n.concept + "/eclub"), We("useEnhancedSelect", n.useEnhancedSelect), (r, i) => t.concept ? (S(), we(jt(e[s.value]), {
      key: 1,
      member: t.member
    }, {
      join: Ee(() => [
        W(r.$slots, "join")
      ]),
      thankyou: Ee(() => [
        W(r.$slots, "thankyou")
      ]),
      update: Ee(() => [
        W(r.$slots, "update")
      ]),
      unsubscribed: Ee(() => [
        W(r.$slots, "unsubscribed")
      ]),
      _: 3
    }, 8, ["member"])) : (S(), we(Mf, { key: 0 }));
  }
}, Lf = {
  install: (t, e = {}) => {
    const n = Wo(), s = n || ia();
    s.use(ya), n || t.use(s), t.provide("eclubPluginOptions", e), t.component("pappas-eclub", Rf);
  }
};
export {
  Lf as default
};
//# sourceMappingURL=pappas-eclub.es.js.map
